import { adminFaz8En } from './admin.faz8.en';
/** Admin panel UI strings (English). */
export const adminEn = {
  ...adminFaz8En,
  nav: {
    overview: 'Overview',
    business: 'Business',
    team: 'Team',
    connections: 'Connections',
    records: 'Records',
    dashboard: 'Dashboard',
    setup: 'Setup Wizard',
    organization: 'Business Details',
    brands: 'Brands',
    stores: 'Stores',
    users: 'Users',
    roles: 'Roles',
    apiKeys: 'API Keys',
    webhooks: 'Webhooks',
    integrations: 'Integrations',
    audit: 'Audit Log',
    system: 'System Status',
    migration: 'Migration package',
    privacy: 'Data subject requests',
    retention: 'Retention and destruction',
    ledger: 'Dealer accounts',
    quotes: 'Quotes',
    salesRegions: 'Sales regions',
    commissions: 'Rep commissions',
    dealerReports: 'Dealer reports',
    internationalReport: 'Sales by country',
    subscriptions: 'Repeat orders',
    bizimhesap: 'BizimHesap',
    exports: 'Exports',
    seo: 'SEO center',
    attribution: 'Campaigns and sources',
    tracking: 'Measurement',
    google: 'Google connections',
    webVitals: 'Page speed',
    keywords: 'Keywords',
    siteSearch: 'Site search',
    attributes: 'Product attributes',
    collections: 'Collections',
    searchConsole: 'Search performance',
    merchant: 'Google Shopping',
    helpEditor: 'Help Texts',
    uiTranslations: 'Translations',
    account: 'My Account',
    menu: 'Menu',
    skipToContent: 'Skip to content',
    stagingBanner: 'Staging (test) server: e-mails go only to allow-listed addresses.',
    stagingBannerLink: 'Allow list',
    organizationSwitch: 'Business',
    sales: 'Sales',
    catalog: 'Catalog',
    orders: 'Orders',
    customers: 'Customers',
    dealers: 'Dealers',
    applications: 'Dealer applications',
    products: 'Products',
    categories: 'Categories',
    stock: 'Stock',
    pricing: 'Pricing',
    fx: 'Exchange rates',
    discounts: 'Coupons',
    promotions: 'Automatic promotions',
    giftCards: 'Gift cards',
    loyalty: 'Loyalty program',
    referrals: 'Referral program',
    affiliates: 'Affiliates',
    imports: 'Import / export',
    payments: 'Payments',
    invoices: 'Invoices',
    paymentSettings: 'Payment settings',
    shipping: 'Shipping',
    legal: 'Legal texts',
    redirects: 'Redirects',
    brokenLinks: 'Broken links',
    storefrontGroup: 'Storefront',
    marketing: 'Marketing',
    marketingAudience: 'Subscribers and consent',
    segments: 'Segments',
    emailTemplates: 'Email templates',
    campaigns: 'Email campaigns',
    automations: 'Automations',
    productAlerts: 'Stock and price alerts',
    smsWhatsapp: 'SMS and WhatsApp',
    smsTemplates: 'SMS templates',
    push: 'Push notifications',
    design: 'Design',
    menus: 'Menus',
    pageDesigns: 'Page designs',
    salesPoints: 'Store listings',
    googleAdsCampaigns: 'Google Ads campaigns',
    needsFinder: 'Needs finder',
    pages: 'Pages',
    banners: 'Banners',
    blog: 'Blog',
    contentCalendar: 'Content calendar',
    contentReport: 'Content report',
    forms: 'Forms',
    contactMessages: 'Contact messages',
    supportTickets: 'Support requests',
    ads: 'Ad center',
    googleReports: 'Google reports',
    liveChat: 'Live chat',
    questions: 'Product questions',
    reviews: 'Product reviews',
  },
  help: {
    whatItDoes: 'What it does',
    whenToUse: 'When to use',
    dataChanged: 'What it changes',
    requiredPermission: 'Required permission',
    reversible: 'Can it be undone?',
    commonErrors: 'Common problems and fixes',
    guide: 'Detailed guide',
    open: 'Explanation: {{title}}',
  },
  auth: {
    brand: 'Zootopia Panel',
    tagline: 'Manage your store, team and connections in one place.',
    signInTitle: 'Sign in to the panel',
    signIn: 'Sign in',
    forgot: 'Forgot password',
    mfaTitle: 'Verification code',
    mfaLead: 'Enter the 6-digit code shown in the authenticator app on your phone.',
    code: '6-digit code',
    verify: 'Verify',
    useBackup: 'Use a backup code',
    backupCode: 'Backup code',
    useCode: 'Verify with app code',
    enrollTitle: 'Set up two-step verification',
    enrollLead:
      'Every user secures the panel with an authenticator app (Google Authenticator, Microsoft Authenticator, etc.). Tap "add account" in the app and scan this QR code.',
    manualKey: 'Cannot scan? Enter this key in the app manually:',
    confirmEnroll: 'Finish setup',
    backupTitle: 'Save your backup codes',
    backupLead:
      'If you cannot reach your phone, sign in with one of these codes. Each code works once and they will not be shown again.',
    backupDone: 'I saved the codes, continue',
    copyCodes: 'Copy codes',
    printCodes: 'Print',
    forgotTitle: 'Reset password',
    forgotLead: 'Enter your account email. If it is registered, we will send a link valid for 1 hour.',
    sendLink: 'Send link',
    forgotSent: 'If the address is registered, an email was sent. Check your inbox and spam folder.',
    forgotUnavailable:
      'Password reset emails cannot be sent because the email service is not set up yet. Ask your business administrator; the server administrator can generate a reset link for you.',
    backToSignIn: 'Back to sign in',
    resetTitle: 'Choose a new password',
    newPassword: 'New password',
    setPassword: 'Save password',
    resetDone: 'Your password was changed. You can sign in with the new password.',
    passwordHint: 'At least 12 characters. A long sentence you remember easily is a good choice.',
    inviteTitle: '{{organization}} invited you',
    inviteLead:
      'Invitation for {{email}}. Set your name and password; then you will set up two-step verification.',
    inviteExistingLead: 'You already have an account for {{email}}. Enter your current password to accept.',
    yourName: 'Full name',
    acceptInvite: 'Accept invitation',
    stepUpTitle: 'Confirm it is you',
    stepUpLead: 'This action is sensitive. Enter the code from your authenticator app again.',
    stepUpSubmit: 'Verify and continue',
  },
  dashboard: {
    greeting: 'Hello {{name}}',
    setupHeading: 'Setup',
    setupProgress: '{{done}} of the {{total}} steps available in this phase are complete.',
    continueSetup: 'Continue setup',
    healthHeading: 'System',
    attentionHeading: 'Needs attention',
    salesHeading: 'Sales and orders',
    nothingToDo: 'Nothing needs your attention right now.',
    salesPending:
      'Sales and order charts come with the reports module (phase 8). For now use the Orders, Payments and Stock screens; no estimated numbers are shown without real data.',
    alertReturns: '{{count}} return/withdrawal requests are waiting for a reply.',
    alertPrivacy: '{{count}} data subject requests are waiting for a reply (legal deadline 30 days).',
    alertPrivacyOverdue: '{{count}} data subject requests are past the 30-day deadline.',
    alertLowStock: '{{count}} products are low on stock (Stock → Low stock).',
    alertPaymentReview: '{{count}} payments need review (the order is not considered paid).',
    alertBalanceReview:
      '{{count}} dealer card payments need review (not posted to the dealer account; Dealer accounts → dealer → Card balance payments).',
    alertIntegration: '{{name}} connection is failing.',
    alertTls: '{{host}} SSL certificate expires in {{days}} days.',
    alertTlsError: 'SSL certificate for {{host}} could not be read.',
    alertMail: 'Email service is not set up: invitations and password resets cannot be sent.',
    alertBackup: 'No backup recorded yet. Nightly backups start after server setup.',
    alertBackupFailed: 'The last backup failed. Details: System status.',
    alertBackupStale:
      'The last successful backup is older than 26 hours. The backup service may not be running.',
    alertRestoreFailed:
      'The last restore test failed: backups may not be restorable. Details: System status.',
    alertRedis: 'Queue server unreachable; emails cannot be sent.',
  },
  setup: { go: 'Open', skip: 'Skip', unskip: 'Undo' },
  organization: {
    systemName: 'Panel name (system name)',
    systemNameHint:
      'The name shown at the top of the admin panel and in the browser tab. Leave empty for "Zootopia Panel".',
    legalSection: 'Legal details',
    legalLead: 'Seller information on the site, invoices and the POS application use these details.',
    contactSection: 'Contact',
    defaultsSection: 'Defaults',
    name: 'Display name',
    legalName: 'Legal name',
    taxOffice: 'Tax office',
    taxNumber: 'Tax no / national ID',
    mersis: 'MERSIS no',
    kep: 'KEP address',
    etbis: 'ETBİS verification link',
    etbisHint:
      'The address opened by the QR code you receive after ETBİS registration. Shown in the storefront footer with the QR code.',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    defaultLocale: 'Default language',
    defaultCurrency: 'Default currency',
  },
  brands: {
    add: 'Add brand',
    createTitle: 'New brand',
    editTitle: 'Edit brand',
    name: 'Brand name',
    slug: 'Short name',
    description: 'Description',
    color: 'Primary color',
    logo: 'Logo',
    uploadLogo: 'Upload logo',
    replaceLogo: 'Replace logo',
    noLogo: 'No logo',
    archive: 'Archive',
    activate: 'Activate',
    active: 'Active',
    archived: 'Archived',
    emptyTitle: 'No brands yet',
    emptyLead: 'Add the brands you sell, such as Zootopia Global and VITATOPIA.',
    logoUploaded: 'Logo uploaded',
  },
  stores: {
    customerAuth: {
      title: 'Customer sign-in',
      lead: '"Continue with Google" on sign-in, registration and checkout. Off by default; do not turn on before the privacy notice and the foreign-transfer inventory are updated with legal approval.',
      clientReady: 'Sign-in with Google client is set up',
      clientMissing: 'Setup required: no sign-in with Google client',
      configure: 'Set up in Integrations',
      google: 'Sign in with Google',
      on: 'On',
      off: 'Off',
      enable: 'Turn on sign-in with Google',
      disable: 'Turn off sign-in with Google',
      enableConfirm:
        'Customers will be able to sign in and register with their Google account in this store. Continue if the privacy notice and the foreign-transfer inventory were updated with legal approval.',
      disableConfirm:
        'Sign-in with Google will be turned off. Accounts created with Google can keep signing in with email and password (with "Forgot password" if they have none).',
      ownerOnly: 'Only the business owner can turn this on.',
      redirects: 'Redirect URIs to enter in the OAuth client in Google Cloud',
      noDomains: 'The store has no storefront domain.',
    },
    add: 'Add store',
    createTitle: 'New store',
    name: 'Store name',
    code: 'Code',
    channel: 'Channel type',
    channelB2C: 'B2C — consumers',
    channelB2B: 'B2B — dealers',
    channelHYBRID: 'Hybrid — consumers and dealers',
    status_draft: 'Preview',
    status_live: 'Live',
    status_maintenance: 'Maintenance',
    status_archived: 'Archived',
    deleteTitle: 'Delete store',
    deleteLead:
      'For a store opened by mistake or not used. Only a store in preview or archive with no orders can be deleted; archive a store that has orders.',
    delete: 'Delete store',
    deleted: 'Store deleted',
    deleteBlocked_store_not_draft:
      'A live or maintenance store cannot be deleted; return it to preview or archive it first.',
    deleteBlocked_store_has_orders:
      'This store has orders and cannot be deleted. Archive it if you will not use it.',
    deleteDialogTitle: 'Delete "{{name}}"?',
    deleteDialogLead: 'This cannot be undone. These are deleted with the store:',
    deleteCodeLabel: 'Type the store code to confirm: {{code}}',
    deleteCount_domains: '{{count}} domains',
    deleteCount_markets: '{{count}} markets',
    deleteCount_priceLists: '{{count}} price lists (with prices)',
    deleteCount_listings: '{{count}} product listings (products are kept)',
    deleteCount_pages: '{{count}} pages',
    deleteCount_banners: '{{count}} banners',
    deleteCount_menus: '{{count}} menus',
    deleteCount_redirects: '{{count}} redirects',
    deleteCount_shippingMethods: '{{count}} shipping methods',
    brands: 'Brands sold',
    domains: 'Domains',
    addDomain: 'Add domain',
    hostname: 'Domain',
    purpose: 'Use',
    purpose_storefront: 'Storefront',
    purpose_admin: 'Panel',
    purpose_api: 'API',
    primary: 'Primary',
    markets: 'Markets',
    addMarket: 'Add market',
    makeDefault: 'Make default',
    makeDefaultConfirm:
      'Make "{{name}}" the default market? The storefront opens in its language and currency ({{currency}}); products without a price in that currency cannot be sold.',
    defaultMarketSaved: 'Default market changed.',
    taxMode: 'Tax mode',
    taxModeOf: '{{name}} tax mode',
    taxModeSaved: 'Tax mode saved.',
    taxModes: {
      domestic: 'Domestic VAT',
      export_exempt: 'Export (VAT exempt)',
      destination: 'Destination country VAT',
    },
    returnPolicy: {
      title: 'Return policy (for search engines)',
      lead: 'Return information shown in Google product results. It must match the withdrawal and return terms in your legal texts.',
      enabled: 'Report to search engines',
      days: 'Return window (days)',
      method: 'Return method',
      methods: { by_mail: 'By mail', in_store: 'In store', by_mail_or_in_store: 'By mail or in store' },
      fees: 'Return shipping fee',
      feeOptions: { customer_pays: 'Customer pays', free: 'Free (we pay)' },
      save: 'Save return policy',
      saved: 'Return policy saved.',
    },
    marketName: 'Market name',
    country: 'Country',
    language: 'Language',
    currency: 'Currency',
    default: 'Default',
    emptyTitle: 'No stores yet',
    emptyLead: 'Start by creating a store for zootopia.com.tr.',
    dnsNote:
      'After adding the domain, its A record must point to your server IP in your domain registrar panel.',
    noDomains: 'No domains yet.',
    noMarkets: 'No markets yet. Prices and taxes work per market, so add at least one.',
    tls: 'SSL',
    remove: 'Remove',
    open: 'Details',
    back: 'Back to stores',
  },
  users: {
    invite: 'Invite user',
    inviteTitle: 'Invite user',
    inviteSent: 'Invitation email sent',
    manualTitle: 'Share the invitation link',
    manualLead:
      'No email was sent to {{email}} because the email service is not set up. Share this link with them through a secure channel; it is valid for 7 days and works once.',
    copyLink: 'Copy link',
    role: 'Role',
    storeScope: 'Store restriction',
    dealerScope: 'Dealer scope',
    dealerScopeOf: '{{name}} — dealer scope',
    dealerScopes: { all: 'All dealers', assigned: 'Assigned dealers only' },
    allStores: 'All stores',
    active: 'Active',
    suspended: 'Suspended',
    lastLogin: 'Last sign-in',
    members: 'Members',
    pending: 'Pending invitations',
    expires: 'Valid until',
    revoke: 'Revoke invitation',
    suspend: 'Suspend',
    activate: 'Activate',
    remove: 'Remove member',
    changeRole: 'Change role',
    you: 'you',
    confirmRemove: 'Remove {{name}}? Their past actions stay in the audit log.',
    noPending: 'No pending invitations.',
  },
  roles: {
    system: 'Built-in roles',
    custom: 'Custom roles',
    createCustom: 'Create custom role',
    createTitle: 'Custom role',
    basedOn: 'Start from role',
    basedOnNone: 'Start empty',
    permissions: 'Permissions',
    permissionCount: '{{count}} permissions',
    sensitive: 'Sensitive',
    phaseNote: 'Phase {{phase}}',
    emptyCustom: 'No custom roles yet. Create one if no built-in role fits.',
    name: 'Role name',
    description: 'Description',
    delete: 'Delete role',
    showPermissions: 'Show permissions',
  },
  apiKeys: {
    create: 'Create API key',
    name: 'Key name',
    namePlaceholder: 'e.g. Accounting software',
    scopes: 'Scopes',
    prefix: 'Prefix',
    expiresAt: 'Expires',
    noExpiry: 'No expiry',
    revoked: 'Revoked',
    expired: 'Expired',
    revoke: 'Revoke',
    secretTitle: 'Your key is ready',
    secretLead: 'Copy this key into the external program now. It will not be shown again.',
    usage: 'Usage example',
    emptyTitle: 'No API keys yet',
    emptyLead: 'Create a key to connect accounting, ERP or n8n.',
    confirmRevoke: 'Programs using this key lose access immediately. Revoke it?',
    docs: 'API documentation',
  },
  webhooks: {
    add: 'Add webhook',
    url: 'URL',
    description: 'Description',
    events: 'Events',
    allEvents: 'All events',
    active: 'Active',
    disabled: 'Disabled',
    test: 'Send test event',
    testSent: 'Test event queued. See the result in delivery history.',
    deliveries: 'Delivery history',
    rotate: 'Rotate secret',
    secretTitle: 'Signing secret',
    secretLead:
      'Save this secret so the receiving program can verify requests come from us. It will not be shown again.',
    signatureHelp:
      'Each request carries an X-Zootopia-Signature header: t=<time>,v1=<HMAC-SHA256(secret, time + "." + body)>.',
    redeliver: 'Redeliver',
    attempt: 'Attempt',
    response: 'Response',
    delivery_pending: 'Pending',
    delivery_succeeded: 'Succeeded',
    delivery_failed: 'Failed',
    delivery_dead: 'Gave up',
    emptyTitle: 'No webhooks yet',
    emptyLead: 'Add a URL if a program should hear about store events instantly.',
    emptyDeliveries: 'No deliveries yet.',
    delete: 'Delete',
    confirmDelete: 'Stop notifications to this URL and delete it?',
    confirmRotate:
      'A new signing secret will be generated and the old one stops working immediately. Update the receiving program too. Continue?',
    disable: 'Disable',
    enable: 'Enable',
  },
  integrations: {
    pendingMerged: 'Use the iyzico connection for card payments',
    pendingDecision: 'Setup required: the decision and account are up to the owner',
    log_health_check: 'Connection check',
    health: {
      title: 'Connection check',
      lead: 'Saved connections are checked automatically every 6 hours, using only tests that send no messages and cost nothing. Two failures in a row raise a System Status alert and email the alert recipients. The check does not change the connection status.',
      verify: 'Verify all connections',
      summary: '{{time}}: {{ok}} working, {{failed}} not working, {{skipped}} to be tested one by one.',
      tableCaption: 'Connection check results',
      colService: 'Service',
      colResult: 'Result',
      colDetail: 'Details',
      outcome_ok: 'Working',
      outcome_failed: 'Not working',
      outcome_skipped: 'Test individually',
      lastOk: 'Last check {{time}}: working',
      lastFailed: 'Last check {{time}}: not working — try "Test connection"',
    },
    carrierViaGeliver:
      'A direct connection needs a corporate integration contract and IP approval from the carrier; for now you can ship with this carrier through Geliver.',
    bizimhesapSettings: 'Account and cash settings',
    adapterPending: 'Not connected yet (setup required): waiting for provider integration details',
    configure: 'Configure',
    manageOnGoogle: 'On the Google connections screen',
    manageOnTracking: 'On the Measurement screen',
    test: 'Test connection',
    testOk: 'Connection succeeded',
    testFail: 'Connection failed',
    disconnect: 'Disconnect',
    save: 'Save details',
    saved: 'Details saved encrypted. Now test the connection.',
    environment: 'Environment',
    env_sandbox: 'Sandbox (test)',
    env_live: 'Live',
    lastTested: 'Last tested',
    notAvailable: 'This integration arrives in phase {{phase}}. Details cannot be entered yet.',
    docs: 'Official docs',
    logs: 'Connection log',
    emptyLogs: 'No records yet.',
    log_test_connection: 'Connection test',
    log_mail_send: 'E-mail',
    log_mail_feedback: 'Bounce / complaint notification',
    logOutcome_success: 'Succeeded',
    logOutcome_failure: 'Failed',
    logOutcome_blocked: 'Blocked on staging',
    reenterSecrets: 'Saved passwords are never shown. Re-enter all fields to change them.',
    confirmDisconnect: 'Saved details will be deleted and this service will stop working. Continue?',
    paymentNote:
      '"Sandbox" / "Live" here is only the result of the key connection test; whether card payment on the storefront is off, test or live is shown in Payment settings:',
  },
  audit: {
    when: 'Time',
    actor: 'By',
    action: 'Action',
    entity: 'Record',
    filterEntity: 'Record type',
    allEntities: 'All',
    apply: 'Filter',
    clear: 'Clear',
    loadMore: 'Show more',
    before: 'Before',
    after: 'After',
    actor_system: 'System',
    actor_customer: 'Customer',
    actor_api_key: 'API key',
    actor_user: 'User',
    empty: 'No records match this filter.',
    details: 'Details',
    code: 'Action code',
    recordId: 'Record ID',
  },
  system: {
    refresh: 'Refresh',
    checkedAt: 'Measured at {{time}}',
    database: 'Database',
    services: 'Services',
    runStatus: { running: 'running', succeeded: 'succeeded', failed: 'failed' },
    redis: 'Queue server',
    queues: 'Queues',
    queueName_mail: 'Email',
    waiting: 'Waiting',
    activeJobs: 'Running',
    failed: 'Failed',
    delayed: 'Delayed',
    mail: 'Email delivery',
    mail_organization_smtp: 'Business SMTP connection',
    mail_platform_smtp: 'Platform SMTP',
    mail_not_configured: 'Not set up',
    backup: 'Last backup',
    restoreTest: 'Last restore test',
    offsite: 'Off-site backup copy',
    offsiteSetup: 'Setup required',
    offsitePending: 'Connected; first upload after the next nightly backup',
    offsiteKeep: 'Kept for {{days}} days in storage',
    none: 'None yet',
    domains: 'Domains and SSL',
    ok: 'Working',
    error: 'Error',
    daysLeft: '{{days}} days left',
    noQueues: 'Queue information unavailable.',
    media: 'File storage (images and documents)',
    media_ok: 'Writable',
    media_storage_permission_denied: 'No write permission',
    media_storage_disk_full: 'Disk full',
    media_storage_read_only: 'Read-only',
    media_storage_write_failed: 'Not writable',
    failedJobs: 'Failed background jobs',
    environment: 'Environment',
    env_staging: 'Staging (test server)',
    env_production: 'Production',
    env_development: 'Development',
    mailGuardTitle: 'Staging e-mail protection',
    mailGuardLead:
      'To keep real customers and dealers from receiving e-mail from the test server, e-mail is sent only to allow-listed addresses. Others are not sent and appear as "Blocked on staging" in Integrations → SMTP e-mail → Connection log. Production has no such restriction.',
    mailGuardServer: 'Set on the server (MAIL_ALLOWLIST): {{count}} entries',
    mailGuardList: 'Addresses allowed from the panel',
    mailGuardListHint: 'One address (name@example.com) or domain (@example.com) per line; up to 20.',
    mailGuardEmpty: 'The allow list is empty: the staging server sends no e-mail.',
    mailGuardPlaceholder: 'name@example.com\n@example.com',
    mailGuardSave: 'Save allow list',
    mailGuardSaved: 'Allow list saved.',
    alertsTitle: 'Critical alerts',
    alertsLead:
      'Backups, restore test, disk, job queues, SSL certificates, payment notifications and storefront/panel reachability are checked every 5 minutes. Email is sent when a problem starts, every 24 hours while it continues and when it is resolved (at most 10 per hour).',
    alertsNone: 'No ongoing problems.',
    alertsResolved: '{{count}} alerts resolved in the last 7 days',
    alertSince: 'since {{time}}',
    alertLastMail: 'last email: {{time}}',
    alertNotMailed: 'email not sent (hourly limit or no recipient)',
    alertResolvedAt: 'resolved: {{time}}',
    severity_critical: 'Urgent',
    severity_warning: 'Warning',
    cspTitle: 'Storefront content security violations',
    cspLead:
      "When the storefront's content security policy (CSP) blocks a script, image, frame or connection that is not allowed, the visitor's browser reports it. A newly added tag, video or payment frame being blocked, or an attempt to inject code into the page, shows up here. No personal data and no reports from browser extensions are kept; entries not seen for {{days}} days are deleted.",
    cspNone: 'No violations reported in the last {{days}} days.',
    cspSummary:
      '{{rows}} distinct violations, {{hits}} reports in total · seen in the last 24 hours: {{lastDay}}',
    cspDirective: 'Rule',
    cspBlocked: 'Blocked resource',
    cspPage: 'Page',
    cspHits: 'Count',
    cspLastSeen: 'Last seen',
    cspReportOnly: 'report only',
    cspSource: 'Source: {{file}} (line {{line}})',
    cspKeyword_inline: 'Inline code (script or event handler embedded in the page)',
    cspKeyword_eval: 'Dynamic code (eval)',
    'cspKeyword_wasm-eval': 'WebAssembly compilation',
    cspKeyword_data: 'data: URL',
    cspKeyword_blob: 'blob: URL',
    cspKeyword_self: "The storefront's own address",
    alertKinds: {
      login_failures:
        'Unusual failed sign-ins ({{surface}}): {{count}} attempts and {{locked}} locked accounts in the last {{minutes}} minutes',
      integration: 'Connection check failed repeatedly: {{provider}} ({{result}})',
      backup_missing: 'No database backup for 26 hours',
      backup_failed: 'Last database backup failed',
      restore_failed: 'Backup restore test failed',
      queue_backlog: 'Job queue backlog ({{queue}}: {{waiting}} waiting)',
      queue_failed: 'Failed jobs ({{queue}}: {{failed}})',
      disk_space: 'Disk {{usedPct}}% full ({{freeGb}} GB free)',
      tls: 'SSL certificate: {{host}} ({{days}} days)',
      payment_hooks: 'Payment notifications rejected ({{failures}} in the last hour)',
      uptime: '{{name}} unreachable ({{result}})',
      preauth_expiring: '{{count}} orders have pre-authorizations older than 20 days (oldest {{oldest}})',
    },
    errorTracking: 'External error tracking',
    errorTrackingLive: 'Connected',
    errorTrackingSetup: 'Setup required',
    observability: 'Observability (OpenTelemetry)',
    recipients: 'Alert recipients',
    recipientsHint:
      'One email per line (max 10). If empty, owners are notified. If ALERT_EMAILS is set on the server, platform alerts go there.',
    recipientsSave: 'Save recipients',
    recipientsSaved: 'Alert recipients saved.',
    mailDnsTitle: 'Email domain (SPF, DKIM, DMARC)',
    mailDnsLead:
      'These records are in your domain DNS. If missing, order and password emails may go to spam or be rejected.',
    mailDnsNone: 'No domain to check: appears once an SMTP connection or storefront domain is set.',
    mailDnsDomain: '{{domain}} ({{source}}) · checked: {{time}}',
    mailDnsSource_smtp: 'SMTP sender address',
    mailDnsSource_provider: 'email provider sender address',
    mailDnsSource_storefront: 'storefront domain',
    mailDnsSource_query: 'entered manually',
    dns: {
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      spf_ok: 'Present',
      spf_missing: 'Missing — add the SPF record from your email provider',
      spf_multiple: 'Multiple SPF records — merge into one (otherwise invalid)',
      spf_unknown: 'DNS could not be read; try again later',
      dkim_ok: 'Present',
      dkim_not_found: 'Not found — enter the selector below if you know it',
      dkim_unknown: 'DNS could not be read; try again later',
      dmarc_ok: 'Present (protection on)',
      dmarc_monitoring: 'Present, monitoring only (p=none)',
      dmarc_missing: 'Missing — add at least "v=DMARC1; p=none"',
      dmarc_unknown: 'DNS could not be read; try again later',
    },
    dkimSelector: 'DKIM selector',
    dkimSelectorHint: 'The name in your provider\'s DKIM record (e.g. "default"); leave empty if unknown.',
    dkimSelectorSave: 'Save selector and check',
    mailGuardTooMany: 'Up to 20 entries.',
  },
  account: {
    profile: 'Profile',
    phone: 'Phone',
    language: 'Panel language',
    uiMode: 'Usage mode',
    beginner: 'Beginner — explanations open by default',
    advanced: 'Advanced — clean screen',
    password: 'Password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    changePassword: 'Change password',
    passwordChanged: 'Password changed; sessions on other devices were signed out.',
    sessions: 'Open sessions',
    thisDevice: 'This device',
    revoke: 'Sign out session',
    organizations: 'My businesses',
    switchTo: 'Switch to this business',
    current: 'Current',
    mobile: 'Mobile app',
    browser: 'Browser',
  },
  privacy: {
    create: 'Record request',
    createLead:
      'Record a request received by email, registered email (KEP), post or in person. The reply deadline is 30 days from when it reached the business.',
    created: 'Request recorded',
    save: 'Save',
    state: 'Show',
    states: { open: 'Open requests', closed: 'Resolved' },
    emptyOpen: 'No open requests',
    emptyClosed: 'No resolved requests',
    emptyLead:
      'Customers can apply from My account → My personal data on the storefront; record emailed requests with "Record request".',
    overdue: 'Overdue',
    daysLeft: '{{count}} days left',
    requesterName: 'Requester name',
    requesterEmail: "Requester's email",
    kind: 'Request type',
    channel: 'Received via',
    receivedAt: 'Request date',
    dueAt: 'Reply deadline',
    store: 'Store (name shown in emails)',
    details: 'Request text / summary',
    statusLabel: 'Status',
    customer: 'Customer account',
    noCustomer: 'No account with this email (guest orders match by email)',
    resolution: 'Outcome',
    exportedAt: 'Data last downloaded',
    recordsTitle: 'Records in the system',
    records:
      '{{orders}} orders, {{addresses}} addresses, {{favorites}} favorites, {{questions}} product questions, {{companies}} dealer company memberships, {{invoices}} invoices, {{acceptances}} contract/notice acceptances, {{messages}} contact messages, {{tickets}} support tickets, {{chats}} live chats, {{newsletter}} newsletter subscriptions, {{campaigns}} campaign emails, {{automations}} automation emails, {{stockAlerts}} back-in-stock requests, {{smsMessages}} SMS/WhatsApp campaign messages; {{loyaltyPoints}} loyalty points (forfeited on erasure).',
    export: 'Download a copy of the data',
    exported: 'Data downloaded',
    erasureTitle: 'Anonymization preview',
    erasureDeletes:
      'Deleted / anonymized: account (name, email, phone, password; sign-in closed), address book, sessions, carts, favorites, dealer company membership; on orders the email, phone, shipping address (city/district kept) and customer note; author name on product questions. Granted message consents are recorded as revoked.',
    erasureKeeps:
      'Kept (legal obligation): order totals and lines, billing address and invoices, payment records, contract and pre-information acceptance records, consent history, audit log and the record of this request.',
    note: 'Reply to requester',
    noteErasure: 'Reply to requester (optional; a default text is sent on anonymization)',
    noteHint:
      'Emailed to the requester when resolved or rejected (if email is set up). A reason is required to reject.',
    startReview: 'Start review',
    complete: 'Resolve',
    reject: 'Reject',
    anonymize: 'Anonymize',
    confirmEmail: "Type the requester's email to confirm: {{email}}",
    anonymizeConfirm: 'Anonymize permanently',
    anonymized: 'Personal data anonymized',
    kinds: {
      export: 'Copy of data',
      erasure: 'Erasure (anonymization)',
      info: 'Information request',
      rectification: 'Rectification',
      objection: 'Objection',
      other: 'Other',
    },
    channels: {
      storefront: 'Storefront (My account)',
      email: 'Email',
      kep: 'Registered email (KEP)',
      post: 'Post',
      in_person: 'In person',
      other: 'Other',
    },
    statuses: {
      received: 'Received',
      in_progress: 'In review',
      completed: 'Resolved',
      rejected: 'Rejected',
    },
  },
  exports: {
    settingsTitle: 'Period and file',
    settingsLead: 'These choices apply to every list below.',
    period: 'Period',
    periods: {
      this_month: 'This month',
      last_month: 'Last month',
      last_30: 'Last 30 days',
      this_year: 'This year',
      last_year: 'Last year',
      custom: 'Choose dates',
      all: 'All time',
    },
    from: 'From',
    to: 'To',
    range: '{{from}} – {{to}} (Turkey time, end day included)',
    rangeAll: 'All records',
    store: 'Store',
    allStores: 'All stores',
    format: 'File format',
    formats: { xlsx: 'Excel (XLSX)', csv: 'CSV (semicolon)' },
    personalData: 'Personal data',
    personalDataHint: 'Unmasked files require two-step verification and are flagged in the audit log.',
    personalDataModes: { masked: 'Masked (recommended)', full: 'Unmasked (full details)' },
    listsTitle: 'Lists',
    listsLead: 'Every download is written to the audit log. A file holds at most 50,000 rows.',
    noAccess: 'There is no list you can export. Ask your administrator for the matching view permission.',
    downloaded: '{{name}} downloaded.',
    stockNote: 'Current stock; the period does not apply.',
    customersNote: 'The period applies to the registration date.',
    kinds: {
      orders: {
        title: 'Orders',
        lead: 'One row per order with totals, VAT and billing details.',
        action: 'Download orders',
      },
      order_lines: {
        title: 'Order lines',
        lead: 'One row per item with VAT rate and lots.',
        action: 'Download order lines',
      },
      customers: {
        title: 'Customers',
        lead: 'With type, consents and order count.',
        action: 'Download customers',
      },
      stock: { title: 'Stock', lead: 'By warehouse and lot, with expiry dates.', action: 'Download stock' },
      invoices: {
        title: 'Invoices',
        lead: 'Invoice no, type, net amount, VAT and total.',
        action: 'Download invoices',
      },
      payments: {
        title: 'Payments and refunds',
        lead: 'Collections and refunds; refunds as negative amounts.',
        action: 'Download payments',
      },
    },
  },
  seo: {
    indexingTitle: 'Indexing',
    indexingLead: 'Whether search engines can see the store.',
    indexOpen: 'Open to search engines',
    indexClosed: 'Closed to search engines',
    closedStore: 'The store is not live (preview). It opens when the store goes live.',
    closedServer: 'The store is live but indexing (SITE_INDEXING) is off on the server.',
    checked: 'Checked: {{products}} products, {{categories}} categories, {{pages}} pages, {{posts}} posts.',
    issuesTitle: 'SEO issues',
    issuesLead: 'Gaps in published storefront content. The edit link opens the right screen.',
    filter: 'Issue type',
    filterAll: 'All ({{count}} items)',
    noIssues: 'No issues for this filter',
    noIssuesLead: 'No gaps of this type were found in published content.',
    colKind: 'Type',
    colTitle: 'Title',
    colIssues: 'Issues',
    editItem: 'Edit {{title}}',
    more: 'Showing the first {{shown}} items ({{total}} in total).',
    kinds: { product: 'Product', category: 'Category', page: 'Page', post: 'Blog post' },
    issueNames: {
      title_long: 'Title too long',
      title_duplicate: 'Duplicate title',
      description_missing: 'No description',
      description_long: 'Description too long',
      description_short: 'Description too short',
      image_missing: 'No image',
      image_alt_missing: 'Missing alt text',
      image_too_small: 'Main image small',
      image_low_resolution: 'Main image low resolution',
      gtin_invalid: 'Invalid barcode (GTIN)',
      content_thin: 'Thin content',
    },
    crawl: {
      title: 'Site crawler',
      lead: 'Crawls your storefront like a visitor and finds technical issues (your own domain only).',
      start: 'Start crawl',
      started: 'Crawl queued.',
      none: 'No crawl yet.',
      clean: 'No issues found in the latest crawl.',
      result: '{{pages}} pages, {{issues}} issues',
      truncated: 'Page limit reached',
      failed: 'Failed: {{reason}}',
      failReasons: {
        no_domain: 'The store has no storefront domain',
        site_protected: 'The storefront is password protected (staging); the crawler cannot read pages',
        home_unreachable: 'The home page could not be reached',
        https_required: 'The storefront address is not https',
        private_address: 'The domain resolves to an internal network address',
        unknown: 'Unexpected error',
      },
      showingPrevious: 'Results below are from the latest completed crawl ({{time}}).',
      filter: 'Issue type',
      filterAll: 'All ({{count}})',
      tableLabel: 'Crawl issues',
      colSeverity: 'Severity',
      colType: 'Issue',
      colPath: 'Address',
      colDetail: 'Details',
      status: { queued: 'Queued', running: 'Running', completed: 'Completed', failed: 'Failed' },
      trigger: { manual: 'manual', scheduled: 'weekly' },
      severity: { error: 'Error', warning: 'Warning', info: 'Info' },
      detailStatus: 'status {{status}}',
      detailFrom: 'linked from: {{list}}',
      detailCanonical: 'canonical: {{url}}',
      detailCount: '{{count}} items',
      detailAlso: 'same as: {{list}}',
      types: {
        fetch_failed: 'Page unreachable',
        server_error: 'Server error',
        broken_link: 'Broken link',
        sitemap_url_not_ok: 'Sitemap address does not open',
        redirect_chain: 'Redirect chain',
        redirected_link: 'Redirected link',
        title_missing: 'No title',
        title_duplicate: 'Duplicate title',
        description_missing: 'No description',
        description_duplicate: 'Duplicate description',
        h1_missing: 'No H1',
        h1_multiple: 'Multiple H1',
        img_alt_missing: 'Image without alt text',
        canonical_mismatch: 'Canonical mismatch',
        noindex_in_sitemap: 'Noindex page in sitemap',
        orphan_page: 'Orphan page (no links)',
      },
    },
    historyTitle: 'SEO change history',
    historyLead: 'Changes to SEO titles, descriptions and slugs (last 50).',
    historyEmpty: 'No SEO field changes yet.',
    fields: { seoTitle: 'SEO title', seoDescription: 'SEO description', slug: 'Slug (address)' },
  },
  merchant: {
    previewTitle: 'Pre-feed check',
    previewLead:
      'Products published in the store and visible to retail customers are checked; problem products are never sent to Google.',
    counts: { items: 'Offers to send', inStock: 'In stock', excluded: 'Products not sent' },
    excludedTitle: 'Products not sent',
    warningsTitle: 'Warnings (sent)',
    colProduct: 'Product',
    colReason: 'Reason',
    reasons: {
      excluded_by_user: 'Turned off on the product screen',
      health_not_approved: 'No veterinary approval or content changed',
      health_claim: 'Disease/treatment claim in the text',
      image_missing: 'No image',
      image_too_small: 'Images too small for Google (at least {{min}}×{{min}} px required)',
      image_too_large: 'Images larger than 64 megapixels',
      price_missing: 'No price',
      price_not_tax_inclusive: 'Price excludes VAT',
      translation_missing: 'No translation in the market language',
      tax_rate_missing: 'No VAT rate for the market country',
      no_variants: 'No active variant',
      country_blocked: 'Product is not for sale in this market’s country',
    },
    warnings: {
      gtin_missing: 'No barcode (GTIN)',
      description_missing: 'No description',
      google_category_missing: 'No Google product category',
      title_truncated: 'Title cut at 150 characters',
      image_main_replaced: 'First image too small for Google; the next image was sent as the main image',
      image_below_upcoming_minimum: 'Not sent after 31 January 2027: Google requires at least 500×500 px',
      image_below_recommended: 'Main image under the recommended 1500×1500 px',
      image_size_unknown: 'Main image size unknown',
    },
    imageSize: 'first image {{size}} px',
    feedTitle: 'Feed file',
    feedLead:
      'In Merchant Center add this address under "Products → Data sources → File → Scheduled fetch"; Google fetches it daily. No Google connection needed.',
    feedEnabled: 'Feed file on',
    feedSaved: 'Saved.',
    previewMarket: 'Market',
    marketsTitle: 'Markets (country and language)',
    marketsLead:
      'Each market sent to Google gets its own feed and Merchant API data source: price in that market currency and list, name and description in the market language, shipping methods of that country.',
    marketsSaved: 'Markets saved.',
    defaultMarket: 'Default',
    marketFeedUrl: '{{market}} feed address',
    marketsNote:
      'Add each market to Merchant Center as a separate data source (choosing country and language); Merchant API sync creates the sources automatically. At least one market stays selected.',
    feedUrl: 'Feed address',
    lastFetch: 'Last fetch: {{time}} ({{count}} offers)',
    neverFetched: 'Not fetched yet.',
    rotate: 'Renew address',
    rotateConfirm: 'The old address stops working immediately; update it in Merchant Center.',
    apiTitle: 'Merchant API',
    apiLead:
      'Products are sent directly with the Google connection; approval status and disapproval reasons come back here.',
    notLinked: 'No Merchant Center account chosen',
    notLinkedLead:
      'Connect with the Merchant Center permission on Google connections and choose the account for this store.',
    lastSync: 'Last sync: {{time}}',
    neverSynced: 'Not synced yet',
    status: { approved: 'Approved', pending: 'Under review', disapproved: 'Disapproved' },
    syncNow: 'Send now',
    synced: '{{inserted}} sent, {{deleted}} deleted, {{unchanged}} unchanged.',
    issuesTitle: 'Issues at Google',
    issuesLead: 'Disapproved or warned offers with Google’s explanation and documentation link.',
    perfTitle: 'Product performance',
    perfLead:
      'Impressions and clicks of your products on Google, free listings and Shopping ads. Read from Merchant Center on request.',
    perfPeriod: 'Period',
    perfLastDays: 'Last {{n}} days',
    perfTotals: 'Period totals',
    perfProduct: 'Product',
    perfOrganicClicks: 'Free clicks',
    perfOrganicImpressions: 'Free impressions',
    perfAdsClicks: 'Ad clicks',
    perfAdsImpressions: 'Ad impressions',
    perfConversions: 'Conversions (free)',
    perfEmpty: 'No impressions on Google in this period.',
    perfNote:
      'Up to yesterday. Google reports conversions only for free listings; ad spend and real order revenue are in the Ads center.',
    colOffer: 'Offer (SKU)',
    colStatus: 'Status',
    colIssue: 'Issue',
    docs: 'Google documentation',
  },
  attribution: {
    builderTitle: 'Build a campaign link',
    builderLead:
      'Adds source information (UTM) to the link you use in ads, emails, social media and QR codes. Orders are grouped by it in the report below.',
    url: 'Page address',
    fields: {
      source: 'Source (utm_source)',
      medium: 'Medium (utm_medium)',
      campaign: 'Campaign (utm_campaign)',
      term: 'Keyword (utm_term)',
      content: 'Content (utm_content)',
    },
    result: 'Campaign link',
    resultEmpty: 'Enter address, source, medium and campaign',
    copy: 'Copy',
    copied: 'Link copied.',
    builderNote:
      'Values are lower-cased and Turkish characters converted (e.g. "Ekim Bülteni" → ekim-bulteni) so a campaign is one row in the report.',
    reportTitle: 'Orders by source',
    reportLead:
      'Real orders (drafts and cancellations excluded) by the source they came from. Revenue only from paid orders; refunds shown separately.',
    period: 'Period',
    lastDays: 'Last {{n}} days',
    model: 'Touch',
    models: { last: 'Last touch', first: 'First touch' },
    dimension: 'Breakdown',
    dimensions: { source_medium: 'Source / medium', campaign: 'Campaign' },
    colSource: 'Source',
    colMedium: 'Medium',
    colCampaign: 'Campaign',
    colOrders: 'Orders',
    colPaid: 'Paid',
    colRevenue: 'Revenue (paid)',
    colRefunded: 'Refunds',
    colNet: 'Net',
    noConsent: 'Unknown (no cookie consent)',
    direct: 'Direct / unknown',
    noCampaign: 'No campaign',
    empty: 'No orders in this period.',
    reportNote:
      'Source information is recorded only if the visitor allowed analytics or marketing cookies; other orders are counted as "Unknown".',
  },
  webVitals: {
    statusTitle: 'Measurement',
    statusLead:
      'Home, one category, one product and one blog post are measured on mobile and desktop with Google PageSpeed Insights. Live stores are measured every Monday.',
    notConfigured: 'No PageSpeed Insights key',
    notConfiguredLead:
      'Create a free API key in Google Cloud, enter it under Integrations → PageSpeed Insights and test it.',
    start: 'Measure now',
    running: 'Measuring…',
    started: 'Measurement started; it may take a few minutes.',
    lastRun: 'Last measurement: {{time}}',
    neverRun: 'Not measured yet.',
    resultsTitle: 'Latest results',
    resultsLead:
      'Score: Lighthouse lab test (0–100). LCP, INP and CLS: real visitors over the last 28 days (Chrome UX Report), which Google uses in ranking.',
    colPage: 'Page',
    colDevice: 'Device',
    colScore: 'Score',
    colLcp: 'LCP',
    colInp: 'INP',
    colCls: 'CLS',
    thresholds:
      'Good: LCP ≤ 2.5 s, INP ≤ 200 ms, CLS ≤ 0.1. Poor: LCP > 4 s, INP > 500 ms, CLS > 0.25. Score: 90+ good, 50–89 needs improvement.',
    templates: { home: 'Home', category: 'Category', product: 'Product', post: 'Blog post' },
    strategies: { mobile: 'Mobile', desktop: 'Desktop' },
    ratings: { good: 'Good', needs_improvement: 'Needs improvement', poor: 'Poor' },
    change: '{{n}} vs previous',
    scopes: {
      url: 'This page',
      origin: 'Whole site (not enough data for this page)',
      none: 'Not enough visitor data',
    },
    fieldLine: 'Field data: {{scope}}',
    labLine: 'Lab: LCP {{lcp}} s, TBT {{tbt}} ms, CLS {{cls}}',
    units: { s: '{{n}} s', ms: '{{n}} ms' },
    runsTitle: 'Recent measurements',
    runStatus: { queued: 'Queued', running: 'Measuring', completed: 'Completed', failed: 'Failed' },
    triggers: { manual: 'Manual', scheduled: 'Weekly' },
    errors: {
      psi_page_failed: 'Page could not be opened (storefront may be password protected)',
      psi_key_invalid: 'API key not accepted',
      psi_quota: 'Daily quota used up',
      psi_timeout: 'Measurement timed out',
      psi_unreachable: 'Could not reach PageSpeed Insights',
      pagespeed_not_configured: 'No key',
      store_has_no_domain: 'Store has no domain',
      unknown: 'Measurement failed',
    },
  },
  attributes: {
    title: 'Product attributes',
    lead: 'Technical attributes of products (e.g. net weight, life stage, flavour). Values are entered on the product screen; visible ones appear in the "Specifications" table on the product page.',
    add: 'Add attribute',
    edit: 'Edit attribute',
    editItem: 'Edit attribute {{name}}',
    saved: 'Attribute saved',
    deleted: 'Attribute deleted',
    deleteConfirm: 'Delete "{{name}}"? Its value on {{count}} products is deleted too.',
    emptyTitle: 'No attributes yet',
    emptyLead: 'Add e.g. "Net weight" (number, kg) or "Life stage" (options: kitten, adult, senior).',
    name: 'Name',
    code: 'Short code',
    type: 'Type',
    types: {
      text: 'Text',
      number: 'Number',
      select: 'Option (single)',
      multiselect: 'Options (multiple)',
      boolean: 'Yes / no',
    },
    unit: 'Unit',
    options: 'Options',
    optionsPlaceholder: 'One option per line',
    where: 'Shown in',
    onProductPage: 'Product page',
    inFilters: 'Filters',
    internal: 'Admin only',
    productCount: 'Products',
    visible: 'Show on product page',
    filterable: 'Show in storefront filters',
    position: 'Order',
    tagsTitle: 'Tags in use',
    tagsLead:
      'Tags given to products and their product counts. Tags are entered on the product screen; they are not shown in the storefront.',
    noTags: 'No tags yet.',
  },
  collections: {
    title: 'Collections',
    lead: 'Groups of hand-picked products or products matching a rule (e.g. "Kitten products"). A rule-based collection updates itself as products change.',
    add: 'New collection',
    emptyTitle: 'No collections yet',
    emptyLead: 'Pick products by hand or write a rule on category, brand, tag, species and attributes.',
    name: 'Name',
    kind: 'Type',
    kinds: { manual: 'Hand-picked', rule: 'Rule-based' },
    kindChoice: { manual: 'I will pick products', rule: 'Products matching a rule' },
    status: 'Status',
    statuses: { active: 'Active', hidden: 'Hidden' },
    productCount: 'Products',
    saved: 'Collection saved',
    deleted: 'Collection deleted',
    deleteConfirm: 'Delete collection "{{title}}"? Products are not deleted.',
    backToList: 'Back to collections',
    basics: 'Basics',
    slug: 'Slug (address)',
    description: 'Description',
    seoTitle: 'SEO title',
    seoDescription: 'SEO description',
    productsTitle: 'Products',
    pickProducts: 'Add product',
    matchesTitle: 'Matching products: {{count}}',
    matchesLead: 'Products in the saved collection (any status; the storefront shows published ones only).',
    previewLead: 'Preview: the rule is not saved yet.',
    noMatches: 'No matching products.',
    match: 'Conditions',
    matchAll: 'All conditions must match',
    matchAny: 'Any condition is enough',
    conditions: 'Condition list',
    field: 'Field',
    fields: { category: 'Category', brand: 'Brand', tag: 'Tag', species: 'Species', attribute: 'Attribute' },
    attribute: 'Attribute',
    op: 'Comparison',
    ops: { is: 'is', is_not: 'is not', gte: 'at least', lte: 'at most' },
    value: 'Value',
    choose: 'Choose',
    addCondition: 'Add condition',
    removeCondition: 'Remove condition',
    preview: 'Show matches',
  },
  siteSearch: {
    reportTitle: 'Search report',
    reportLead:
      'Searches made in the storefront (the first view of a search page counts as one search). No personal data is kept.',
    period: 'Period',
    lastDays: 'Last {{days}} days',
    emptyTitle: 'No searches in this period',
    emptyLead: 'Searches appear here as visitors use the storefront search.',
    totalSearches: 'Total searches',
    distinctQueries: 'Distinct searches',
    zeroResultSearches: 'Searches without results',
    topTitle: 'Most searched',
    zeroTitle: 'Searches without results',
    noZero: 'No searches without results.',
    noResults: 'No results',
    colQuery: 'Search',
    colSearches: 'Count',
    colResults: 'Last results',
    synonymsTitle: 'Synonyms',
    synonymsLead:
      'Words in a group are searched for each other (e.g. food, feed). Useful for searches without results.',
    addSynonym: 'Add synonyms',
    editSynonym: 'Edit synonyms',
    editSynonymItem: 'Edit group {{terms}}',
    deleteSynonymConfirm: 'Delete group {{terms}}?',
    synonymSaved: 'Synonyms saved',
    synonymDeleted: 'Synonym group deleted',
    noSynonyms: 'No synonym groups yet.',
    terms: 'Words',
    termsPlaceholder: 'Comma-separated: food, feed',
  },
  keywords: {
    alertsTitle: 'Alerts',
    alertsLead:
      'From the last 28 days of Search Console: pages competing for the same search, and keywords with no target page.',
    noAlerts: 'No alerts.',
    none: 'None.',
    cannibalTitle: 'Cannibalization',
    gapTitle: 'Content gap',
    gapReasons: { no_target: 'No target page', target_not_found: 'Target page not live' },
    inPool: 'In pool',
    target: 'Target',
    pageStats: '{{impressions}} impressions, {{clicks}} clicks, position {{position}}',
    poolTitle: 'Keyword pool',
    poolLead: 'Searches the store targets, with the last 28 days of Search Console data.',
    add: 'Add keyword',
    edit: 'Edit keyword',
    editItem: 'Edit {{keyword}}',
    saved: 'Saved.',
    deleted: 'Deleted.',
    deleteConfirm: 'Remove "{{keyword}}" from the pool?',
    cluster: 'Cluster',
    allClusters: 'All clusters',
    language: 'Language',
    allLanguages: 'All languages',
    search: 'Search',
    emptyTitle: 'No keywords yet',
    emptyLead: 'Use "Add keyword" or pick from the Search Console suggestions below.',
    colKeyword: 'Keyword',
    colTarget: 'Target page',
    colClicks: 'Clicks',
    colImpressions: 'Impressions',
    colPosition: 'Avg. position',
    colTopPage: 'Top page by impressions',
    cannibalized: 'Cannibalization',
    targetStatus: { ok: 'Live', missing: 'No target', not_found: 'Not live', unverified: 'Not checked' },
    intents: {
      informational: 'Informational',
      commercial: 'Commercial',
      transactional: 'Transactional',
      navigational: 'Navigational',
    },
    metricsNote:
      'Clicks, impressions and position are the last 28 days of Search Console data (about 2 days delayed).',
    keyword: 'Keyword',
    intent: 'Search intent',
    intentNone: 'Not set',
    targetPath: 'Target page',
    notes: 'Note',
    candidatesTitle: 'Search Console suggestions',
    candidatesLead:
      'Searches not in the pool with the most impressions in the last 28 days. Pick and add; the target page is suggested from the top page.',
    notSynced: 'No Search Console data yet. Choose a property and sync on the Search performance screen:',
    noCandidates: 'No new suggestions; all searches are in the pool.',
    candidateStats: '{{impressions}} impressions, {{clicks}} clicks, position {{position}}',
    importCluster: 'Cluster',
    importSelected: 'Add selected ({{n}})',
    imported: '{{created}} keywords added, {{skipped}} already existed.',
    rankTitle: 'Rank tracking',
    rankLead:
      'Tracking daily Google rankings needs a licensed (paid) data provider; until one is chosen and its key entered it shows "Setup required". For now, position is the Search Console average.',
  },
  scSetup: {
    title: 'Connect to Google and set up',
    lead: "One button: the system verifies and adds the Search Console properties of the store domain and old domains, submits the sitemap and maps the old site's pages seen in Google to new addresses. Every morning it inspects product pages and sample old addresses in Google.",
    connectedAs: 'Connected Google account: {{email}}',
    notConnected: 'No Google account connected.',
    missingScope: 'Site verification permission missing: grant it with "Connect to Google".',
    connect: 'Connect to Google',
    run: 'Run setup',
    rerun: 'Run setup again',
    done: 'Search Console setup completed',
    siteOk: 'Verified and added to Search Console',
    siteVerifiedOnly: 'Verified; could not be added to Search Console',
    siteFailed: 'Stopped at {{step}}: {{reason}}',
    enableApi: 'Enable "{{api}}" in the Google Cloud project (free), then run the setup again.',
    enableApiLink: 'Open the enable page',
    sitePending: 'Not set up yet',
    lastRun: 'Last setup: {{date}}',
    sitemapOk: 'Sitemap submitted: {{url}}',
    sitemapFailed: 'Sitemap could not be submitted: {{reason}}',
    sitemapSkipped: 'Sitemap not submitted (store property could not be added).',
    legacyPages:
      '{{found}} pages seen in Google on old properties: {{matched}} new matches, {{table}} already redirected, {{fallback}} without counterpart (Broken links).',
    publishNote:
      'For a lasting connection the OAuth app in Google Cloud must be "In production"; permission of an app in "Testing" expires after 7 days.',
    inspectionsTitle: 'Google index status (daily URL inspection)',
    inspectionsEmpty: 'No inspections yet. The first results appear the morning after setup.',
    colUrl: 'Address',
    colKind: 'Type',
    colState: 'Status in Google',
    colCrawl: 'Last crawl',
    checkedAt: 'checked: {{date}}',
    roles: {
      store: 'Store',
      legacy: 'Old domain',
    },
    kinds: {
      product: 'Product page',
      legacy: 'Old address',
    },
    steps: {
      token: 'verification file',
      verify: 'verification',
      add: 'adding to Search Console',
      link: 'linking',
      sitemap: 'sitemap',
      pages: 'old pages',
    },
  },
  indexNow: {
    title: 'IndexNow (Bing, Yandex)',
    lead: 'Changed product, category, page and article addresses are reported to Bing and Yandex every ten minutes; all addresses are sent once on the first run.',
    notLive: 'The store is not live: nothing is sent.',
    indexingOff: 'Search engine indexing is off on the server: nothing is sent.',
    key: 'Key: {{key}} (its file is live on the site)',
    noKey: 'The key is created with the first submission.',
    last: 'Last submission: {{date}} · {{count}} addresses',
    never: 'Nothing submitted yet.',
    failed: 'Submission failed: {{reason}}',
    sent: '{{count}} addresses sent to IndexNow',
    submit: 'Send all addresses now',
    skipped: {
      not_live: 'The store is not live.',
      indexing_off: 'Indexing is off.',
      no_domain: 'The store has no domain.',
      nothing_changed: 'No addresses to send.',
    },
  },
  sc: {
    notLinked: 'No Search Console property chosen',
    notLinkedLead:
      'Connect your Google account and choose this store’s Search Console property; data arrives the next morning (or with "Sync now").',
    statusTitle: 'Linked property',
    lastSync: 'Last sync: {{time}}',
    neverSynced: 'Not synced yet',
    dataRange: 'Data: {{from}} – {{to}}',
    syncNow: 'Sync now',
    synced: 'Sync completed ({{rows}} rows).',
    noData: 'No data yet. Use "Sync now"; new properties get Google data after a few days.',
    summaryTitle: 'Summary',
    period: 'Period',
    lastDays: 'Last {{count}} days',
    metrics: {
      clicks: 'Clicks',
      impressions: 'Impressions',
      ctr: 'Click-through rate',
      position: 'Average position',
    },
    vsPrevious: '{{change}} vs previous period',
    chartLabel: 'Daily clicks chart',
    chartCaption: 'Daily clicks (Google data is about 2 days behind).',
    tableTitle: 'Details',
    dimension: 'Show',
    dims: { query: 'Queries', page: 'Pages', country: 'Countries', device: 'Devices' },
    devices: { mobile: 'Mobile', desktop: 'Desktop', tablet: 'Tablet' },
    filter: 'Search',
    noRows: 'No rows in this period.',
    moversTitle: 'Rising and falling pages',
    moversLead: 'Clicks in the latest period compared with the previous equal period.',
    rising: 'Rising',
    falling: 'Falling',
    noMovers: 'No notable change.',
    notComparable: 'There is no data for the previous period yet (Search Console data builds up daily).',
    sitemapsTitle: 'Sitemaps',
    sitemapsLead: 'Sitemaps submitted to Search Console and their status.',
    sitemapsError: 'Sitemaps could not be read; test the Google connection.',
    noSitemaps: 'No sitemap submitted yet.',
    colSitemap: 'Sitemap',
    colSubmitted: 'Submitted',
    colStatus: 'Status',
    colUrls: 'URLs',
    sitemapPending: 'Processing',
    sitemapOk: 'Processed',
    sitemapErrors: '{{count}} errors',
    ownSitemap: 'Store sitemap:',
    notInProperty: 'Not covered by the property',
    submitSitemap: 'Submit sitemap',
    sitemapSubmitted: 'Sitemap submitted to Search Console.',
    inspectTitle: 'URL inspection',
    inspectLead: 'A page’s status in Google’s index (Search Console URL inspection).',
    inspectUrl: 'Page address',
    inspect: 'Inspect',
    quota: '{{used}} / {{limit}} inspections used today.',
    verdicts: {
      PASS: 'Indexed',
      PARTIAL: 'Partly (with warnings)',
      FAIL: 'Not indexed (error)',
      NEUTRAL: 'Not indexed',
      VERDICT_UNSPECIFIED: 'Unknown',
    },
    inspectFields: {
      verdict: 'Result',
      coverageState: 'Coverage',
      indexingState: 'Indexing allowed',
      robotsTxtState: 'robots.txt',
      pageFetchState: 'Page fetch',
      lastCrawlTime: 'Last crawl',
      googleCanonical: 'Google-selected canonical',
    },
    digestTitle: 'Weekly email summary',
    digestLead:
      'Every Monday at 09:00 the alert recipients get the last 7 days, top queries, rising/falling pages and the last site crawl.',
    digestToggle: 'Weekly email summary',
    digestSaved: 'Saved.',
  },
  google: {
    connected: 'Google account connected.',
    clientTitle: 'OAuth client',
    clientLead:
      'The OAuth client you created in Google Cloud Console. The ID and secret are stored encrypted under Integrations.',
    clientOk: 'Verified',
    clientMissing:
      'First enter and test the client ID and secret under Integrations → Google account (OAuth client).',
    toIntegrations: 'Go to integrations',
    redirectUri: 'Authorized redirect URI',
    copy: 'Copy',
    copied: 'Address copied.',
    accountTitle: 'Google account',
    accountLead:
      'You approve the selected services on Google’s consent screen; your password never reaches us.',
    account: 'Connected account',
    connectedAt: 'Connected at',
    lastChecked: 'Last checked',
    notConnected: 'No Google account connected yet.',
    chooseServices: 'Services to connect',
    permissionsTitle: 'Granted permissions',
    granted: 'Granted',
    notGranted: 'Not granted',
    connect: 'Connect with Google',
    reconnect: 'Reconnect',
    test: 'Test connection',
    testOk: 'The connection works.',
    testFailed: 'The connection has problems; see the log.',
    disconnect: 'Remove connection',
    disconnectConfirm:
      'Google access will be revoked and the properties/accounts chosen for stores will be removed.',
    disconnected: 'Connection removed and access revoked at Google.',
    disconnectedLocal:
      'Connection removed; Google could not be reached, so also remove access from your Google account.',
    status: { active: 'Active', error: 'Error' },
    errors: {
      token_revoked: 'Access was removed at Google; reconnect.',
      userinfo_failed: 'Account information could not be read.',
      resource_not_accessible: 'This resource is no longer accessible.',
      insufficient_scope: 'Permission not granted.',
      permission_denied: 'No access to this resource.',
      api_not_enabled: 'API not enabled in the Cloud project.',
      unauthorized: 'Authorization rejected.',
      quota_exceeded: 'Google quota exhausted; will retry later.',
      http_error: 'Google rejected the request.',
      network: 'Google could not be reached.',
      timeout: 'Google did not respond in time.',
    },
    services: {
      search_console: 'Search Console',
      analytics: 'Google Analytics 4',
      merchant_center: 'Merchant Center',
      google_ads: 'Google Ads',
      business_profile: 'Google Business Profile',
    },
    serviceLeads: {
      search_console: 'Search queries, page performance, sitemap submission.',
      analytics: 'Property list and reports (read only).',
      merchant_center: 'Product data and product statuses.',
      google_ads:
        'Ad spend (into the ad center) and optional conversion upload. No developer token needed; a real account needs Explorer access for the Cloud project.',
      business_profile: 'Business location details and Google reviews (read only).',
    },
    resourcesTitle: 'Store resources',
    resourcesLead:
      'Which Search Console property, GA4 property, Merchant Center account, Google Ads customer account and Business Profile location each store uses.',
    notLinked: 'Not chosen.',
    serviceNotGranted: 'Permission not granted for this service; select it and reconnect.',
    choose: 'Choose',
    change: 'Change',
    unlink: 'Remove',
    linked: 'Resource saved.',
    unlinked: 'Resource link removed.',
    resourceLabel: '{{service}} resource',
    pick: 'Select',
    noResources: 'This Google account cannot access any resource. Grant access at Google and reload.',
    lastSync: 'Last sync: {{time}}',
    noSyncYet: 'Not synced yet',
    logsTitle: 'Log',
    logsLead: 'Last 50 operations. Tokens and personal data are never written.',
    noLogs: 'No entries yet.',
    colTime: 'Time',
    colOperation: 'Operation',
    colOutcome: 'Result',
    colDetail: 'Detail',
    logError: 'Error: {{code}}',
    operations: {
      oauth_start: 'Connection started',
      oauth_callback: 'Google response',
      token_refresh: 'Token refresh',
      list_resources: 'Resource list',
      verify_resource: 'Account access check',
      test: 'Connection test',
      revoke: 'Access revoked',
    },
    outcomes: { success: 'Succeeded', failure: 'Failed', blocked: 'Blocked' },
  },
  tracking: {
    crossDomain: {
      title: 'Cross-domain tracking',
      lead: 'If the store has several storefront domains, visitors moving between them are measured as the same visitor with the same source (campaign).',
      active: 'Active',
      inactive: 'Not needed',
      activeLead: 'GA4 linker and source data carried across {{count}} domains.',
      reasons: {
        single_domain:
          'The store has a single storefront domain; this turns on by itself when a second domain is added.',
        no_google_tag: 'No GA4 measurement ID or GTM container entered.',
      },
      toDomains: 'Go to domains',
      domains: 'Domains in cross-domain tracking',
      stepsTitle: 'To do',
      stepAuto:
        'The storefront adds the GA4 linker parameter and source data to links between these domains by itself; arriving from these domains is not counted as a referral.',
      stepGa4:
        'In Google Analytics, add these domains under Admin → Data streams → web stream → Configure tag settings → Configure your domains. Required if you use GTM.',
      stepReferrals:
        'To keep these hops out of referral reports, add them under "List unwanted referrals" in the same place if needed.',
      stepConsent:
        'Cookie consent is per domain: visitors are asked again on the other domain; source data is written there only with consent.',
    },
    server: {
      title: 'Server-side events',
      lead: 'Completed sales and refunds are also sent from the server, independent of the browser: bank transfer and cash on delivery orders and sales from visitors with ad blockers are measured too. The visitor’s cookie consent at order time is respected.',
      providers: {
        ga4: 'Google Analytics 4 (Measurement Protocol)',
        meta: 'Meta (Conversions API)',
        tiktok: 'TikTok (Events API)',
      },
      short: { ga4: 'GA4', meta: 'Meta', tiktok: 'TikTok' },
      status: { live: 'On', off: 'Off', needs_secret: 'Setup required', needs_id: 'No ID' },
      needsId: {
        ga4: 'First enter the GA4 measurement ID under Storefront tags above.',
        meta: 'First enter the Meta pixel ID under Storefront tags above.',
        tiktok: 'First enter the TikTok pixel ID under Storefront tags above.',
      },
      secret: {
        ga4: 'API secret (Measurement Protocol)',
        meta: 'Access token (Conversions API)',
        tiktok: 'Access token (Events API)',
      },
      secretSaved: 'Saved — enter a new one to replace it',
      testCode: 'Test event code',
      enabled: 'Send server events',
      save: 'Save',
      saved: 'Saved.',
      test: 'Send test event',
      testOk: 'The test event reached the provider.',
      testFailed: 'Test failed: {{reason}}',
      remove: 'Remove secret',
      removeConfirm: 'The secret is deleted and server events to this provider stop.',
      last24h: 'Last 24 hours: {{sent}} sent, {{failed}} failed, {{pending}} pending, {{skipped}} not sent.',
      userData: 'Personal data matching (email and phone hash)',
      userDataLead:
        'When on, the customer’s email and phone are sent to Meta and TikTok as SHA-256 hashes. This is a personal data transfer: update the privacy notice and cookie policy with your lawyer first. Off by default.',
      logTitle: 'Server event log',
      logLead: 'Last 100 events: sent data, attempts and the provider’s error message. Kept for 90 days.',
      logEmpty: 'No server events yet. They appear when a consenting visitor’s order is paid.',
      filter: 'Status',
      all: 'All',
      eventStatus: { pending: 'Pending', sent: 'Sent', failed: 'Failed', skipped: 'Not sent' },
      events: { purchase: 'Purchase', refund: 'Refund' },
      colTime: 'Time',
      colProvider: 'Provider',
      colEvent: 'Event',
      colOrder: 'Order',
      colStatus: 'Status',
      colDetail: 'Details',
      attempts: '{{n}} attempts',
      payload: 'Sent data',
      retry: 'Retry',
      retried: 'Queued again.',
      errors: {
        no_client_id: 'No GA cookie (visitor ordered before GA loaded)',
        no_match_keys: 'No matching ID (no pixel cookie)',
        disabled: 'Not sent because sending was turned off',
        timeout: 'The provider did not respond in time',
        network: 'Could not reach the provider',
        redirect: 'The provider redirected the request (the service address may have changed)',
      },
    },
    statusTitle: 'Storefront status',
    statusLead:
      "Tags load on the storefront only while the cookie policy is published and with the visitor's consent.",
    active: 'Active',
    inactive: 'Not active',
    activeLead: 'Tags that load when the visitor consents: {{list}}.',
    reasons: {
      no_tags: 'No tags yet. The storefront shows no cookie banner and uses necessary cookies only.',
      cookie_policy_missing:
        'Tags are not added to the storefront because no cookie policy is published. Publish it under Legal texts first.',
    },
    toLegal: 'Go to legal texts',
    tagsTitle: 'Tags',
    tagsLead: 'Copy the IDs from the related accounts. An empty field means that tag is not used.',
    fields: {
      gtmContainerId: 'Google Tag Manager ID',
      ga4MeasurementId: 'GA4 measurement ID',
      googleAdsId: 'Google Ads ID',
      googleAdsPurchaseLabel: 'Purchase conversion label',
      metaPixelId: 'Meta pixel ID',
      tiktokPixelId: 'TikTok pixel ID',
    },
    consentNote:
      'GA4 loads only with analytics consent; Google Ads, Meta and TikTok only with marketing consent; GTM with either. No tag runs for visitors who decline.',
    save: 'Save tags',
    saved: 'Tags saved. They take effect on the storefront within a few minutes.',
    providers: {
      site: 'Storefront (consent choice)',
      gtm: 'Google Tag Manager',
      ga4: 'Google Analytics 4',
      googleAds: 'Google Ads',
      meta: 'Meta pixel',
      tiktok: 'TikTok pixel',
    },
    legal: {
      title: 'Legal text impact',
      lead: 'Cookies of the configured tags and the recipients of data; whether the published texts mention them.',
      policyVersion: 'Published cookie policy: version {{version}}.',
      policyMissing: 'No cookie policy is published.',
      actionNeeded:
        'Some cookies or transfers are not mentioned: have your lawyer update the texts and publish a new version.',
      cookiesTitle: 'Cookies',
      transfersTitle: 'Data transfers (abroad)',
      colCookie: 'Cookie',
      colService: 'Service',
      colDuration: 'Duration',
      colRecipient: 'Recipient',
      colCountries: 'Countries',
      colInPolicy: 'In cookie policy',
      colInNotice: 'In privacy notice',
      found: 'Mentioned',
      missing: 'Not mentioned',
      days: '{{count}} days',
      note: "The system does not write legal texts; it only checks whether the cookie and provider names appear. Cookie names and durations follow the providers' documentation and may change. When a new cookie policy version is published, visitors are asked again.",
    },
    stats: {
      title: 'Cookie consent statistics',
      lead: 'Last 30 days; the latest choice per browser is counted.',
      none: 'No choices in the last 30 days.',
      visitors: 'Browsers that chose',
      acceptAll: 'Accepted all',
      rejectAll: 'Rejected',
      custom: 'Chose in preferences',
      analytics: 'Allowed analytics',
      marketing: 'Allowed marketing',
    },
  },
  migration: {
    exportTitle: 'Export (staging)',
    exportLead:
      'Downloads the configuration and content of the selected store as one ZIP file. Upload it with "Import" on the live panel.',
    sourceStore: 'Store',
    export: 'Download migration package',
    exported: 'Migration package downloaded',
    included:
      'Included: products, categories, price lists and prices, stock balances (with lot/expiry), legal texts, pages, blog, menus, banners, theme, shipping methods, bank accounts, store and business details, redirects and images.',
    excluded:
      'Not included: customers, dealers, orders, payments, audit log, users, domains, the business tax number and all keys/passwords (SMTP, iyzico, PayTR, API).',
    importTitle: 'Import (live)',
    importLead:
      'Previewed first: nothing is written. Matching uses slug, SKU, code and IBAN; uploading the same package again creates no duplicates.',
    targetStore: 'Target store',
    targetFromPackage: 'Store in the package (matched by code; created if missing)',
    includeStock: 'Move stock balances as opening stock',
    overwrite: 'Overwrite existing records that differ (off: only missing records are added)',
    legalReviewed: 'I confirm the legal texts were reviewed by a lawyer (publish with the "reviewed" flag)',
    carryApprovals: 'I carry over the veterinary (expert) approvals given on staging in my name',
    chooseFile: 'Choose package file and preview',
    previewOf: 'Package from store "{{store}}" of {{org}} ({{env}}), exported on {{date}}.',
    storeWillCreate:
      'Store "{{store}}" does not exist here; it will be created in preview mode (add the domain later).',
    sectionsCaption: 'Actions per section',
    section: 'Section',
    create: 'To add',
    update: 'To update',
    unchanged: 'Unchanged',
    skipped: 'Skipped',
    stockTitle: 'Opening stock (per product)',
    stockSkipped: 'Stock will not be moved (option off)',
    product: 'Product',
    stockStatus: 'Status',
    stockStatus_new: 'To write',
    stockStatus_already: 'Already written',
    stockStatus_exists: 'Warehouse already has stock records; skipped',
    stockStatus_missing: 'Product or warehouse missing',
    approvalsPending:
      '{{products}} products and {{content}} content items will await veterinary approval (approvals not carried); hidden on the storefront until approved.',
    legalWithReview: 'Legal texts will be published with the "reviewed by a lawyer" flag: {{list}}',
    legalWithoutReview:
      'Legal texts will be published without the "reviewed by a lawyer" flag (a launch requirement): {{list}}',
    warnings: {
      migration_no_secrets:
        'Keys and passwords are not in the package: enter SMTP, payment and shipping details again on the live panel.',
      migration_card_off:
        'Card payment arrives off; enable it in Payment settings after the keys are entered and tested.',
      migration_domains_manual: 'Domains are not moved; add the live domain under Stores.',
    },
    refresh: 'Refresh preview',
    stale: 'Options changed; refresh the preview',
    apply: 'Import',
    applyConfirm:
      'The package will be applied to this business (in one transaction). Existing records change only if "overwrite" is on. Continue?',
    applied: 'Migration package applied',
    resultTitle: 'Applied to store "{{store}}". Result:',
    sections: {
      store: 'Store',
      organization: 'Business details',
      files: 'Images',
      brands: 'Brands',
      taxClasses: 'Tax classes',
      categories: 'Categories',
      customerGroups: 'Customer groups',
      warehouses: 'Warehouses',
      products: 'Products',
      productOptions: 'Product options',
      productVariants: 'Variants (SKU)',
      productCategories: 'Product–category links',
      productMedia: 'Product images',
      markets: 'Markets',
      storeBrands: 'Store brands',
      priceLists: 'Price lists',
      prices: 'Prices',
      productStoreListings: 'Product listings',
      shippingMethods: 'Shipping methods',
      paymentSettings: 'Payment settings (card off)',
      bankAccounts: 'Bank accounts',
      legalDocuments: 'Legal texts',
      legalDocumentVersions: 'Legal text versions',
      postCategories: 'Blog categories',
      posts: 'Blog posts',
      postVersions: 'Post versions',
      pages: 'Pages',
      pageVersions: 'Page versions',
      banners: 'Banners',
      menus: 'Menus',
      themes: 'Theme',
      themeVersions: 'Theme versions',
      redirects: 'Redirects',
    },
  },
  uiTranslations: {
    coverageTitle: 'Translation status by language',
    coverageLead:
      'Coverage of interface texts (admin panel, storefront, mobile) and help texts in each language. Turkish is the source; a missing text falls back to English, then Turkish.',
    language: 'Language',
    ui: 'Interface texts',
    help: 'Help texts',
    direction: 'Text direction',
    ltr: 'Left to right',
    rtl: 'Right to left',
    complete: 'Complete ({{total}})',
    missing: '{{count}} missing of {{total}}',
    missingKeys: '{{language}}: missing keys ({{count}})',
    helpNote:
      'In other languages, detailed help fields come from the Turkish entry; to edit them per language:',
  },
  helpEditor: {
    search: 'Search key or title',
    edit: 'Edit',
    customized: 'Edited',
    saved: 'Explanation saved',
    title: 'Title',
    short: 'Short description',
    history: 'Previous versions',
    noHistory: 'No previous versions.',
    locale: 'Language',
  },
  confirm: { title: 'Are you sure?', yes: 'Yes, continue' },
  products: {
    customs: {
      title: 'Customs and export',
      lead: 'Used on the proforma invoice and the customs declaration for shipments abroad.',
      hsCode: 'HS code (GTİP)',
      hsCodeHint: '6–12 digits; dots and spaces are allowed (e.g. 2309.10.13.00.00).',
      originCountry: 'Country of origin',
      description: 'Customs description',
      descriptionHint: 'Short goods description for the declaration (e.g. dry cat food).',
    },
    extrasTitle: 'Videos, documents and complementary products',
    extrasLead:
      'The "Videos" and "Documents" tabs and the "Goes well with" section on the product page. Changes are stored with Save.',
    videos: 'Videos',
    videoUrl: 'Video {{n}} address',
    videoTitle: 'Video {{n}} title',
    addVideo: 'Add video',
    removeVideo: 'Remove video {{n}}',
    documents: 'Documents',
    noDocuments: 'No documents.',
    documentTitle: 'Document {{n}} title',
    documentKind: 'Document {{n}} type',
    documentFile: 'File: {{name}} ({{size}} KB)',
    documentKinds: {
      analysis_certificate: 'Certificate of analysis',
      leaflet: 'Instructions for use',
      safety_data_sheet: 'Safety data sheet',
      registration: 'Registration / approval',
      other: 'Other document',
    },
    addDocument: 'Upload PDF document',
    openDocument: 'Open',
    removeDocument: 'Remove document {{n}}',
    documentUploaded: 'Document uploaded. It appears in the storefront after you save the product.',
    complementary: 'Complementary products (Goes well with)',
    create: 'New product',
    createTitle: 'New product',
    search: 'Search',
    searchPlaceholder: 'Product name, SKU or barcode',
    status: 'Status',
    statuses: {
      draft: 'Draft',
      active: 'Active',
      archived: 'Archived',
    },
    vetReview: 'Vet review',
    vetStatuses: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      not_required: 'Not required',
    },
    brand: 'Brand',
    empty: 'No products yet',
    emptyLead: 'Add products one by one or upload an Excel/Shopify file on the Import / export page.',
    product: 'Product',
    sku: 'SKU',
    stock: 'Stock',
    variantCount: '{{count}} variants',
    backToList: 'Product list',
    basics: 'Basics',
    title: 'Product name',
    slug: 'Short name (URL)',
    species: 'Species',
    speciesNames: {
      cat: 'Cat',
      dog: 'Dog',
      bird: 'Bird',
      rodent: 'Small rodent (hamster, guinea pig etc.)',
      rabbit: 'Rabbit',
      reptile: 'Reptile and turtle',
      exotic: 'Other exotic',
    },
    taxClass: 'Tax class',
    defaultTax: 'Default tax class',
    b2cVisible: 'Visible to retail customers',
    b2bVisible: 'Visible to dealers',
    dealerMinQuantity: 'Dealer minimum quantity',
    dealerPackSize: 'Dealer case size (quantity must be a multiple)',
    healthContent: 'Has health content (vet approval required)',
    subscribable: 'Available for repeat delivery (customers can order "every N weeks")',
    content: 'Content',
    contentLead: 'Do not claim to prevent or treat disease. Changing these fields renews the vet review.',
    shortDescription: 'Short description',
    description: 'Description',
    composition: 'Composition',
    usage: 'Usage',
    warnings: 'Warnings',
    feedRegistrationNo: 'Feed registration no',
    categories: 'Categories',
    noCategories: 'No categories yet; add them on the Categories page.',
    tagsAttributes: 'Tags and attributes',
    tagsAttributesLead:
      'Tags are for collection rules and admin filters; attributes appear in the "Specifications" table on the product page.',
    tags: 'Tags',
    tagsPlaceholder: 'Comma-separated: kitten, grain free',
    tagSuggestions: 'Frequently used:',
    tag: 'Tag',
    noAttributes: 'No product attributes defined yet.',
    attributeEmpty: 'Empty',
    variants: 'Options and variants',
    variantsLead: 'Separate option values with commas. Each row is a variant.',
    optionName: 'Option name',
    optionNamePlaceholder: 'e.g. Size',
    optionValues: 'Option values',
    optionValuesPlaceholder: 'e.g. 60 tablets, 120 tablets',
    removeOption: 'Remove option',
    addOption: 'Add option',
    barcode: 'Barcode',
    weight: 'Weight (g)',
    cost: 'Cost',
    reservedShort: '{{n}} reserved',
    archiveVariant: 'Archive',
    restoreVariant: 'Restore',
    addVariant: 'Add variant',
    seo: 'Search engines (SEO)',
    seoTitle: 'SEO title',
    seoTitleHint: 'Max 70 characters. Product name is used if empty.',
    seoDescription: 'SEO description',
    seoDescriptionHint: 'Max 170 characters.',
    merchant: {
      title: 'Google Shopping',
      lead: 'Product data sent to Merchant Center. Price, stock, images and barcodes come from the product itself.',
      include: 'Send to Google Shopping',
      googleCategory: 'Google product category',
      condition: 'Item condition',
      conditions: { new: 'New', refurbished: 'Refurbished', used: 'Used' },
      identifierExists: 'Manufacturer barcode',
      identifiers: { auto: 'Yes if a barcode (GTIN) is entered', no: 'This product has no barcode' },
      skuIsMpn: 'SKU is the manufacturer part number (MPN)',
      customLabels: 'Custom labels (campaign grouping)',
      customLabel: 'Label {{n}}',
    },
    vetReviewTitle: 'Vet review',
    vetReviewLead: 'Products with health content cannot be published without vet reviewer approval.',
    claimsFound: 'Wording that needs review was found:',
    noClaims: 'The automatic check found no risky wording (the reviewer decides).',
    reviewNote: 'Review note',
    reviewNoteHint: 'required when rejecting',
    approveContent: 'Approve content',
    rejectContent: 'Reject',
    reviewSaved: 'Review saved',
    fields: {
      title: 'Product name',
      shortDescription: 'Short description',
      description: 'Description',
      composition: 'Composition',
      usage: 'Usage',
      warnings: 'Warnings',
    },
    media: 'Images',
    mediaLead: 'The first image is the cover.',
    mediaAlt: 'Alt text of image {{n}}',
    mediaMoveLeft: 'Move image {{n}} earlier',
    mediaMoveRight: 'Move image {{n}} later',
    mediaReordered: 'Image order saved',
    mediaOrderLead: 'The storefront gallery shows images in this order.',
    mediaStatus: {
      ready: 'Ready',
      pending_download: 'Waiting for download',
      failed: 'Download failed',
    },
    mediaFailure: {
      invalid_url: 'Invalid address',
      blocked_address: 'Internal network addresses are not allowed',
      dns_failed: 'Domain not found',
      connect_failed: 'Could not connect to the server',
      tls_failed: 'Secure connection failed',
      timeout: 'Timed out (30 s)',
      not_found: 'Image no longer exists at the source',
      forbidden: 'The source refused access',
      http_error: 'Source server error',
      too_many_redirects: 'Too many redirects',
      too_large: 'Larger than 20 MB',
      not_image: 'Not an image or corrupted',
      storage_failed: 'Could not be saved on the server',
      unknown: 'Unknown error',
    },
    mediaRetry: 'Retry',
    mediaSize: '{{width}}×{{height}} px',
    mediaSmall: 'Small for Google Shopping: at least 500×500 px recommended (required after 31 January 2027)',
    mediaRetryQueued: 'The image will be downloaded again (in about 30 s).',
    confirmRemoveMedia: 'Remove the image from the product?',
    imageAdded: 'Image added',
    addImage: 'Add image',
    prices: 'Prices',
    pricesLead: 'Prices save when you leave the field. Empty removes the price.',
    noPriceLists: 'Create a price list on the Pricing page first.',
    noBaseList_none:
      'Store "{{store}}" has no base (retail) price list: the product has no price there and is not listed. Create a list on the Pricing page with the store selected and no group.',
    noBaseList_inactive:
      'The base price list of store "{{store}}" is inactive: the product has no price there. Activate it on the Pricing page.',
    noBaseList_currency:
      'Store "{{store}}" sells in {{currency}} but its base price list uses another currency. Create a {{currency}} list.',
    noBaseList_dates:
      'The base price list of store "{{store}}" is not valid today (start/end date). Check the dates on the Pricing page.',
    goPriceLists: 'Go to Pricing',
    listInactive: 'inactive',
    listings: 'Store publishing',
    listingsLead: 'Publishing requires: active product, approved health content, a base price.',
    published: 'Published',
    notPublished: 'Not published',
    publish: 'Publish',
    unpublish: 'Unpublish',
  },
  categories: {
    slug: 'Short name (address)',
    slugLead: 'Address: {{path}}. If it changes, the old address redirects permanently to the new one.',
    description: 'Description',
    seoTitle: 'Title in search results',
    seoDescription: 'Description in search results',
    editTitle: 'Edit category',
    editHint:
      'Use "Edit" to change a category\'s name, address, description and how it appears in search results.',
    name: 'Category name',
    parent: 'Parent category',
    topLevel: 'Top level',
    add: 'Add category',
    productCount: '{{count}} products',
    statuses: {
      active: 'Visible',
      hidden: 'Hidden',
    },
    hide: 'Hide',
    show: 'Show',
    confirmDelete: 'Delete "{{name}}"? Products are not deleted.',
    empty: 'No categories yet',
    emptyLead: 'Start with top-level categories such as "Cat supplements".',
  },
  pricing: {
    referencePriceNote:
      'The storefront "previous price" is the lowest price actually applied in the last 30 days; no manual strike-through prices.',
    groups: 'Customer groups',
    groupsLead: 'Dealer levels. Approved dealer companies are linked to a group.',
    addGroup: 'Add group',
    noGroups: 'No customer groups yet',
    noGroupsLead: 'Create at least one dealer group for dealer prices.',
    minOrderShort: 'Minimum order: {{amount}}',
    noMinOrder: 'No minimum order',
    editMinOrder: 'Minimum order',
    minOrderTitle: '{{name}} — minimum order amount',
    minOrderLead:
      'Dealers in this group cannot order while the cart total (products, discounts and VAT included; shipping excluded) is below this amount. A company-specific amount is set on the dealer card.',
    minOrder: 'Minimum order amount ({{currency}})',
    minOrderHint: 'Empty: none',
    groupName: 'Group name',
    groupCode: 'Code',
    groupCodeHint: 'Lowercase letters, digits, - and _.',
    groupKind: 'Type',
    kinds: {
      dealer: 'Dealer',
      retail: 'Retail',
    },
    lists: 'Price lists',
    listsLead: 'A list without a group is the base list everyone sees.',
    addList: 'Add price list',
    noLists: 'No price lists yet',
    noListsLead: 'Create the base list first, then dealer lists.',
    taxIncl: 'Tax included',
    taxExcl: 'Tax excluded',
    forGroup: 'Group: {{group}}',
    baseList: 'Base list',
    priceCount: '{{count}} prices',
    listStatus: {
      active: 'Active',
      inactive: 'Inactive',
    },
    activate: 'Activate',
    deactivate: 'Deactivate',
    listName: 'List name',
    store: 'Store',
    listGroup: 'Customer group',
    baseListOption: 'None — base (retail) list',
    market: 'Market',
    allMarkets: 'All markets (in this currency)',
    forMarket: 'Market: {{market}}',
    currency: 'Currency',
    taxInclusive: 'Prices include tax',
    priority: 'Priority',
    taxes: 'Tax classes',
    taxesLead: 'Tax rates assigned to products.',
    defaultTax: 'Default',
    noTaxes: 'No tax classes yet',
    taxName: 'Name',
    taxNamePlaceholder: 'e.g. VAT 20%',
    taxRate: 'Rate',
    addTax: 'Add tax class',
    countryRates: 'Country VAT rates',
    countryRatesLead:
      'In markets whose tax mode is "Destination country VAT", the rate of the product tax class for that country applies. Products without a rate cannot be sold in that market.',
    noCountryRates: 'No country rates yet',
    countryRateClass: 'Tax class',
    countryRateCountry: 'Country',
    addCountryRate: 'Add country rate',
    countryRateDelete:
      'Delete the "{{name}}" rate for {{country}}? Products in this class can no longer be sold in that country\'s "Destination country VAT" market.',
    bulk: 'Bulk price change',
    bulkLead: 'Preview first; applied changes can be reverted.',
    targetList: 'Target list',
    operation: 'Operation',
    ops: {
      percent: 'Increase/decrease by percent',
      fixed: 'Add/subtract amount',
      from_list: 'Derive from another list',
      from_cost: 'From cost (markup)',
      target_margin: 'Target gross margin',
      fx: 'From another currency (rate)',
    },
    markup: 'Markup (%)',
    markupHint: 'Net price = cost × (1 + markup). VAT is added on tax-inclusive lists.',
    targetMargin: 'Gross margin (%)',
    targetMarginHint: 'Net price = cost ÷ (1 − margin). E.g. 40% margin on 100 cost → 166.67.',
    fxRate: 'Rate',
    fxRateHint: 'Value of 1 unit of the source currency in this list (e.g. 1 TRY = 0.0291 EUR → 0.0291).',
    fxAdjust: 'Extra adjustment (%)',
    minMargin: 'Minimum margin (%)',
    minMarginHint:
      'Leave empty to skip the check. Margin uses the net price and cost; products without cost are not checked.',
    minMarginMode: 'If below',
    minMarginModes: { warn: 'Warn (still apply)', block: 'Do not apply' },
    margin: 'Margin',
    lowMargin: 'Low margin',
    noCost: '{{count}} variants without cost (or with cost in another currency) were skipped.',
    blocked: '{{count}} variants are below the minimum margin and will not be applied.',
    lowMarginCount: '{{count}} variants are below the minimum margin.',
    campaign: 'Campaign',
    campaignStates: { upcoming: 'Not started', live: 'Live', ended: 'Ended' },
    validity: '{{from}} – {{to}}',
    startsAt: 'Valid from',
    endsAt: 'Valid until',
    datesHint:
      'Leave empty to keep the list always valid. For a campaign list set dates and a higher priority than the base list.',
    editDates: 'Edit dates',
    noLimit: 'open-ended',
    amount: 'Amount',
    percent: 'Percent',
    valueHint: 'Use a minus sign to decrease (e.g. -10).',
    sourceList: 'Source list',
    filterBrand: 'Brand',
    filterCategory: 'Category',
    ending: 'Price ending',
    endings: {
      none: 'Keep',
      whole: 'Whole',
      end_90: '.90',
      end_99: '.99',
    },
    previewBulk: 'Preview',
    previewSummary: '{{affected}} prices will change, {{skipped}} skipped.',
    before: 'Before',
    after: 'After',
    confirmApply: '{{count}} prices will change. Continue?',
    applyBulk: 'Apply',
    bulkApplied: 'Bulk prices applied',
    bulkReverted: 'Bulk prices reverted',
    history: 'History',
    affectedCount: '{{count}} prices',
    bulkStatus: {
      preview: 'Preview',
      applied: 'Applied',
      reverted: 'Reverted',
      expired: 'Expired',
    },
    confirmRevert: 'Revert this bulk change? Manually changed prices are kept.',
    revert: 'Revert',
  },
  discounts: {
    create: 'Create coupon',
    empty: 'No coupons yet',
    emptyLead: 'Create a percentage or fixed coupon for a campaign.',
    min: 'min {{amount}}',
    used: '{{used}}/{{limit}} used',
    until: 'until {{date}}',
    name: 'Coupon name (internal)',
    code: 'Code',
    type: 'Type',
    types: {
      percentage: 'Percentage',
      fixed_amount: 'Fixed amount',
    },
    minSubtotal: 'Minimum cart total',
    usageLimit: 'Usage limit',
    endsAt: 'End date',
    groups: 'Valid customer groups',
    groupsHint: 'If none is selected, everyone can use it.',
  },
  stock: {
    ledgerNote: 'Stock movements are never deleted; balance mistakes with a reverse adjustment.',
    warehouses: 'Warehouses',
    warehousesLead: 'The first warehouse is the default; orders reserve from it first.',
    default: 'Default',
    noWarehouses: 'No warehouses yet',
    warehouseName: 'Warehouse name',
    warehouseCode: 'Code',
    addWarehouse: 'Add warehouse',
    variantStock: 'Product stock',
    variantStockLead: 'Find a product and choose a variant to see balances and recent movements.',
    findProduct: 'Find product',
    newMovement: 'Stock movement',
    transfer: 'Transfer',
    warehouse: 'Warehouse',
    lot: 'Lot',
    expiry: 'Expiry',
    onHand: 'On hand',
    reserved: 'Reserved',
    movements: 'Recent movements',
    types: {
      receipt: 'Receipt',
      sale: 'Sale',
      return: 'Return',
      adjustment: 'Adjustment',
      transfer_in: 'Transfer in',
      transfer_out: 'Transfer out',
      damage: 'Damage',
      count: 'Count',
      import: 'Import',
      opening: 'Opening stock',
    },
    noResults: 'No results',
    movementType: 'Movement type',
    lotPick: 'Lot',
    chooseLot: 'Choose a lot',
    lotless: 'Stock without lot',
    lotOption: '{{lot}} · expiry {{expiry}} · {{onHand}} units',
    countedQuantity: 'Counted quantity (new total)',
    quantity: 'Quantity',
    lotNo: 'Lot no',
    reason: 'Reason',
    fromWarehouseId: 'From warehouse',
    toWarehouseId: 'To warehouse',
    noLot: 'No lot',
    expiryLabel: 'Exp. {{date}}',
    availableCount: '{{count}} available',
    transferNoStock:
      'This product has no transferable stock. A transfer moves existing stock between warehouses; the first stock entry is a "Receipt".',
    goReceipt: 'Enter receipt',
    transferNeedsTwo: 'A transfer needs another active warehouse (add one under Warehouses).',
    transferMax: 'Up to {{count}} can be moved.',
    transferTooMany: 'This source has only {{count}}.',
    noStockYet:
      'No stock for this product yet. Make the first entry with "Stock movement" → "Receipt" (with lot and expiry).',
    expiring: 'Expiring soon',
    expiringLead: 'Lots with stock nearing expiry.',
    withinDays: 'Period',
    days: '{{n}} days',
    lotLabel: 'Lot {{lot}}',
    noExpiring: 'No lots expire in this period.',
    critical: {
      title: 'Low stock',
      lead: 'Products whose sellable quantity is at or below their threshold. Furthest below first.',
      none: 'No products are low on stock.',
      product: 'Product',
      available: 'Sellable',
      threshold: 'Threshold',
      rule: 'Rule',
      allWarehouses: 'All warehouses',
      sources: {
        warehouse: 'Warehouse threshold',
        variant: 'Product threshold',
        default: 'Default threshold',
      },
      more: 'Showing the first {{shown}} rows ({{total}} in total).',
      defaultThreshold: 'Default threshold',
      defaultThresholdHint: 'For products without their own threshold; leave empty to disable.',
      saveDefault: 'Save default threshold',
      defaultSaved: 'Default threshold saved.',
      dailyDigest: 'Daily email summary',
      digestOn: 'Daily email summary is on (every morning at 08:00).',
      digestOff: 'Daily email summary is off.',
      thresholds: 'Low stock thresholds',
      thresholdsLead:
        'The product joins the low stock list when its sellable quantity drops to this number or below.',
      saveThresholds: 'Save thresholds',
      thresholdsSaved: 'Thresholds saved.',
    },
  },
  customers: {
    create: 'Add customer',
    search: 'Search',
    searchMaskedHint: 'Without the personal data permission, search uses names only.',
    kind: 'Type',
    kinds: {
      dealer: 'Dealer',
      retail: 'Retail',
    },
    maskedNote: 'Personal data is masked.',
    empty: 'No customers yet',
    emptyLead: 'Customers appear when they sign up or when a dealer list is imported.',
    notActivated: 'Not activated',
    disabled: 'Disabled',
    createdAndEmailed: 'Saved; the access link was emailed.',
    name: 'Full name',
    email: 'Email',
    phone: 'Phone',
    sendAccessLink: 'Send set-password link',
    manualLinkTitle: 'Send the link manually',
    manualLinkLead:
      'Email is not set up, so nothing was sent. Share this link with the customer through a secure channel.',
    linkEmailed: 'The link was emailed.',
    backToList: 'Customer list',
    profile: 'Profile',
    activated: 'Account active (password set)',
    emailVerified: 'Email verified',
    created: 'Created',
    companies: 'Dealer companies',
    sendReset: 'Password reset link',
    sendActivation: 'Activation link',
    unlock: 'Unlock',
    confirmDisable: 'Disable the customer account? Open sessions are closed.',
    confirmEnable: 'Re-enable the customer account?',
    disable: 'Disable',
    enable: 'Enable',
    consents: 'Marketing consents',
    channels: {
      email: 'Email',
      sms: 'SMS',
      call: 'Call',
      whatsapp: 'WhatsApp',
    },
    consentStatus: {
      granted: 'Granted',
      revoked: 'Revoked',
      none: 'No record',
    },
    consentSource: {
      register: 'At sign-up',
      account: 'Account page',
      checkout: 'At checkout',
      import: 'Import',
      admin: 'From panel',
      unsubscribe: 'Unsubscribe link',
    },
    confirmRevoke: 'Revoke the consent? The history is kept.',
    revoke: 'Revoke',
    addresses: 'Addresses',
    masked: 'masked',
    noAddresses: 'No saved addresses.',
    orders: 'Recent orders',
    noOrders: 'No orders yet.',
    tags: 'Tags',
    tagsLead:
      'Not shown on the storefront; used as a list filter and in segment rules. Included in KVKK data copies.',
    tagsLabel: 'Tags (comma separated)',
    tagsPlaceholder: 'e.g. vip, fair 2026, cat owner',
    tagSuggestions: 'Frequently used:',
    saveTags: 'Save tags',
    tagsSaved: 'Tags saved.',
    noTags: 'No tags.',
    tagFilter: 'Tag',
    metricsTitle: 'Order summary and RFM',
    metricsLead:
      'Calculated nightly from valid orders (cancelled, draft and fully refunded orders excluded).',
    noMetrics: 'No valid orders yet, or RFM has not been calculated.',
    orderCount: 'Orders',
    totalSpent: 'Net spend',
    avgOrder: 'Average order',
    firstOrder: 'First order',
    lastOrder: 'Last order',
    rfmGroup: 'RFM group',
    rfmScores: 'R{{r}} · F{{f}} · M{{m}}',
    otherCurrency: '{{count}} orders in another currency (not included in spend)',
    metricsComputed: 'Calculated: {{date}}',
    summaryTitle: 'Customer summary',
    summaryLead:
      'Calculated live from orders (cancelled, draft, unpaid and fully refunded orders excluded); the RFM group is updated nightly.',
    lifetimeSpent: 'Net spend to date',
    last12Months: 'Last 12 months',
    daysAgo: '{{count}} days ago',
    cycle: 'Order interval',
    cycleValue: 'Every {{days}} days on average',
    cycleNone: 'Needs at least two orders',
    nextExpected: 'Next order expected: {{date}} (estimate from past orders)',
    returnsCount: 'Return requests',
    newsletter: 'Newsletter',
    acquisition: 'Acquisition source',
    acquisitionNoAd: 'Not matched to an ad account',
    cacValue: 'Acquisition cost {{amount}} ({{month}}, {{count}} new customers)',
    newsletterNone: 'Not subscribed',
    rfmNotYet: 'Not calculated yet',
    notes: 'Internal notes',
    notesLead: 'Visible to panel users only; included in KVKK data copies.',
    notesLabel: 'Note',
    saveNotes: 'Save note',
    notesSaved: 'Note saved.',
    noNotes: 'No notes.',
    timelineTitle: 'Activity',
    timelineLead: 'Last 40 events, newest first; only sections you are allowed to see.',
    timeline: {
      account: 'Signed up',
      order: 'Order {{number}} · {{status}} · {{total}}',
      return: 'Return request (order {{order}}) · {{resolution}} · {{status}}',
      review: '{{rating}}/5 review for {{product}} · {{status}}',
      question: 'Question about {{product}} · {{status}}',
      consent: '{{channel}} consent: {{status}} · {{source}}',
      contact: 'Contact form message · {{status}}',
      ticket: 'Support request #{{number}}: {{subject}} · {{status}}',
      privacy: 'KVKK request: {{kind}} · {{status}}',
      newsletter: 'Newsletter: {{status}}',
      campaign: 'Campaign email: {{name}}',
      campaignClicked: 'clicked a link',
      campaignUnsubscribed: 'unsubscribed',
      automation: 'Automation email: {{name}}',
      message: '{{channel}} campaign: {{name}} ({{status}})',
    },
  },
  dealers: {
    ledgerTitle: 'Account',
    ledgerOpen: 'Open account',
    ledgerSummary: 'Balance {{balance}} · overdue {{overdue}}',
    paymentTerm: 'Payment term (days)',
    paymentTermInvalid: 'Enter a whole number between 0 and 365.',
    paymentTermValue: 'Payment term: {{days}} days after the order.',
    importList: 'Import dealer list',
    create: 'Add dealer',
    search: 'Search',
    searchHint: 'Name, dealer code, city or full tax number.',
    status: 'Status',
    statuses: {
      applied: 'Applied',
      approved: 'Approved',
      suspended: 'Suspended',
      rejected: 'Rejected',
    },
    empty: 'No dealers yet',
    emptyLead: 'Import your dealer list from Excel/CSV or add them one by one.',
    memberCount: '{{count}} users',
    legalName: 'Legal name',
    tradeName: 'Trade name',
    taxOffice: 'Tax office',
    taxNumber: 'Tax no / national ID',
    externalCode: 'Dealer code',
    city: 'City',
    district: 'District',
    email: 'Company email',
    phone: 'Phone',
    group: 'Dealer group',
    createApproved: 'Create as approved (dealer prices open immediately)',
    backToList: 'Dealer list',
    info: 'Company details',
    address: 'Address',
    source: 'Source',
    sources: {
      application: 'Storefront application',
      import: 'Import',
      manual: 'From panel',
    },
    approvedAt: 'Approved at',
    statusActions: 'Status actions',
    note: 'Note',
    noteHint: 'required when rejecting',
    actions: {
      approved: 'Approve',
      rejected: 'Reject',
      suspended: 'Suspend',
    },
    confirm: {
      approved: 'Approve the dealer? Its users start seeing dealer prices.',
      rejected: 'Reject the dealer?',
      suspended: 'Suspend the dealer? Its users will see retail prices.',
    },
    members: 'Users',
    membersLead: 'People who sign in to the storefront for this company.',
    roles: {
      owner: 'Owner',
      buyer: 'Buyer',
      viewer: 'View only',
    },
    rolesLead: 'The role decides what the user can do for the company on the storefront.',
    roleHelp: {
      owner:
        'Places orders; sees company orders, the account statement and company users; manages company locations. No order threshold.',
      buyer:
        'Places orders and sees only their own orders. With a threshold, orders above it need the owner’s approval.',
      viewer:
        'Sees dealer prices, company orders and the account statement; cannot order (e.g. accounting staff).',
    },
    editMember: 'Role and threshold',
    orderRules: 'Order rules',
    orderRulesLead:
      'Minimum order amount for this dealer (when empty, the dealer group’s amount applies) and whether storefront orders need a purchase order (PO).',
    minOrder: 'Minimum order amount ({{currency}})',
    minOrderHint: 'Empty: dealer group amount',
    poRequirement: 'Purchase order (PO)',
    poRequirements: {
      none: 'Optional',
      number: 'PO number required',
      number_and_document: 'PO number and document required',
    },
    editMemberTitle: '{{name}} — role and order threshold',
    orderLimit: 'Order threshold ({{currency}})',
    orderLimitHint: 'Empty: no threshold',
    orderLimitShort: 'Threshold: {{amount}}',
    confirmRemoveMember: 'Remove {{name}} from the company? The account is not deleted.',
    noMembers: 'No users yet.',
    role: 'Role',
    addMember: 'Add user',
    applications: 'Applications',
  },
  applications: {
    status: 'Status',
    statuses: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    empty: 'No applications',
    emptyLead: 'Applications from the storefront form appear here.',
    documentCount: '{{count}} documents',
    businessType: 'Business type',
    applicant: 'Applicant',
    note: 'Application note',
    documents: 'Documents',
    noDocuments: 'No documents uploaded.',
    decisionNote: 'Note',
    decisionNoteHint: 'Required when rejecting; emailed to the applicant.',
    approve: 'Approve',
    reject: 'Reject',
  },
  imports: {
    products: 'Products',
    productsLead:
      'Our template (Excel/CSV), a Shopify product CSV or a product JSON/XML document. Products are added as drafts; more than 50 products are applied in the background.',
    columnMapping: 'Column mapping',
    columnMappingLead:
      'Which field each column of the file goes to. Map an unrecognised column to a field or ignore it, then preview again. The mapping is saved when applied and used automatically for later files with the same headers.',
    unmatchedCount: '{{count}} columns not recognised',
    fileColumn: 'Column in file',
    targetField: 'Imported into',
    columnSource: 'How it was matched',
    noField: '— not imported —',
    ignoreColumn: 'Ignore',
    attributeColumn: 'Attribute column',
    columnSources: {
      auto: 'Automatic',
      saved: 'Saved mapping',
      manual: 'Chosen by hand',
      attribute: 'Attribute',
      ignored: 'Ignored',
      unmatched: 'Not recognised',
    },
    remap: 'Preview again with mapping',
    fields: {
      handle: 'Product code (slug)',
      title: 'Product name',
      brand: 'Brand',
      categories: 'Category',
      species: 'Species',
      shortDescription: 'Short description',
      description: 'Description',
      composition: 'Composition',
      usage: 'Usage',
      warnings: 'Warnings',
      feedRegistrationNo: 'Feed registration no',
      tax: 'VAT',
      visibility: 'Visibility',
      option1Name: 'Option 1 name',
      option1Value: 'Option 1 value',
      option2Name: 'Option 2 name',
      option2Value: 'Option 2 value',
      option3Name: 'Option 3 name',
      option3Value: 'Option 3 value',
      sku: 'SKU',
      barcode: 'Barcode',
      weight: 'Weight (g)',
      cost: 'Cost',
      price: 'Price',
      stock: 'Stock',
      images: 'Image URLs',
      imageAlt: 'Image description',
      seoTitle: 'SEO title',
      seoDescription: 'SEO description',
      tags: 'Tags',
    },
    importQueued: 'Applying in the background: {{processed}} / {{total}} products',
    importQueuedLead: 'You can leave this page; the import continues. The result appears here.',
    importProgress: 'Import progress',
    retryFailed: 'Retry failed products',
    exportJson: 'Download JSON',
    exportXml: 'Download XML',
    template: 'Download template',
    exportProducts: 'Export products',
    priceList: 'Price list',
    skipPrices: 'Do not import prices',
    warehouse: 'Warehouse',
    skipStock: 'Do not import stock',
    defaultBrand: 'Default brand',
    healthContent: 'Products carry health content (vet approval required)',
    chooseFile: 'Choose file and preview',
    formats: {
      zootopia: 'Zootopia template',
      shopify: 'Shopify CSV',
    },
    toCreate: '{{count}} new',
    toUpdate: '{{count}} updates',
    skipped: '{{count}} skipped',
    variants: '{{count}} variants',
    images: '{{count}} images',
    unknownHeaders: 'Unknown columns (ignored): {{list}}',
    issues: '{{count}} issues found; affected rows are not applied.',
    row: 'Row {{row}}',
    downloadIssues: 'Download issue list',
    issueRow: 'Row',
    issueField: 'Field',
    issueProblem: 'Problem',
    issueValue: 'Value in file',
    productsDraftNote: 'Products are not published; review them and publish after vet approval.',
    apply: 'Apply',
    applied: 'Import applied',
    stockSkippedLot:
      'Stock of {{count}} variants is tracked by lot/expiry and was not written from the file; enter it on the stock screen by lot.',
    productResult: '{{created}} added, {{updated}} updated, {{failed}} failed.',
    categories: 'Categories',
    categoriesLead:
      'Add or update the category tree from a file. Upload categories before products; re-uploading the same file creates no duplicates.',
    exportCategories: 'Export categories',
    categoriesPreview: 'Category preview',
    categoryResult: '{{created}} categories added, {{updated}} updated.',
    createMissingCategories: 'Create missing categories',
    categoryMode: 'Categories of existing products',
    categoryModes: {
      merge: 'Add those in the file (keep existing)',
      replace: 'Replace with those in the file',
    },
    categoriesToCreate: '{{count}} categories will be created',
    skuMissing:
      '{{count}} variants have an empty SKU; their products will be skipped. Suggested SKUs are shown in brackets in the issue list (barcode if present, otherwise product code + option).',
    skuGenerate: 'Preview again with suggested SKUs',
    skuGenerated:
      'SKUs suggested for {{count}} variants (listed per product below). Applying saves them; uploading the same file again produces the same SKUs, so no duplicates.',
    mediaStatusTitle: 'Imported images',
    mediaPending: '{{count}} images waiting for download (in the background, every 30 s).',
    mediaFailed: '{{count}} images could not be downloaded.',
    mediaReasons: 'Reasons: {{list}}',
    mediaRetryAll: 'Retry failed downloads',
    mediaRetryQueued: '{{count}} images will be downloaded again.',
    dealers: 'Dealer list',
    dealersLead: 'Required: company name and dealer code or tax number. Re-uploading creates no duplicates.',
    exportDealers: 'Export dealers',
    noDealerGroups: 'First create a dealer customer group on the Pricing page.',
    defaultGroup: 'Default dealer group',
    defaultStatus: 'Default status',
    useCompanyEmail: 'Use the company email for sign-in if no contact email',
    sendLinks: 'Email set-password links to users',
    unchanged: '{{count}} unchanged',
    errorRows: '{{count}} rows with errors',
    members: '{{count}} users',
    action: 'Action',
    actions: {
      create: 'New',
      update: 'Update',
      unchanged: 'Unchanged',
      error: 'Error',
    },
    dealerResult: '{{created}} dealers added, {{updated}} updated, {{members}} users linked.',
    linksEmailed: 'Set-password emails were sent to {{count}} users.',
    needActivation:
      '{{count}} users got no link (email not set up or not selected). Generate links on the dealer page, or dealers can use "Forgot password" once email is set up.',
  },
  orders: {
    geliver: {
      ship: 'Ship with Geliver',
      lead: "Enter the parcel size and weight, get the carriers' offers, choose one and buy the label.",
      testBadge: 'Test environment',
      weight: 'Weight (g)',
      weightMissing:
        '{{count}} product(s) have no weight; the default weight was added. Weigh the parcel and correct it.',
      getOffers: 'Get offers',
      offersPending: 'Offers arriving ({{percent}}%)',
      refresh: 'Refresh',
      noOffers: 'No offers arrived. Check the size and address and try again.',
      offers: 'Shipping offers',
      cheapest: 'Cheapest',
      fastest: 'Fastest',
      buy: 'Buy label ({{amount}})',
      confirm:
        'The label fee of {{amount}} will be charged to your Geliver balance; the shipment is recorded and the packed products leave stock.',
      confirmTest:
        'A label will be bought for a test shipment; the shipment is recorded and the packed products leave stock.',
      confirmYes: 'Confirm and buy',
      back: 'Back',
      bought: 'Label bought; shipment recorded.',
      codNote: 'Cash-on-delivery orders are not shipped with Geliver yet.',
      notReady: 'Choose a sender address on the Shipping page to ship with Geliver.',
      badge: 'Geliver',
      label: 'Open label',
      sync: 'Refresh status',
      synced: 'Status updated',
      cancel: 'Cancel in Geliver',
      cancelConfirm:
        "The shipment will be cancelled in Geliver; the packed products return to stock and the order can be shipped again. The label fee is refunded according to Geliver's rules.",
      cancelled: 'Shipment cancelled',
      price: 'Label {{amount}}',
      awaitingTracking:
        'The tracking number arrives when the carrier picks up the parcel; the customer is emailed then.',
    },
    createManual: 'Create order',
    paymentNote:
      'Card orders become "Paid" automatically after provider verification. For bank transfers use "Payment received" on the order once the money arrives; cash on delivery and dealer open account orders arrive as "Processing".',
    search: 'Search (order no, customer, company, PO no)',
    po: {
      title: 'Purchase order and company approval',
      lead: 'The dealer’s purchase order (PO) number and document; the company owner’s approval when a buyer’s order exceeds their threshold.',
      number: 'PO number',
      save: 'Save PO number',
      document: 'PO document:',
      download: 'Download {{name}} ({{kb}} KB)',
      noDocument: 'not attached',
      attach: 'Attach document',
      replace: 'Replace document',
      attached: 'PO document attached.',
      approval: 'Company approval',
      requestedBy: 'Requested by',
      approvedBy: 'Approved by (company owner)',
      approvedAmount: 'Approved goods total',
      approvalNote: 'Approval note',
      listLabel: 'PO: {{number}}',
    },
    status: 'Status',
    statuses: {
      draft: 'Draft',
      awaiting_payment: 'Awaiting payment',
      paid: 'Paid',
      processing: 'Processing',
      shipped: 'Shipped',
      delivered: 'Delivered',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    empty: 'No orders yet',
    emptyLead: 'Storefront, dealer and panel orders appear here.',
    number: 'Order no',
    customer: 'Customer',
    channel: 'Channel',
    channels: {
      web: 'Storefront',
      b2b: 'Dealer',
      manual: 'Panel',
      api: 'API',
    },
    total: 'Total',
    detailTitle: 'Order {{number}}',
    backToList: 'Order list',
    payment: {
      unpaid: 'Unpaid',
      authorized: 'Pre-authorized',
      pending: 'Payment pending',
      paid: 'Paid',
      partially_refunded: 'Partially refunded',
      refunded: 'Refunded',
    },
    lines: 'Items',
    qty: 'Qty',
    unitPrice: 'Unit price',
    lineTotal: 'Amount',
    lotAllocated: 'Allocated by lot / expiry',
    subtotal: 'Subtotal',
    discount: 'Discount {{code}}',
    promotion: 'Promotion: {{label}}',
    loyaltyTier: 'Tier discount: {{tier}} ({{percent}})',
    loyaltyPoints: '{{points}} points',
    shippingPromotion: 'Free ({{label}})',
    tax: 'Tax',
    shipping: 'Shipping',
    customerInfo: 'Customer and address',
    shippingAddress: 'Shipping address',
    billingAddress: 'Billing address',
    customerNote: 'Order note',
    changeStatus: 'Status actions',
    actions: {
      awaiting_payment: 'Confirm order (reserve stock)',
      processing: 'Mark as processing',
      shipped: 'Mark as shipped',
      delivered: 'Mark as delivered',
      completed: 'Complete',
      cancelled: 'Cancel',
    },
    actionHints: {
      awaiting_payment: 'The draft is confirmed; stock is reserved and the coupon is counted.',
      processing: 'Preparation starts. When ready, use "Ship" to enter the tracking number.',
      shipped: 'Reserved stock is deducted as a sale. The order can no longer be cancelled.',
      delivered: 'The order is marked as delivered.',
      completed: 'The order is closed.',
      cancelled: 'Reserved stock and the coupon use are released.',
    },
    statusNote: 'Note',
    timeline: 'Timeline',
    noteEvent: 'Internal note',
    internalNote: 'Add internal note',
    addNote: 'Add note',
    manualLead: "Prices follow the customer's group (dealer price for dealers).",
    createButton: 'Create order',
    created: 'Order created',
    changeCustomer: 'Change',
    customerHint: 'Search by name (or email with the personal data permission).',
    addProduct: 'Add product',
    manualPrice: 'Manual unit price',
    manualPricePlaceholder: 'List price',
    fullName: 'Recipient name',
    addressLine: 'Address',
    discountCode: 'Coupon code',
    initialStatus: 'Initial status',
    codFee: 'Cash on delivery fee',
    paymentMethod: 'Payment method',
    paymentMethods: {
      card: 'Card',
      paypal: 'PayPal',
      bank_transfer: 'Bank transfer',
      cash_on_delivery: 'Cash on delivery',
      open_account: 'Open account',
      manual: 'Manual (transfer/cash etc.)',
      gift_card: 'Gift card',
      store_credit: 'Store credit',
      loyalty_points: 'Loyalty points',
    },
    shippingMethod: 'Shipping method',
    initialStatuses: {
      confirmed: 'Confirm (reserve stock)',
      draft: 'Draft (no reservation)',
    },
    paymentsTitle: 'Payment',
    capture: 'Payment received',
    refund: 'Refund',
    noPayments: 'No payment records.',
    installments: '{{count}} installments',
    refundedAmount: 'Refunded: {{amount}}',
    refunds: 'Refunds',
    refundReasons: {
      customer_request: 'Customer request',
      withdrawal: 'Right of withdrawal',
      damaged: 'Damaged/defective',
      out_of_stock: 'Out of stock',
      duplicate: 'Duplicate payment',
      other: 'Other',
    },
    restocked: 'restocked',
    testPaymentWarning:
      'This order was paid in the test environment; no real money was collected. Do not ship it; cancel the order when testing is done.',
    resolveRefund: 'Set outcome',
    resolveRefundTitle: 'Set refund outcome',
    resolveRefundLead:
      "This refund was interrupted and its outcome is unknown. Check in the payment provider's panel whether the refund was made, then choose the outcome. No new refund request is sent to the provider.",
    resolveRefundOutcome: 'In the provider panel, this refund was',
    resolveRefundSucceeded: 'Made (amount refunded)',
    resolveRefundFailed: 'Not made',
    resolveRefundNote: 'Note',
    resolveRefundSave: 'Save outcome',
    resolveRefundDone: 'Refund outcome saved',
    eventTypes: {
      preauth_captured: 'Pre-authorization captured',
      preauth_released: 'Pre-authorization released; order cancelled',
      preauth_capture_failed: 'Pre-authorization capture failed',
      edited: 'Order edited',
      return_requested: 'Return/withdrawal request opened',
      return_approved: 'Return request approved',
      return_rejected: 'Return request rejected',
      return_completed: 'Return request completed',
      return_cancelled: 'Return request cancelled',
      created: 'Order created',
      status_changed: 'Status changed',
      payment_failed: 'Payment failed',
      payment_review: 'Payment needs review',
      payment_after_cancel: 'Payment arrived for a cancelled order (refund required)',
      payment_captured: 'Payment received',
      payment_amount_mismatch: 'Payment amount mismatch',
      refund: 'Refunded',
      refund_failed: 'Refund failed',
      partially_shipped: 'Package shipped (partial shipment)',
      exchange_shipped: 'Exchange item shipped',
      items_cancelled: 'Items cancelled (partial cancellation)',
      shipment_cancelled: 'Shipment cancelled; items returned to stock',
    },
    eventMessages: {
      draft_updated: 'Draft updated (items, customer, shipping or discount).',
      lines_changed: 'Items/quantities changed; amounts and stock reservation recalculated.',
      address_changed: 'Delivery address changed.',
      billing_changed: 'Billing address changed.',
      note_changed: 'Order note changed.',
      po_number_changed: 'Purchase order (PO) number changed.',
      po_document_attached: 'Purchase order (PO) document attached.',
      payment_timeout: 'Payment time ran out; the order was cancelled automatically.',
      bank_transfer_timeout:
        'The bank transfer did not arrive in time; the order was cancelled automatically.',
    },
    refundStatuses: {
      pending: 'In progress',
      succeeded: 'Succeeded',
      failed: 'Failed',
    },
    captured: 'Payment recorded',
    captureTitle: 'Payment received · {{amount}}',
    captureLead: 'Record after checking the money arrived. The customer gets a "payment received" email.',
    captureNote: 'Payment note',
    refundDone: 'Refund completed',
    refundFailed: 'Refund failed; see the payment section',
    refundTitle: 'Refund',
    refundCardLead:
      'The refund goes through the provider that took the payment (iyzico, PayTR, Sipay, Stripe or PayPal); it may take a few business days to appear.',
    refundManualLead: 'You make the bank transfer/COD refund yourself; record it here.',
    refundConfirm: 'Refund',
    refundable: 'Refundable: {{amount}}',
    refundAmount: 'Refund amount (₺)',
    refundReason: 'Reason',
    refundNote: 'Note',
    refundNoteHint: 'e.g. refunded IBAN and date.',
    refundPayment: 'Payment to refund',
    refundPaymentOption: '{{provider}} · refundable {{amount}}',
    refundAsCredit: 'Refund as store credit instead of money',
    refundCreditConsent: 'The customer explicitly agreed to receive the refund as store credit',
    refundCreditLead:
      "The amount is added to the customer's store credit; nothing is refunded to the card or bank account. Use only with the customer's explicit consent and never for withdrawal refunds.",
    refundTenderLead: 'The amount is restored to the gift card or store credit; no provider refund is made.',
    refundToStoreCredit: 'As store credit',
    restock: 'Restock returned items',
    restockQty: '{{title}} quantity returned',
    shipmentsTitle: 'Shipping',
    ship: 'Ship',
    shipAfterPayment: 'Cannot ship before payment.',
    noShipments: 'No shipments yet.',
    trackingLink: 'Track',
    shipmentStatuses: {
      created: 'Created',
      in_transit: 'In transit',
      out_for_delivery: 'Out for delivery',
      delivered: 'Delivered',
      returned: 'Returned',
      exception: 'Problem',
      cancelled: 'Cancelled',
    },
    updateShipment: 'Update status',
    shipped: 'Order shipped',
    shipTitle: 'Ship order',
    shipLead:
      'Choose the items and quantities in this package. Packed quantities leave stock and the customer gets an email with the tracking number. With nothing left to ship the order becomes "Shipped"; otherwise it stays in preparation.',
    shipItems: 'Items in this package',
    shipQty: '{{title}} quantity to ship',
    shipProgress: '{{shipped}}/{{ordered}} shipped',
    shipCodNote: 'A cash-on-delivery order cannot be split; all remaining items ship in this package.',
    shipPartialNote: 'This package is part of the order; the remaining items ship later.',
    shipNothing: 'Add at least one item to the package.',
    shippedPartial: 'Package shipped; remaining items are waiting',
    partiallyShipped: 'Partially shipped',
    ledgerSettled: 'Settled on account',
    exportExempt: 'Export — VAT exempt',
    waitingToShip: 'Waiting to ship: {{items}}',
    shipmentItem: '{{quantity}} × {{title}}',
    chooseProvince: 'Choose a province',
    chooseDistrict: 'Choose a district',
    chooseProvinceFirst: 'Choose a province first',
    legacyPlace: '{{value}} (not in the list)',
    cancelledQty: '{{count}} cancelled',
    cancelledItems: 'Cancelled items',
    refundDue:
      'The {{amount}} for items cancelled because they could not ship has not been refunded yet. Refund it with "Refund" (the amount is suggested).',
    cancelItems: 'Cancel remaining items',
    cancelItemsLead:
      'Items that cannot ship are cancelled from the order: reserved stock is freed and the customer gets an email. The order total does not change; if it was paid, refund the cancelled items with "Refund". With nothing left to ship the order becomes "Shipped".',
    cancelQty: '{{title}} quantity to cancel',
    cancelItemsNote: 'Note to the customer',
    cancelItemsNoteHint: 'Shown to the customer in the email (e.g. "The supplier ran out").',
    itemsCancelled: 'Items cancelled; amount {{amount}}',
    trackingNumber: 'Tracking number',
    trackingUrl: 'Tracking URL',
    trackingUrlHint: "If empty, the carrier's tracking page is used (format unverified).",
    packageCount: 'Packages',
    updateShipmentLead:
      'Choosing "Delivered" also marks the order delivered once all of its packages are delivered.',
    shipmentCancelNote:
      'Items in a cancelled package return to stock and are reserved for the order again; the order goes back to "Processing" and the items can be shipped again. Cancel only if the package never left.',
    shipmentStatus: 'Status',
    shipmentNote: 'Note',
    invoicesTitle: 'Invoice',
    createInvoice: 'Create invoice',
    noInvoices: 'No invoice.',
    contractsTitle: 'Accepted texts',
    contractsLead: 'Texts the customer saw and accepted at checkout, with version and time.',
    contractHash: 'Text digest: {{hash}}…',
  },
  orderTools: {
    manualPriceHint:
      'Manual unit price ({{currency}}, tax treatment as in the price list); leave empty to use the customer’s list price.',
    editDraftTitle: 'Draft order {{number}}',
    saveDraft: 'Save draft',
    customerKind: 'Customer type',
    customerKinds: { customer: 'Registered customer', guest: 'Guest' },
    guestEmail: 'Email',
    guestEmailHint: 'Order and payment details are sent to this address.',
    maskedKeep: 'The saved value is hidden; leave empty to keep it.',
    guestPhone: 'Customer phone',
    noShippingMethod: 'No shipping method (free or decided later)',
    audience: { retail: 'retail only', dealers: 'dealers only' },
    shippingFee: 'Shipping fee ({{currency}}, incl. VAT)',
    shippingFeeHint:
      'Leave empty to calculate it from the selected method (weight tiers, free shipping threshold).',
    discountKind: 'Discount',
    discountKinds: { none: 'No discount', code: 'Coupon code', manual: 'Manual amount' },
    manualDiscount: 'Discount amount ({{currency}}, incl. VAT)',
    manualDiscountHint: 'Spread across items in proportion to their amounts; cannot exceed the subtotal.',
    addressMasked:
      'The address is hidden (you cannot view personal data). Enter the full address to change it; leave empty to keep the saved one.',
    editLinesTitle: 'Edit items',
    editLinesLead:
      'Existing items keep their unit price; new items are added at the current price. The shipping fee stays; stock is reserved again.',
    editAddressTitle: 'Edit address and note',
    editAddressLead:
      'The delivery address and order note can be changed until a shipment is created. The billing address cannot change once invoiced.',
    editDraft: 'Edit draft',
    editLines: 'Edit items',
    editAddress: 'Edit address and note',
    bulkRegion: 'Selected orders',
    selected: '{{count}} orders selected',
    printOrders: 'Print order summary',
    printPacking: 'Print packing list',
    exportSelected: 'Download as Excel',
    bulkStatus: 'Change status',
    bulkDone: 'Status changed for {{count}} orders.',
    bulkStatusTitle: 'Change the status of {{count}} orders',
    bulkStatusLead:
      'Each order changes under its own rules (stock, coupon, customer notification); those that cannot are listed with the reason.',
    bulkApply: 'Apply',
    bulkSummary: '{{ok}} orders changed, {{failed}} not changed.',
    bulkTarget: 'New status',
    bulkCancelWarning:
      'Customers of cancelled orders receive a cancellation email; reserved stock and coupon use are released. Paid orders are not cancelled without a refund.',
    selectAllPage: 'Select all orders on this page',
    selectRow: 'Select order {{number}}',
  },
  preauth: {
    held: '{{amount}} is held on the card (pre-authorization); not charged yet.',
    deadline: 'Capture by: {{date}} ({{days}} days left).',
    expiringSoon: 'About to expire: ship the order or capture now.',
    partial:
      'Order total is {{amount}}: this is charged on capture and the bank releases the remaining {{rest}}.',
    capture: 'Capture',
    captureTitle: 'Capture pre-authorization',
    captureLead:
      '{{amount}} will be charged from the {{held}} hold. This also happens automatically when shipping.',
    captured: 'Amount captured',
    release: 'Release pre-authorization',
    releaseTitle: 'Release pre-authorization',
    releaseLead:
      'The card hold is released and the order cancelled; stock and coupon use are returned and the customer gets a cancellation email. This cannot be undone.',
    releaseNote: 'Reason',
    released: 'Pre-authorization released; order cancelled',
  },
  paymentLinks: {
    title: 'Payment link',
    create: 'Create payment link',
    renew: 'Create new link',
    empty: 'No payment link for this order.',
    createdAt: 'Created: {{date}}',
    expiresAt: 'Valid until: {{date}}',
    paidAt: 'Paid: {{date}}',
    openedAt: 'Opened by customer: {{date}}',
    notOpened: 'Not opened yet',
    states: {
      active: 'Valid',
      paid: 'Paid',
      expired: 'Expired',
      cancelled: 'Cancelled',
      closed: 'Closed',
      amount_changed: 'Amount changed',
    },
    cancel: 'Cancel',
    cancelConfirm: 'Cancel this link? The customer will not be able to pay with it.',
    cancelledToast: 'Link cancelled',
    createTitle: 'Create payment link',
    createLead: 'The customer sees the order and contract texts, accepts them and pays {{amount}} by card.',
    draftNote:
      'The order is a draft: creating the link confirms it, reserves stock and counts the coupon use.',
    renewNote: 'The current link is cancelled; send the new link to the customer.',
    hours: 'Valid for',
    hourOptions: { h24: '24 hours', h72: '3 days', h168: '7 days', h720: '30 days' },
    sendEmail: 'Send the link to the customer’s email ({{email}})',
    noEmail: 'The order has no email address; copy the link and send it yourself.',
    createButton: 'Create',
    createdTitle: 'Payment link ready',
    createdLead:
      'The link is shown only now; copy it and send it to the customer (WhatsApp, SMS, email). If lost, create a new one.',
    url: 'Link',
    copy: 'Copy',
    copied: 'Link copied',
    copyFailed: 'Could not copy; select the link and copy it manually.',
    emailed: 'The link was emailed to the customer.',
    notEmailed: 'No email was sent.',
  },
  proforma: {
    title: 'Proforma invoice',
    open: 'Proforma invoice',
    back: 'Back to order',
    documentLabel: 'Proforma invoice {{number}}',
    notInvoice:
      'This is a proforma invoice; it does not replace the commercial invoice (e-Invoice / e-Archive).',
    currency: 'Currency: {{currency}}',
    sellerTax: 'Tax office / no: {{office}} / {{number}}',
    mersis: 'MERSIS: {{no}}',
    buyer: 'Buyer',
    consignee: 'Consignee',
    totalWeight: 'Total product weight',
    kg: '{{value}} kg',
    description: 'Description of goods',
    hsCode: 'HS code',
    origin: 'Origin',
    weight: 'Weight',
    discount: 'Discount',
    exportExemption: 'Export delivery: no VAT charged (Turkish VAT Law No. 3065, art. 11/1-a).',
    exemptionVerify: 'Have your accountant confirm the exemption basis and the wording on this document.',
    fxLine: 'Rate: {{pair}} (CBRT forex buying, {{date}})',
    pricesInclusive: 'Prices include VAT.',
    pricesExclusive: 'Prices exclude VAT.',
    missingCustoms:
      'Products missing an HS code or country of origin: {{skus}}. Complete them in the "Customs and export" section of the product editor.',
  },
  catalogTranslations: {
    title: 'Translations',
    productLead:
      'The product base language is {{base}}. Name, descriptions and SEO fields in other languages; a translated language is opened to search engines at its language-prefixed address (e.g. /en/…).',
    missing: 'No translation',
    findings: '{{count}} possible health claims; review before approving',
    vet: { approved: 'Approved', pending: 'Awaiting veterinary approval' },
    approve: 'Approve',
    approveConfirm: 'Approve the {{language}} translation? The approved text is published on the storefront.',
    approved: 'Translation approved.',
    add: 'Add translation',
    deleteConfirm: 'Delete the {{language}} translation?',
    dialogTitle: '{{language}} translation',
    dialogLead:
      'Empty description fields are not shown. Composition, usage and warnings stay in the base language.',
    productTitle: 'Product name',
    shortDescription: 'Short description',
    description: 'Description',
    seoTitle: 'SEO title',
    seoDescription: 'SEO description',
    categoryTitle: '{{name}} — translations',
    categoryLead:
      'Category name, description and SEO fields; a translated category is opened to search engines in that language.',
    noLanguages:
      'Your stores have no language other than the base language. Add a market in another language to translate.',
    language: 'Language',
    done: 'translated',
    categoryName: 'Category name',
    saveLanguage: 'Save {{language}}',
  },
  orderPrint: {
    orderTitle: 'Order summary',
    packingTitle: 'Packing list',
    print: 'Print / save as PDF',
    nothing: 'No orders to print.',
    lead: '{{count}} orders. Each order prints on its own page; choose "Save as PDF" in the print dialog for a PDF.',
    maskedNote: 'Addresses and contact details are hidden because you cannot view personal data.',
    documentLabel: '{{title}} {{number}}',
    packingNote: 'Warehouse picking and packing list; not an e-dispatch note.',
    lots: 'Lot / expiry',
    check: 'Check',
    lotLine: '{{lot}} (exp. {{expiry}}) × {{qty}}',
    preparedBy: 'Prepared by',
    checkedBy: 'Checked by',
  },
  payments: {
    store: 'Store',
    noStore: 'Create a store first',
    noStoreLead: 'Payment and shipping settings are per store. Add a store under Stores.',
    cardTitle: 'Card payments (virtual POS)',
    cardLead:
      "iyzico or PayTR. Card details never reach the store; they are entered on the provider's secure page.",
    envSandbox: 'Test',
    envLive: 'Live',
    keysHint: 'Keys are stored encrypted on the Integrations screen, where you also run the connection test:',
    cardProvider: 'Card provider',
    cardOff: 'Off',
    cardStatus: 'Card payment on the storefront:',
    cardState_off: 'Off',
    cardState_test: 'Test (no real money)',
    cardState_live: 'Live',
    cardNext_off_none:
      'Next step: enter iyzico or PayTR sandbox keys under Integrations and test the connection; then choose the provider below and save.',
    cardNext_off_live_only:
      'Live keys are connected but card payment is off. Owner: choose the provider or press "Go live"; without a test payment you can confirm the warning and go live directly with two-step verification, then place and refund a small first live order. Other roles need a successful sandbox payment first.',
    cardNext_off_ready: 'Next step: choose the provider below and save; card payment opens in test mode.',
    cardNext_test:
      'Customers can pay with test cards; no real money is charged. Pay a test order and check it under Payments; if successful, switch to real payments with "Go live" (launch day).',
    cardNext_live: 'Real card payments are being accepted.',
    environment: 'Environment',
    goLive: 'Go live',
    backToSandbox: 'Back to test',
    backToSandboxConfirm:
      'Card payments will be turned off and the environment switched back to test. Continue?',
    sandboxNote: "No real money is charged in test; place a trial order with the provider's test cards.",
    maxInstallments: 'Installments',
    singlePayment: 'Single payment',
    upTo: 'Up to {{count}} installments',
    cardTimeout: 'Card payment timeout (minutes)',
    cardCapture: 'When to charge',
    cardCaptures: {
      immediate: 'Charge at payment',
      preauth: 'Pre-authorize, charge when shipping',
    },
    cardCapturePreauthHint:
      'The amount is held on the card at checkout and charged when the order ships (or with "Capture" on the order). Holds not captured within 25 days are released by the bank. Single payment; debit cards cannot be pre-authorized.',
    preauthPaytr:
      'Pre-authorization is not available for PayTR: its technical document is not public; it can be added once PayTR provides it.',
    preauthSipay: 'Pre-authorisation is not used with Sipay: payment is captured immediately.',
    cardCurrencies: 'Card payments in foreign currency',
    cardCurrenciesHint: {
      iyzico:
        'In a store priced in a currency other than TRY, cards are offered only in the currencies ticked here. Tick them if you have a foreign-currency agreement with iyzico.',
      paytr:
        'In a store priced in a currency other than TRY, cards are offered only in the currencies ticked here. PayTR requires an agreement with its corporate team for EUR/USD/GBP.',
      sipay:
        'In a non-TRY store, card payment is offered only in the currencies ticked here. Sipay accepts EUR and USD; foreign-currency collection needs an agreement with Sipay.',
      stripe:
        'Foreign-currency cards via Stripe: in markets priced in a ticked currency, cards are taken on Stripe’s payment page.',
    },
    cardCurrencyLabel: 'Card payments in {{currency}}',
    notifyUrls: 'Notification URLs',
    iyzicoNotify: 'iyzico notification (webhook) URL',
    paytrNotify: 'PayTR notification URL',
    sipayNotify: 'Sipay webhook URL',
    intlTitle: 'Foreign payments (Stripe, PayPal)',
    intlLead:
      'Take cards in foreign-currency markets on Stripe’s page and PayPal payments on PayPal’s page. TRY payments keep using the card provider above.',
    intlEntityTitle: 'A company outside Türkiye is required',
    intlEntityLead:
      'Stripe and PayPal do not open accounts for businesses established in Türkiye. The account is opened for your company in a supported country and funds go to that company. Settle invoicing and accounting with your accountant before going live.',
    intlCardProvider: 'Foreign-currency card payments',
    intlCardHint:
      'With Stripe selected, non-TRY card payments go through Stripe; no instalments or pre-authorisation.',
    intlCardOff: 'Domestic card provider (if it has a currency agreement)',
    intlCardEnvironment: 'Foreign card environment',
    paypal: 'Pay with PayPal',
    paypalHint:
      'PayPal option at checkout; shown only in EUR, USD and GBP markets. Connect Integrations → PayPal first.',
    paypalEnvironment: 'PayPal environment',
    stripeNotify: 'Stripe webhook URL',
    paypalNotify: 'PayPal webhook URL',
    otherTitle: 'Other payment methods',
    otherLead: 'For non-card methods, mark "Payment received" on the order when the money arrives.',
    bankTransfer: 'Bank transfer',
    bankTransferHold: 'Bank transfer payment window (hours)',
    bankTransferHint:
      'The customer sees bank details after ordering; you confirm when paid. Orders not paid in time are cancelled automatically.',
    cod: 'Cash on delivery',
    codHint: 'Offered only with shipping methods that support it.',
    codFee: 'Cash on delivery fee (₺)',
    codMax: 'Cash on delivery limit (₺)',
    dealerOpenAccount: 'Dealer open account',
    dealerOpenAccountHint: 'Approved dealers order without paying; the amount goes to their account.',
    guestCheckout: 'Guest checkout',
    guestCheckoutHint: 'If off, customers must create an account to order.',
    summaryTitle: 'Methods offered on the storefront',
    summaryCard: 'Card: {{provider}} ({{env}})',
    summaryNoCard: 'Card payments off',
    summaryIntl: 'Foreign cards: {{provider}} ({{env}})',
    summaryPaypal: 'PayPal ({{env}})',
    goLiveTitle: 'Go live with {{provider}}',
    goLiveLead: "From now on real money is charged from customers' cards. The items below must be complete.",
    goLiveConfirm: 'Go live',
    checkLiveConnection: 'Connection test with live keys passed',
    checkSandboxPayment: 'At least one successful payment in test',
    noSandboxTitle: 'No test payment made',
    noSandboxLead:
      'There is no successful sandbox payment. If you go live, place the first live order yourself with a small amount and refund it to confirm payment and refund work.',
    noSandboxAck:
      'I am going live without a test payment; I will place the first live order myself with a small amount and refund it (owner approval).',
    noSandboxOwnerOnly: 'Only the business owner can approve going live without a test payment.',
    firstLiveOrderTitle: 'Place the first live order yourself and refund it',
    firstLiveOrderLead:
      'Card payments went live without a test payment. Place a small order with your own card, check it is paid and refund it from the order details. This notice disappears once the refund completes.',
    goLiveAck: 'I understand real cards will be charged and the provider agreement is approved.',
    bankAccounts: 'Bank accounts',
    bankAccountsLead: 'Shown to customers choosing bank transfer.',
    addBankAccount: 'Add bank account',
    editBankAccount: 'Edit bank account',
    noBankAccounts: 'No bank accounts',
    noBankAccountsLead: 'Add at least one account if bank transfer is on; otherwise the method is hidden.',
    accountStatus: {
      active: 'Active',
      inactive: 'Inactive',
    },
    deleteBankAccountConfirm: 'Delete this bank account? Past orders are not affected.',
    bankAccountDialogLead: 'The IBAN is validated. Changes need two-step verification and are audited.',
    bankName: 'Bank',
    accountHolder: 'Account holder',
    iban: 'IBAN',
    accountStatusLabel: 'Status',
    accountCurrency: 'Currency',
    status: 'Status',
    provider: 'Method',
    statuses: {
      pending: 'Pending',
      requires_action: 'Needs review',
      authorized: 'Authorized (hold)',
      captured: 'Captured',
      failed: 'Failed',
      cancelled: 'Cancelled',
      expired: 'Expired',
    },
    providers: {
      iyzico: 'iyzico',
      paytr: 'PayTR',
      stripe: 'Stripe',
      paypal: 'PayPal',
      sipay: 'Sipay',
      bank_transfer: 'Bank transfer',
      cash_on_delivery: 'Cash on delivery',
      open_account: 'Open account',
      manual: 'Manual',
      gift_card: 'Gift card',
      store_credit: 'Store credit',
      loyalty_points: 'Loyalty points',
    },
    empty: 'No payments yet',
    emptyLead: 'Payments from the storefront or panel appear here.',
    amount: 'Amount',
    refunded: 'Refunded',
    events: 'Notifications',
    eventsTitle: 'Payment records · {{number}}',
    eventsLead:
      'Provider notifications and queries. Notifications with invalid signatures are not processed.',
    noEvents: 'No records.',
    eventKinds: {
      webhook: 'Notification',
      callback: 'Notification (PayTR)',
      return: 'Browser return',
      status_query: 'Status query',
      reconcile: 'Reconciliation',
      manual: 'Manual',
    },
    outcomes: {
      applied: 'Applied',
      duplicate: 'Duplicate (ignored)',
      ignored: 'Ignored',
      rejected: 'Rejected',
      error: 'Error',
    },
    signatureOk: 'Signature valid',
    signatureBad: 'Signature invalid',
  },
  returns: {
    title: 'Return / withdrawal requests',
    customerNote: "Customer's note",
    decisionNote: "Store's note",
    kinds: {
      withdrawal: 'Right of withdrawal',
      defective: 'Damaged / defective item',
      wrong_item: 'Wrong item',
      other: 'Other',
    },
    statuses: {
      requested: 'Awaiting reply',
      approved: 'Approved',
      rejected: 'Rejected',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      approved: 'Approve',
      rejected: 'Reject',
      completed: 'Completed',
      cancelled: 'Cancel',
    },
    leads: {
      approved:
        'An approval email is sent to the customer. Write how to send the item (carrier, agreement code, address). The refund is made from the payment section when the item arrives.',
      rejected: 'An email with the reason is sent to the customer. The reason is required.',
      completed:
        'Close the request once the item arrived and the refund was made from the payment section. This does NOT make a refund.',
      cancelled: 'Close it if the customer withdrew the request. A note is required.',
    },
    noteLabels: {
      approved: 'Shipping instructions',
      rejected: 'Reason',
      completed: 'Note',
      cancelled: 'Note',
    },
    done: {
      approved: 'Request approved',
      rejected: 'Request rejected',
      completed: 'Request completed',
      cancelled: 'Request cancelled',
    },
    resolutions: {
      refund: 'Refund',
      exchange: 'Exchange',
    },
    exchangeTo: 'Send instead: {{items}}',
    exchangeShipped: 'Exchange item shipped: {{carrier}} · {{tracking}}',
    restockedYes: 'The returned item was restocked.',
    restockedNo: 'The returned item was not restocked.',
    shipExchange: 'Ship exchange',
    shipExchangeLead:
      'Once the returned item has arrived, ship the new item. The reserved item leaves stock, the request completes and the customer gets an email with the tracking number. No money moves.',
    restock: 'Put the returned item back into sellable stock',
    restockHint: 'Do not restock a defective or opened item.',
    exchangeShippedDone: 'Exchange item shipped',
    exchangeLeads: {
      approved:
        'Approving reserves the requested item for the customer and emails an approval. Write how to send the item back. When the returned item arrives, ship the new one with "Ship exchange".',
      rejected: 'The customer gets an email with the reason. A reason is required.',
      cancelled:
        'Close it if the customer changed their mind; the reserved item goes back on sale. A note is required.',
    },
  },
  launch: {
    title: 'Publication status',
    lead_draft:
      'The store is in preview: the storefront is open with a "preview" notice and hidden from search engines. It can go live once the required items below are complete.',
    lead_live: 'The store is live: the storefront is open to real customers.',
    lead_maintenance:
      'The store is in maintenance: visitors see a maintenance page. The panel and orders keep working.',
    lead_archived:
      'The store is archived: the storefront is closed and the store is listed last. Unarchiving returns it to preview.',
    toArchive: 'Archive',
    unarchive: 'Unarchive',
    dialogTitle_archived: 'Archive store',
    dialogLead_archived:
      'The storefront closes; orders, products and settings are kept. You can unarchive at any time.',
    confirm_archived: 'Archive',
    done_archived: 'Store archived',
    goLive: 'Take the store live',
    toMaintenance: 'Maintenance',
    toDraft: 'Back to preview',
    blocked: '{{count}} required items are missing before going live.',
    noPermission: 'Only the owner and administrators can change the publication status.',
    dialogTitle_live: 'Take the store live',
    dialogLead_live: 'This requires two-step verification and is written to the audit log.',
    dialogTitle_maintenance: 'Put the store into maintenance',
    dialogLead_maintenance:
      'Visitors see a maintenance page (within a minute). Search engines get a temporarily-unavailable response.',
    dialogTitle_draft: 'Back to preview',
    dialogLead_draft:
      'The store goes offline: the storefront opens with a "preview" notice and is hidden from search engines.',
    liveEffect1: 'The "preview" notice disappears; orders placed are real orders.',
    liveEffect2:
      'Card payments in the test environment are not offered; card payments need the live environment.',
    liveEffect3:
      'Opening to search engines is a separate server setting (SITE_INDEXING=on); see the migration guide.',
    confirmText:
      'I have checked prices, payment methods and legal texts; the store will open to real customers.',
    note: 'Note',
    confirm_live: 'Go live',
    confirm_maintenance: 'Start maintenance',
    confirm_draft: 'Back to preview',
    done_live: 'The store is live',
    done_maintenance: 'The store is in maintenance',
    done_draft: 'The store is back in preview',
  },
  readiness: {
    title: 'Go-live checklist',
    lead: 'What the store needs before selling. Each item is checked against real data.',
    progress: '{{done}} of {{total}} done',
    ok: 'Done',
    missing: 'Missing',
    fix: 'Fix',
    goLiveLocked:
      'Once the required items are complete, the store goes live from Stores → store → Publication status with explicit confirmation and two-step verification.',
    items: {
      seller_info: 'Seller details (legal name, address, phone, email)',
      domain: 'Store domain',
      products: 'At least one published product',
      shipping: 'At least one shipping method',
      payment_methods: 'At least one payment method',
      card_live: 'Card payments live',
      etbis: 'ETBİS registration (recommended)',
      legal_published: 'Required legal texts published',
      legal_reviewed: 'Legal texts reviewed by a lawyer',
      legal_languages: 'Legal texts in market languages',
    },
    hints: {
      seller_info: 'Fill in the missing fields on Business Details.',
      domain: 'Add a storefront domain under Stores.',
      products: 'Publish at least one product.',
      shipping: 'Add a shipping method.',
      payment_methods: 'Enable card, bank transfer or cash on delivery.',
      card_live: 'Go live after a successful test payment.',
      etbis: 'Register with the Ministry of Trade ETBİS and enter the verification link on Business Details.',
      legal_published: 'Publish the missing legal texts.',
      legal_reviewed: 'Have a lawyer review the texts and republish marked as reviewed.',
      legal_languages:
        "Some texts aren't published in your markets' languages; visitors in that language see the Turkish text. Add them from the language tab on the Legal texts screen (optional).",
    },
    sellerFields: {
      legalName: 'legal name',
      address: 'address',
      phone: 'phone',
      email: 'email',
    },
  },
  reconcile: {
    title: 'Reconciliation',
    lead: "The provider's transaction report is compared with your payments. With a live connection the previous day is checked automatically every day.",
    done: 'Reconciliation finished',
    date: 'Day',
    run: 'Compare',
    empty: 'No reconciliation yet.',
    issues: '{{count}} differences',
    statuses: {
      running: 'Running',
      ok: 'No differences',
      mismatch: 'Differences',
      error: 'Error',
    },
    view: 'Details',
    detailTitle: 'Reconciliation details',
    summary: '{{local}} payments here, {{remote}} at the provider; {{issues}} differences.',
    kinds: {
      missing_local: 'At provider, missing here',
      missing_provider: 'Here, missing at provider',
      amount_mismatch: 'Amount difference',
      status_mismatch: 'Status difference',
    },
    amounts: 'Here: {{ours}} · Provider: {{theirs}}',
    resolvedNote: 'Closed',
    resolveNote: 'Note',
    resolve: 'Close difference',
  },
  shipping: {
    currency: 'Fee currency',
    currencyMismatch:
      'The store currency is {{currency}}; the method is only offered on orders in its own currency, so it will not show.',
    otherCurrency: '{{currency}} (not shown in the store)',
    countries: 'Destination countries',
    countriesHint:
      'If none is selected the method is offered in every market; otherwise only in the markets of these countries.',
    countriesShort: 'Countries: {{list}}',
    add: 'Add shipping method',
    edit: 'Edit shipping method',
    empty: 'No shipping methods',
    emptyLead: 'Add at least one shipping method for checkout.',
    carriers: {
      yurtici: 'Yurtiçi Kargo',
      aras: 'Aras Kargo',
      mng: 'MNG Kargo (DHL eCommerce)',
      ptt: 'PTT Kargo',
      surat: 'Sürat Kargo',
      hepsijet: 'HepsiJET',
      kolaygelsin: 'Kolay Gelsin',
      ups: 'UPS',
      other: 'Other',
    },
    freeAlways: 'Free',
    byWeight: 'By weight ({{count}} tiers)',
    freeOverShort: 'Free over {{amount}}',
    codShort: 'Cash on delivery',
    audiences: {
      all: 'Everyone',
      retail: 'Retail customers',
      dealers: 'Dealers',
    },
    daysShort: '{{days}} business days',
    statuses: {
      active: 'Active',
      inactive: 'Inactive',
    },
    deleteConfirm: 'Delete this shipping method? Existing orders are not affected.',
    trackingTitle: 'Tracking',
    trackingLead:
      'Enter the tracking number when shipping; the customer sees it in the email and on the order page.',
    carrierApiNote:
      'With Geliver connected, "Ship with Geliver" on the order page gets offers, buys the label and fetches the tracking number automatically. Direct connections to Yurtiçi, Aras and MNG need the carriers\' corporate integration details and IP approval (setup required); until then ship with them through Geliver or enter the tracking number manually.',
    geliver: {
      title: 'Shipping with Geliver',
      lead: 'With your Geliver account, shipments are created from orders, carrier prices are compared and the label is bought in the panel; status and tracking number come from Geliver automatically.',
      notConnected: 'Geliver is not connected (setup required).',
      connect: 'Connect in Integrations',
      test: 'Test environment',
      live: 'Live',
      testNote: 'In the test environment shipments are created in Geliver as test shipments.',
      liveNote: 'In the live environment the label fee is charged to your Geliver balance.',
      sender: 'Sender address',
      senderHint: 'Choose from the addresses defined in Geliver.',
      senderNone: 'Not selected',
      sendersEmpty:
        'The Geliver account has no sender address. Add one in the Geliver dashboard and reload the page.',
      senderDefault: '{{name}} (Geliver default)',
      length: 'Length (cm)',
      width: 'Width (cm)',
      height: 'Height (cm)',
      parcel: 'Default parcel size',
      defaultWeight: 'Default weight (g)',
      defaultWeightHint: 'Used for lines whose product has no weight.',
    },
    name: 'Name',
    nameHint: 'Shown to customers (e.g. Standard shipping).',
    carrier: 'Carrier',
    audience: 'Audience',
    rateType: 'Rate type',
    rateTypes: {
      flat: 'Flat rate',
      weight: 'By weight',
    },
    price: 'Price (₺, tax incl.)',
    priceHint: 'Enter 0 for free shipping.',
    tiers: 'Weight tiers',
    tiersHint: 'Each row: the price for carts up to that weight (grams). Sort ascending.',
    upToGrams: 'Up to (grams)',
    addTier: 'Add tier',
    freeOver: 'Free shipping over (₺)',
    estimatedDays: 'Estimated delivery (business days)',
    estimatedDaysHint: 'e.g. 1-3',
    handlingDays: 'Handling time (business days)',
    transitDays: 'Transit time (business days)',
    daysMin: 'Min',
    daysMax: 'Max',
    status: 'Status',
    codAvailable: 'Cash on delivery available',
    codAvailableHint: 'Offered with this method (if cash on delivery is on).',
  },
  brokenLinks: {
    collect: 'Collect old addresses from archive',
    collected:
      '{{found}} addresses found in the archive: {{matched}} new matches, {{table}} already listed, {{fallback}} without counterpart (sent to a safe page).',
    collectFailed: 'The archive could not be reached: {{hosts}}. Try again later.',
    storeHost: 'Store domain',
    foundVia: 'Found via',
    emptyLead: 'Addresses that return 404 or old addresses without a counterpart appear here.',
    fallback: 'No counterpart found; visitors are sent with 301 to: {{to}}',
    shown404: 'The storefront shows "page not found" (404)',
    notVisited: 'No visits yet · added: {{date}}',
    via: {
      request: 'Visit',
      archive: 'Archive',
      search_console: 'Search Console',
    },
    kinds: {
      product: 'Product',
      category: 'Category',
      shop: 'Shop',
      blog: 'Articles',
      post: 'Article',
      page: 'Page',
      asset: 'File',
      home: 'Home page',
    },
  },
  redirects: {
    goneTarget: 'Permanently removed (no redirect)',
    gone: 'Permanently removed (410)',
    goneLead:
      'No redirect is made; visitors see a "page removed" page and search engines get 410, removing the address from the index. Prefer 301 if a similar page exists.',
    goneSaved: 'Address marked as permanently removed',
    goneConfirm: 'Return 410 (permanently removed) for "{{path}}"? Search engines will drop this address.',
    notFoundTitle: 'Addresses not found',
    notFoundLead:
      'Storefront addresses returning 404 and old addresses sent to a safe page because no counterpart was found, most seen first. Add the right redirect, return 410 or ignore them. Only the domain and path are stored (no IP or query string).',
    notFoundFilter: 'Show',
    notFoundOpen: 'Pending',
    notFoundIgnored: 'Ignored',
    notFoundEmpty: 'No addresses not found.',
    notFoundIgnoredEmpty: 'No ignored addresses.',
    notFoundHits: 'Seen {{count}} times · last: {{date}}',
    notFoundRedirect: 'Redirect',
    notFoundGone: 'Return 410',
    notFoundIgnore: 'Ignore',
    notFoundReopen: 'Restore',
    notFoundMore: 'Showing the {{shown}} most seen addresses ({{total}} total).',
    add: 'Add redirect',
    edit: 'Edit redirect',
    import: 'Import from file',
    search: 'Search addresses',
    empty: 'No redirects yet',
    emptyLead:
      "Point the old site's addresses to the new ones so Google rankings and saved links are kept. A redirect is added automatically when a product or category address changes.",
    noMatch: 'No redirect matches the search',
    from: 'Old address',
    to: 'New address',
    code: 'Redirect type',
    permanent: '301 — permanent (recommended)',
    temporary: '302 — temporary',
    note: 'Note',
    saved: 'Redirect saved',
    dialogLead:
      'The old address must be a path starting with "/" (a full URL is reduced to its path). The new address can be a path on this site or a full https:// address.',
    deleteConfirm: 'Delete the redirect for {{path}}? Visitors to that address will see page not found.',
    hits: 'Used {{count}} times · last {{date}}',
    noHits: 'Not used yet',
    range: '{{from}}–{{to}} of {{total}}',
    sources: {
      manual: 'Manual',
      import: 'Import',
      auto: 'Automatic',
      match: 'Match',
    },
    importTitle: 'Import redirect list',
    importLead:
      'CSV or Excel file: old address, new address, optional code (301/302) and note columns. It is previewed first; if any row has an error, nothing is saved. Existing old addresses are updated. An optional "domain" column limits a rule to one old domain.',
    chooseFile: 'Choose file and preview',
    apply: 'Import',
    previewSummary:
      '{{total}} rows: {{create}} new, {{update}} to update, {{unchanged}} unchanged, {{errors}} with errors.',
    errorLine: 'Row {{line}}',
    imported: '{{created}} redirects added, {{updated}} updated',
    howTitle: 'How it works',
    howLead: 'The storefront checks this list on every page request (changes apply within a minute).',
    how1: 'Matching ignores letter case and a trailing "/"; "/uyeol/" and "/uyeol" are the same. Query strings (?...) are ignored.',
    how2: 'Chains are collapsed (A→B and B→C send A straight to C); a record that creates a loop is not applied.',
    how3: 'The usage count shows whether an old address still gets traffic; records unused for months can be deleted.',
    allHosts: 'All domains',
    host: 'Source domain',
    filterSource: 'Source',
    filterHost: 'Domain',
    anySource: 'All',
    anyHost: 'All',
    matchScore: 'similarity {{score}}%',
    shadowTitle: "{{count}} rules hiding the store's own pages",
    shadowLead:
      'These addresses are real storefront pages (e.g. Sales points, Articles, Needs finder, a live product or category). Because of the rule, visitors are redirected instead of seeing the page. Delete the rule to show the page.',
    shadowDelete: 'Delete rule',
    how4: 'Every request to an old domain (e.g. zootopiaglobal.com) — http or https, with or without www — goes to its final address in one 301 step based on this list.',
    how5: 'For an old address not in the list the system finds the counterpart: a confident match is added as "Match"; otherwise the visitor is sent to the species category, all products or the home page and the address is listed in:',
    matchKinds: {
      product: 'product',
      category: 'category',
      category_species: 'species category',
      shop: 'all products',
      blog: 'articles',
      post: 'article',
      page: 'page',
    },
  },
  legal: {
    lawyerNote:
      'These texts are written by you or your lawyer; the system does not generate legal content. Have them reviewed before publishing.',
    kinds: {
      kvkk_notice: 'Privacy notice (KVKK)',
      membership_terms: 'Membership terms',
      pre_information: 'Pre-information form',
      distance_sales: 'Distance sales contract',
      return_policy: 'Returns and withdrawal',
      privacy_policy: 'Privacy policy',
      cookie_policy: 'Cookie policy',
    },
    required: '(required to go live)',
    publishedVersion: 'Version {{version}} · published {{date}}',
    notPublished: 'Not published',
    templated: 'Filled in at checkout',
    reviewed: 'Legally reviewed',
    notReviewed: 'Review not declared',
    hasDraft: 'Draft',
    write: 'Write',
    draftSaved: 'Draft saved',
    published: 'New version published',
    templatedLead:
      'This text is filled with seller, buyer, product and total details at checkout. Required variables: seller name, buyer name, products, total.',
    plainLead: 'This text is published on its own storefront page; seller variables are filled in.',
    discardConfirm: 'Delete the draft? The published version is not affected.',
    discard: 'Delete draft',
    saveDraft: 'Save draft',
    publish: 'Publish',
    title: 'Title',
    variables: 'Variables',
    insertVariable: 'Insert at cursor',
    body: 'Text',
    bodyHint: 'Plain text; separate paragraphs with a blank line.',
    reviewedAck: 'This text was reviewed by my lawyer/legal adviser.',
    saveBeforePublish: 'Save the draft before publishing.',
    history: 'Version history',
    versionLabel: 'Version {{version}}',
    statuses: {
      published: 'Published',
      retired: 'Archived',
      draft: 'Draft',
    },
    view: 'View',
    languages: 'Language versions',
    languageGaps:
      "Some required texts aren't published in your open markets' languages (visitors in that language see the Turkish text; this doesn't block going live):",
    langPublished: 'live, version {{version}}',
    language: 'Language',
    primaryLanguage: 'primary',
    marketLanguage: 'market language',
    copyTurkish: 'Start from the Turkish text',
    translationNote:
      'The {{language}} version is a translation of the Turkish text. Have your lawyer review the translation too; the legal review declaration is given separately for this language. Until a version is published in this language, visitors see the Turkish text.',
    switchLanguageConfirm: 'Unsaved changes will be lost. Switch language?',
  },
  invoices: {
    providerCancelStates: {
      required: 'To be cancelled in BizimHesap',
      failed: 'BizimHesap cancellation failed',
      uncertain: 'BizimHesap cancellation uncertain',
      return_required: 'E-document issued: return invoice needed',
      done: 'Cancelled in BizimHesap',
    },
    providerCancelResult: {
      done: 'Invoice cancelled in BizimHesap.',
      failed: 'BizimHesap rejected the cancellation; the error is on the invoice.',
      uncertain:
        'BizimHesap did not respond: the cancellation may exist. Check the BizimHesap panel and mark it.',
    },
    cancelAtProvider: 'Cancel in BizimHesap',
    resolveProviderCancel: 'Mark cancellation',
    returnDone: 'Return invoice issued',
    returnLead:
      'The invoice has an official e-document number: it is not cancelled in BizimHesap, a return invoice is issued instead (pending accountant confirmation). Mark it here after issuing the return invoice.',
    providerResolveLead: 'Check in the BizimHesap panel whether the invoice was cancelled.',
    providerOutcomes: { done: 'Cancelled', not_done: 'Not cancelled (can retry)' },
    sendResult: {
      sent: 'Invoice sent to BizimHesap',
      failed: 'Invoice could not be sent',
      uncertain: 'Connection lost: invoice uncertain',
      draft: 'Saved',
      sending: 'Sending',
      cancelled: 'Cancelled',
    },
    bhTarget: 'BizimHesap account {{code}} · cash account {{cash}}',
    bhNoCash: 'none (receivable)',
    resend: 'Send again',
    send: 'Send',
    resolve: 'I checked',
    markCancelled: 'Mark as cancelled',
    resolveTitle: 'Record uncertain invoice',
    cancelTitle: 'Mark invoice as cancelled',
    resolveLead: 'Check in BizimHesap whether the invoice for this order was created.',
    cancelLead: 'This only cancels the record here. Cancel the BizimHesap invoice/e-Archive in BizimHesap.',
    outcome: 'Result',
    outcomes: {
      sent: 'Invoice was created',
      not_sent: 'Invoice was not created',
    },
    number: 'Invoice number',
    note: 'Note',
    status: 'Status',
    statuses: {
      draft: 'Draft',
      sending: 'Sending',
      sent: 'Sent',
      failed: 'Failed',
      uncertain: 'Uncertain',
      cancelled: 'Cancelled',
    },
    empty: 'No invoices yet',
    emptyLead: 'Invoices are created from the order details.',
    providers: {
      bizimhesap: 'BizimHesap',
      manual: 'Manual (issued elsewhere)',
    },
    kinds: {
      e_arsiv: 'e-Archive',
      e_fatura: 'e-Invoice',
      unknown: 'Not specified',
    },
    open: 'Open invoice',
    bizimhesapNote:
      'The BizimHesap API creates the invoice as a record; converting to e-Archive/e-Invoice is done in BizimHesap.',
    bizimhesapLead:
      'Lines and totals match the order exactly; sending is a separate step. Connect BizimHesap on the Integrations screen.',
    manualLead: 'If you issued the invoice in another program, record its number.',
    provider: 'Source',
    kind: 'Type',
  },
  pageDesigns: {
    published: '{{experience}}: design {{variant}} is live.',
    option: '{{letter}} — {{name}}',
    live: 'Live',
    preview: 'Preview',
    previewOf: 'Preview {{name}}',
    publish: 'Publish',
    publishOf: 'Publish {{name}}',
    shotDesktop: '{{name}}: desktop view',
    shotMobile: '{{name}}: mobile view',
    history: 'Change history',
    historyLead: 'Who switched which option to which, and when (from the audit log).',
    noHistory: 'No changes yet; all experiences use option A.',
    colWhen: 'Date',
    colWho: 'Person',
    colWhat: 'Experience',
    colChange: 'Change',
    change: '{{from}} → {{to}}',
    experiences: {
      header: {
        title: 'Top menu',
        lead: 'The header on every storefront page: logo, menu items (Menus), search, Sign in and Cart; a drawer menu on mobile.',
      },
      articles: {
        title: 'Articles',
        lead: 'Blog list, category and archive pages: featured post, categories, reading time and search. The article page is the same in every option.',
      },
      store_locator: {
        title: 'Store locator',
        lead: 'The storefront page listing approved dealers: filter by province, district and neighbourhood, "Use my location", map and province/district pages.',
      },
      needs_finder: {
        title: "My Pet's Needs",
        lead: "Question flow and suggested care routine for the visitor's pet (/ihtiyac-bulucu). Questions, rules and results are the same in all three options.",
      },
    },
    variants: {
      header: {
        a: {
          name: 'Classic horizontal',
          character:
            'Logo, search and cart on top, menu items in a horizontal row; the familiar shop layout, fastest to scan.',
        },
        b: {
          name: 'Centred logo',
          character: 'Large brand name in the centre, menu centred below; a calm, boutique welcome.',
        },
        c: {
          name: 'Compact and visual',
          character:
            'A slim single row; Products opens with illustrated species tiles, leaving more room for content.',
        },
      },
      articles: {
        a: {
          name: 'Magazine',
          character: 'Large featured post and category strips; content shown like a shop window.',
        },
        b: {
          name: 'Card grid',
          character: 'Equal cards and filter chips; quick choice among many posts.',
        },
        c: {
          name: 'Reading list',
          character: 'Type-first simple list with small images; focused on reading.',
        },
      },
      store_locator: {
        a: {
          name: 'Map first',
          character: 'Filters and list on one side, province map on the other; browse both together.',
        },
        b: {
          name: 'List first',
          character: 'A single filter row above a grid of cards; the map is optional.',
        },
        c: {
          name: 'Region guide',
          character:
            'A province and district directory with a page per region; suits visitors from search engines.',
        },
      },
      needs_finder: {
        a: {
          name: 'Cards',
          character:
            'Each step on its own screen with large cards; progress on top, Back / Continue below. The easiest flow on phones.',
        },
        b: {
          name: 'Chat',
          character:
            'Questions arrive one by one in chat bubbles, answers are given with chips; every answer can be changed. The questions are fixed; there is no AI.',
        },
        c: {
          name: 'Single page + live summary',
          character:
            'All questions on one page; the routine summary next to them updates as you answer. Suited to comparing on wide screens.',
        },
      },
    },
  },
  needsFinder: {
    editor: 'Needs finder editor',
    startTitle: "My Pet's Needs is not set up yet",
    startLead:
      'Visitors choose their species, basics and support areas; fixed rules suggest a care routine from suitable products. You can create the first draft from your product data or start empty. The draft cannot go live without veterinary expert approval.',
    generate: 'Create the first draft from product data',
    startEmpty: 'Start with an empty draft',
    generated: 'Draft created from product data. Review the texts and rules.',
    noDraft: 'No draft yet. Someone with content editing permission can create one.',
    save: 'Save draft',
    saved: 'Draft saved.',
    unsaved: 'There are unsaved changes.',
    discard: 'Discard changes',
    saveErrors: 'The draft could not be saved; fix the following:',
    saveFirst: 'Save the draft first.',
    statusTitle: 'Status and publishing',
    statusLead:
      'Draft → submit for review → veterinary expert approval → publish. If the draft changes after approval, the approval lapses; the storefront keeps showing the approved live version.',
    review: {
      not_submitted: 'Not submitted for review',
      pending: 'In expert review',
      approved: 'Approved by expert',
      rejected: 'Rejected by expert',
    },
    live: 'Live on the storefront',
    notLive: 'Not live on the storefront',
    liveDiffers: 'Draft differs from the live version',
    publishedAt: 'Last published: {{date}}',
    generatedNote:
      'This draft was generated from product data: areas from categories, rules from products. Review the reason texts, the emergency question and the exclusions with the expert.',
    reviewNote: 'Expert note: {{note}}',
    problemsTitle: 'Checklist',
    problems: {
      no_areas: 'No support areas (blocks publishing).',
      no_rules: 'No recommendation rules (blocks publishing).',
      no_emergency_option: 'No question has an emergency option (blocks publishing).',
      area_without_rules: 'The “{{ref}}” area has no rules; visitors choosing it get no products.',
      product_hidden:
        '{{product}} is not visible on the storefront (draft, hidden, not listed in the store or no veterinary approval); it will not be suggested.',
      product_species_mismatch: '{{product}} does not match the rule’s species; it will never be suggested.',
      product_no_species: '{{product}} has no target species; it will never be suggested.',
      bundle_promotion_not_running:
        'The linked bundle promotion is not running; it is not shown on the storefront.',
    },
    submit: 'Submit for review',
    submitted: 'Draft submitted for expert review.',
    publish: 'Publish',
    publishedToast: "My Pet's Needs is live on the storefront.",
    unpublish: 'Unpublish',
    unpublishedToast: 'Removed from the storefront.',
    unpublishTitle: 'Unpublish?',
    unpublishLead:
      'The storefront page closes and the default header link is removed. The draft and the expert approval are kept; you can publish again.',
    regenerate: 'Regenerate draft',
    regenerateTitle: 'Regenerate the draft?',
    regenerateLead:
      'A new draft from product data replaces the current one; your edits and the expert approval are lost. The live version does not change.',
    petProfiles: 'Save my pet (members)',
    petProfilesLead:
      "When on, members can save their pet's basics to their account with explicit consent. Do not turn on before the consent text has passed legal review. Answers to health questions are not saved.",
    reviewTitle: 'Veterinary expert review',
    reviewLead:
      'The expert reviews the questions, reason texts and the full list of products that may be suggested. The decision applies to the content on screen.',
    findings: 'The health claim check found {{count}} expressions',
    productsTitle: 'Products that may be suggested',
    colProduct: 'Product',
    colSpecies: 'Species',
    colReasons: 'Reason',
    colState: 'Status',
    visible: 'Visible on the storefront',
    hidden: 'Not visible on the storefront',
    noUsage: 'No usage text',
    reviewNoteLabel: 'Expert note',
    approve: 'Approve',
    reject: 'Reject',
    decided: 'Decision saved.',
    waitingExpert: 'Waiting for the veterinary expert reviewer’s decision.',
    otherLanguages: 'Other languages',
    lang: {
      en: 'English',
      de: 'German',
      ar: 'Arabic',
    },
    condition: 'Condition',
    conditionLead:
      'Every section you fill in must match; within a section, one of the ticked values is enough. If you choose nothing, it always applies.',
    cond: {
      species: 'Species',
      ages: 'Age',
      weights: 'Weight',
      neutered: 'Neutered',
      any: 'Any',
      reproductive: 'Pregnant / nursing',
      areas: 'Support area',
      answer: 'Answer to a question',
      noAnswer: 'Do not check an answer',
      answerOptions: 'One of these answers',
    },
    always: 'Always',
    moveUp: '{{name}}: move up',
    moveDown: '{{name}}: move down',
    edit: '{{name}}: edit',
    delete: '{{name}}: delete',
    deleteTitle: 'Delete?',
    deleteLead: 'The item is removed from the draft; until you save, you can undo it with “Discard changes”.',
    apply: 'Apply',
    tabs: {
      areas: 'Support areas',
      questions: 'Questions',
      rules: 'Recommendation rules',
      exclusions: 'Exclusions',
      texts: 'Texts',
      preview: 'Preview',
      report: 'Report',
    },
    areasLead: 'Topics the visitor chooses (e.g. joints, skin and coat). Shown only for the ticked species.',
    rulesCount: '{{count}} rules',
    addArea: 'Add area',
    noAreas: 'No support areas yet.',
    areaDialog: 'Support area',
    areaLabel: 'Area name',
    areaDescription: 'Short description',
    areaSpecies: 'Shown for species',
    areaCategories: 'Related categories',
    id: 'ID',
    idLead: 'Short name used in rules (lowercase letters, digits, hyphens). Do not change it after saving.',
    questionsLead:
      'Questions are asked in this order. A question linked to an area is asked only when that area is chosen; a conditional question only when its condition matches (branching).',
    general: 'General (every visitor)',
    optionsCount: '{{count}} options',
    hasEmergency: 'Has an emergency option',
    askedWhen: 'Asked when: {{condition}}',
    defaultYes: 'Yes',
    defaultNo: 'No',
    addQuestion: 'Add question',
    noQuestions: 'No questions yet. At least one question needs an emergency option.',
    questionDialog: 'Question',
    questionText: 'Question text',
    questionHelp: 'Help text',
    questionArea: 'Linked area',
    questionMultiple: 'More than one option can be chosen',
    askWhen: 'When should it be asked? (branching)',
    options: 'Options',
    optionLabel: 'Option {{n}}',
    optionEmergency: 'Emergency (no products, refer to a veterinarian)',
    optionExclusive: 'Chosen on its own ("None")',
    addOption: 'Add option',
    rulesLead:
      'If the condition matches, the product is suggested with its approved reason. A product that does not suit the chosen species is never suggested. If it is out of stock, the next alternative is shown.',
    unsavedProduct: 'Product (name appears after saving)',
    priorityValue: 'Priority {{n}}',
    alternativesCount: '{{count}} alternatives',
    addRule: 'Add rule',
    noRules: 'No rules yet.',
    ruleDialog: 'Recommendation rule',
    ruleProduct: 'Suggested product',
    ruleReason: 'Why it is suggested (shown on the storefront)',
    rulePriority: 'Priority (0–100)',
    rulePriorityLead: 'Higher-priority suggestions come first in the list.',
    ruleAlternatives: 'Alternatives when out of stock (in order, up to 5)',
    exclusionsLead:
      'If the condition matches, the listed products are not suggested by any rule (e.g. those unsuitable during pregnancy). Exclusions always take precedence.',
    addExclusion: 'Add exclusion',
    noExclusions: 'No exclusions yet.',
    exclusionDialog: 'Exclusion',
    exclusionProducts: 'Products not to suggest',
    exclusionNote: 'Note (in the panel)',
    textsLead: 'The page intro, the emergency text and the optional bundle promotion.',
    intro: 'Intro text',
    emergencyText: 'Emergency text',
    bundle: 'Needs bundle promotion',
    bundleLead:
      'Optional; off by default. If the linked automatic promotion is running, its name and condition are shown in the result; the cart calculates the discount.',
    bundleOff: 'No promotion',
    bundleLinked: 'A promotion is linked',
    previewLead:
      "Same calculation as the storefront's rule engine. Choose a visitor's answers to see which products appear with which reasons and which are removed and why.",
    previewResult: 'Result',
    removedTitle: 'Removed products',
    removed: {
      excluded: 'exclusion rule',
      species: 'not suitable for the chosen species',
      unavailable: 'not visible on the storefront',
    },
    previewNote:
      'The preview uses saved product information and ignores stock; newly added products appear after the draft is saved.',
    emergencyShort: 'emergency',
    reportLead:
      'Totals only: how many visitors started, completed, chose an emergency, added everything to the cart. No visitor identity or answers are stored.',
    reportDays: 'Period',
    lastDays: 'Last {{n}} days',
    reportEmpty: 'No records in this period.',
    metrics: {
      starts: 'Started',
      completes: 'Completed',
      emergencies: 'Emergency',
      addAll: 'Added all to cart',
      rate: 'Completion rate',
    },
    bySpecies: 'By species',
    reportPrivacy:
      'The counters contain no personal data; tracking tags (GA4/GTM) receive events only with cookie consent.',
  },
  salesPoints: {
    sectionTitle: 'Store listing',
    sectionLead:
      "Business details shown on the storefront Store locator page. The contact person's name and mobile number are never shown automatically.",
    add: 'Add store listing',
    edit: 'Edit store listing',
    saved: 'Store listing saved.',
    deleted: 'Store listing deleted.',
    confirmDelete: 'Delete the store listing "{{name}}"? The dealer record does not change.',
    empty: 'This dealer has no store listing',
    emptyLead: 'Once added, it appears on the Store locator page (if the dealer is approved).',
    fromLocation: 'Add from location:',
    addFromLocation: '{{label}}',
    personNameNote:
      "This dealer's legal name may be a person's name. Enter the shop or business name as the display name, or hide the listing (privacy law).",
    notApprovedNote:
      'The dealer is not approved, so its listings are not shown; they appear automatically once approved.',
    shown: 'Shown',
    hidden: 'Hidden',
    visible: 'Show on storefront',
    name: 'Display name',
    nameLead: "Shop or business name. Do not enter a person's name.",
    neighbourhood: 'Neighbourhood',
    chooseNeighbourhood: 'Choose a neighbourhood',
    addressLine: 'Street and number',
    pin: 'Location (map pin)',
    pinLead:
      'Find the place in Google Maps, right-click to copy the coordinates and paste them here (a link works too). Without a pin the listing is not sorted by distance.',
    pinRead: 'Location read: {{lat}}, {{lng}}',
    pinInvalid:
      'Could not read the location. Paste coordinates like "41.0082, 28.9784" or a Google Maps link.',
    findOnMaps: 'Open the address in Google Maps',
    phone: 'Storefront phone',
    phoneLead:
      "The business number visitors will call. Enter the contact person's mobile only with their consent.",
    hours: 'Opening hours',
    days: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday',
    },
    dayMode: '{{day}}: status',
    dayUnknown: 'Not specified',
    dayOpen: 'Open',
    dayClosed: 'Closed',
    opens: '{{day}}: opens',
    closes: '{{day}}: closes',
    note: 'Note (shown on storefront)',
    warnings: {
      no_pin: 'No pin',
      no_phone: 'No phone',
      person_name: "May be a person's name",
      company_not_approved: 'Dealer not approved',
      address_missing: 'Address missing',
      geocode_not_found: 'Address not found on the map',
      geocode_mismatch: 'Address points elsewhere',
      geocode_approximate: 'Approximate location',
    },
    settings: 'Automatic listing',
    autoAdd: 'List newly approved dealers as stores',
    autoAddLead:
      "When a dealer is approved, listings are created from its locations (without the contact's name or phone). Dealers whose legal name may be a person's name are also added visible with a \"may be a person's name\" warning; check the display name. Listings of suspended dealers are hidden automatically.",
    autoAddOn: 'Newly approved dealers will be listed as stores.',
    autoAddOff: 'Newly approved dealers will not be listed as stores.',
    geocode: 'Find location from address (OpenStreetMap)',
    geocodeLead:
      'Listings without a manual pin are located from their address; on the storefront "Use my location" sorts the nearest listings by this location. If the address points elsewhere or cannot be found, a warning appears on the dealer card. Only the business address is sent.',
    geocodeOn: 'Locations will be found from addresses.',
    geocodeOff: 'Locations will not be found from addresses; only manual pins are used.',
    backfill: 'Create from approved dealers',
    backfillDone:
      '{{created}} listings added ({{companies}} dealers). Dealers with an unrecognised address: {{skipped}}.',
    backfillSkipped:
      'No listing could be created for these dealers because their province/district was not recognised:',
    geocodeNow: 'Find locations now',
    geocodeNowRunning: 'Looking up addresses…',
    geocodeNowDone: '{{checked}} addresses looked up: {{found}} located, {{problems}} with problems.',
    geocodeNowNone: 'No listing is waiting for a location.',
    geocodeOne: 'Find location from address',
    geocodeResult: {
      ok: 'Location found and pin saved.',
      approximate: 'Approximate location found (neighbourhood level); pin saved.',
      not_found: 'Address not found on the map; check the address or enter the pin manually.',
      mismatch: 'The address points elsewhere ({{place}}); pin not saved.',
      error: 'The location service could not be reached; it will be retried shortly.',
    },
    pinSource: {
      manual: 'Location: entered manually',
      geocoded: 'Location: found from address (OpenStreetMap)',
      none: 'Location: none',
    },
    mismatchFound: 'found: {{place}}',
    missing: {
      no_address:
        'This dealer has no address; no listing could be created. Add a location or company address.',
      address_unknown:
        "This dealer's province/district is not in the official list; no listing could be created. Fix the address or add the listing manually.",
    },
    listTitle: 'Store listings',
    listLead:
      'Edit listing details on the dealer page. Only listings marked "Shown" with an approved dealer appear on the storefront.',
    allCities: 'All provinces',
    visibility: 'Storefront status',
    bulkShow: 'Show selected ({{count}})',
    bulkHide: 'Hide selected ({{count}})',
    bulkDone: '{{count}} store listings updated.',
    selectAll: 'Select all',
    selectOne: 'Select store listing {{name}}',
    none: 'No store listings',
    noneLead:
      'Add them from the dealer page; with automatic listing on, newly approved dealers are added automatically.',
    colName: 'Display name',
    colPlace: 'District/Province',
    colDealer: 'Dealer',
    colStatus: 'Status',
  },
  design: {
    saved: 'Theme draft saved.',
    published: 'Theme published. It appears on the storefront within a minute.',
    discarded: 'Unpublished changes discarded.',
    rolledBack: 'The selected version was published again.',
    preview: 'Preview on storefront',
    previewBlocked: 'The browser blocked the new tab. Copy and open the link:',
    save: 'Save draft',
    publish: 'Publish',
    unsaved: 'You have unsaved changes.',
    revertLocal: 'Discard my changes',
    discard: 'Revert to the live theme',
    discardConfirm:
      'Unpublished draft changes will be deleted and the draft returns to the live version ({{version}}). Continue?',
    editor: 'Theme settings',
    liveVersion: 'Live: version {{version}} · {{date}}',
    noLiveTheme: 'No published theme (default look)',
    unpublished: 'Unpublished changes',
    issuesCount: '{{count}} readability issues',
    templates: 'Templates',
    templatesLead:
      'Changes colours, fonts and layout together. The chosen template only shows in the preview until you save.',
    templatePick: 'Choose a template',
    templateNames: {
      clinic: 'Clinic',
      natural: 'Natural',
      modern: 'Modern',
      classic: 'Classic',
    },
    colors: 'Colours',
    colorsLead:
      'Start from a ready palette and adjust colours one by one. Unreadable colour pairs are listed under the preview.',
    palettes: 'Ready palettes',
    paletteNames: {
      pine: 'Pine',
      ocean: 'Ocean',
      forest: 'Forest',
      amber: 'Amber',
      plum: 'Plum',
      ink: 'Ink',
    },
    lightColors: 'Light colours',
    darkColors: 'Dark colours',
    darkMode: 'Use dark colours when the device is in dark mode',
    colorNames: {
      background: 'Background',
      surface: 'Card and field background',
      text: 'Text',
      mutedText: 'Secondary text',
      border: 'Lines and borders',
      primary: 'Primary (links)',
      secondary: 'Secondary',
      accent: 'Accent',
      button: 'Button',
      buttonText: 'Button text',
      buttonHover: 'Button (hover)',
    },
    typography: 'Type',
    typographyLead: 'Fonts are served with the storefront; visitors do not need them installed.',
    bodyFont: 'Body font',
    headingFont: 'Heading font',
    fontKinds: {
      sans: 'sans-serif',
      serif: 'serif',
    },
    baseSize: 'Body text size',
    px: '{{value}} px',
    headingScale: 'Heading sizes',
    headingScales: {
      compact: 'Small',
      normal: 'Medium',
      large: 'Large',
    },
    headingWeight: 'Heading weight',
    weights: {
      w500: 'Medium',
      w600: 'Semibold',
      w700: 'Bold',
    },
    shape: 'Shape',
    shapeLead: 'Corner radius and shadow apply to cards, fields and buttons.',
    radius: 'Corner radius',
    buttonShape: 'Button shape',
    buttonShapes: {
      square: 'Square',
      rounded: 'Rounded',
      pill: 'Pill',
    },
    shadow: 'Shadow',
    shadows: {
      none: 'None',
      soft: 'Soft',
      strong: 'Strong',
    },
    layout: 'Layout',
    layoutLead: 'Product cards, header and footer, product page and form fields.',
    cardStyle: 'Product card',
    cardStyles: {
      bordered: 'Bordered',
      flat: 'Flat',
      raised: 'Raised',
    },
    imageRatio: 'Product image ratio',
    imageRatios: {
      square: 'Square (1:1)',
      portrait: 'Portrait (4:5)',
      landscape: 'Landscape (4:3)',
    },
    gridDesktop: 'Columns on desktop',
    gridMobile: 'Columns on phones',
    columns: '{{count}} columns',
    headerLayout: 'Logo position',
    headerLayoutMoved: 'The layout of the top menu and logo is now chosen under',
    headerLayouts: {
      start: 'Left',
      center: 'Centre',
    },
    headerStyle: 'Header background',
    headerStyles: {
      surface: 'Light',
      brand: 'Primary colour',
    },
    headerSticky: 'Keep the header on top while scrolling',
    footerStyle: 'Footer background',
    footerStyles: {
      surface: 'Light',
      dark: 'Dark',
      brand: 'Primary colour',
    },
    gallery: 'Product page image',
    galleryPositions: {
      start: 'Left',
      end: 'Right',
    },
    blogLayout: 'Blog page',
    blogLayouts: {
      grid: 'Grid',
      list: 'List',
    },
    inputStyle: 'Form fields',
    inputStyles: {
      outline: 'Outlined',
      filled: 'Filled',
    },
    livePreview: 'Live preview',
    device: 'Device',
    devices: {
      phone: 'Phone',
      tablet: 'Tablet',
      desktop: 'Desktop',
    },
    scheme: 'Appearance',
    schemes: {
      light: 'Light',
      dark: 'Dark',
    },
    mock: {
      store: 'Store name',
      search: 'Search products',
      account: 'My account',
      cart: 'Cart',
      heading: 'Sample heading',
      lead: 'The intro paragraph uses the secondary text colour.',
      body: 'Body text uses the chosen font and size;',
      link: 'links use the primary colour.',
      primaryButton: 'Primary button',
      secondaryButton: 'Secondary button',
      secondaryTag: 'Secondary',
      accentTag: 'Accent',
      products: 'Products',
      product: 'Product name',
      price: 'Price',
      field: 'Form field',
      placeholder: 'Sample input',
      fieldHelp: 'Field help uses the secondary text colour.',
      footer: 'Footer',
    },
    contrastOk: 'All colour pairs are readable (WCAG AA).',
    contrastTitle: 'These colour pairs are not readable enough; the theme cannot be published until fixed:',
    contrastIssue: '{{palette}} appearance: {{fg}} / {{bg}} — {{ratio}}:1 (at least {{min}}:1)',
    versions: 'Version history',
    versionsLead:
      'Each publish is stored as an immutable version. Going back also publishes a new version; history is never deleted.',
    noVersions: 'No published versions yet.',
    versionNo: 'Version {{version}}',
    restoredFrom: 'Restored version {{version}}',
    current: 'Live',
    rollback: 'Go back to this version',
    rollbackConfirm:
      'Version {{version}} will be published again and the draft set to it. Unsaved draft changes are deleted. Continue?',
    publishTitle: 'Publish theme',
    publishLead:
      'Visitors see the new look within a minute. You can go back to a previous version at any time.',
    publishConfirm: 'Publish',
    publishSavesFirst: 'Unsaved changes will be saved first.',
    note: 'Version note',
  },
  menus: {
    save: 'Save menu',
    startFrom: 'Start from another language',
    loadDraft: 'Load draft',
    draftLoaded: 'Draft menu loaded; translate the labels and save.',
    draftDropped: 'Links without a counterpart in this language were removed: {{labels}}',
    draftEmpty: 'The {{lang}} menu is empty; nothing to load.',
    saved: 'Menu saved. It appears on the storefront within a minute.',
    unsaved: 'Unsaved changes',
    location: 'Menu location',
    locations: {
      header: 'Header menu',
      footer: 'Footer menu',
    },
    locationLead: {
      header:
        'The header menu appears below the storefront header. An item with sub-items opens a mega menu: level two are column headings, level three are links.',
      footer:
        'In the footer menu, level one is a column heading and level two its links. Links without sub-items are grouped under "Links".',
    },
    empty: 'This menu has no items yet',
    emptyLead: {
      header: 'While empty, the storefront header shows "Products", "Store locator" and "Articles" links.',
      footer: 'While empty, the footer shows seller details, customer service and legal texts.',
    },
    add: 'Add item',
    addChild: 'Add sub-item',
    newItem: 'New item',
    label: 'Name shown in the menu',
    link: 'Link',
    linkTypes: {
      none: 'Heading without link',
      category: 'Category',
      product: 'Product',
      products: 'All products',
      page: 'Page',
      blog: 'Articles (blog)',
      post: 'Blog post',
      url: 'Address',
    },
    category: 'Category',
    chooseCategory: 'Choose a category',
    page: 'Page',
    choosePage: 'Choose a page',
    post: 'Post',
    choosePost: 'Choose a post',
    blogLead: 'Goes to the storefront Articles page (/blog).',
    notLivePage: '{{name}} (not live)',
    hiddenCategory: '{{name}} (hidden)',
    product: 'Product',
    productSearch: 'Product name, SKU or barcode',
    productPicked: 'Selected product: {{title}}',
    productNone: 'No product selected yet.',
    url: 'Address',
    newTab: 'Open in a new tab',
    noneLead: 'A heading without a link only groups its sub-items.',
    productsLead: 'Goes to the all products page.',
    unavailable: 'Target not visible on the storefront',
    moveUp: 'Move {{label}} up',
    moveDown: 'Move {{label}} down',
  },
  editor: {
    toolbar: 'Text formatting',
    paragraph: 'Paragraph',
    heading2: 'Heading',
    heading3: 'Subheading',
    bold: 'Bold',
    italic: 'Italic',
    bulletList: 'Bulleted list',
    orderedList: 'Numbered list',
    blockquote: 'Quote',
    rule: 'Divider',
    link: 'Add link',
    unlink: 'Remove link',
    image: 'Add image',
    undo: 'Undo',
    redo: 'Redo',
    moveUp: 'Move selected block up',
    moveDown: 'Move selected block down',
    linkTitle: 'Link',
    linkApply: 'Apply link',
    linkUrl: 'Address',
    linkUrlLead: 'A site path (e.g. /urunler), an https:// address, mailto: or tel:.',
    linkNewTab: 'Open in a new tab',
    imageTitle: 'Add image',
    imageInsert: 'Insert image',
    imageAlt: 'Alt text',
    imageAltLead: 'Briefly describe what the image shows; screen readers read this text.',
    imageCaption: 'Caption',
    table: 'Insert table',
    tableToolbar: 'Table actions',
    addRow: 'Add row',
    addColumn: 'Add column',
    deleteRow: 'Delete row',
    deleteColumn: 'Delete column',
    deleteTable: 'Delete table',
    video: 'Insert video',
    videoTitle: 'Insert video',
    videoLead:
      'Paste a YouTube or Vimeo address. On the storefront nothing is requested from the video service until the visitor presses play.',
    videoUrl: 'Video address',
    videoName: 'Video title',
    videoInsert: 'Insert video',
    import: 'Import Markdown or HTML',
    importTitle: 'Import Markdown or HTML',
    importLead:
      'Paste text written elsewhere; it is inserted at the cursor. Headings, lists, tables, quotes, bold/italic and links are kept; scripts, styles and external images are not.',
    importFormat: 'Format',
    importText: 'Text',
    importRun: 'Convert and insert',
    importEmpty: 'Nothing to convert.',
    imported: 'Content inserted.',
    importSkippedImages: '{{count}} external image(s) skipped (upload images with "Insert image").',
    importSkippedScripts: '{{count}} script/style block(s) removed.',
    importSkippedEmbeds: '{{count}} embedded item(s) removed (only YouTube/Vimeo videos are kept).',
  },
  pages: {
    create: 'New page',
    createConfirm: 'Create and edit',
    empty: 'No pages yet',
    emptyLead:
      'Until a home layout is published, the storefront shows the default home page. Use "New page" to create a home layout, company page or campaign page.',
    updated: 'Last changed {{date}}',
    kind: 'Page type',
    kinds: { home: 'Home layout', page: 'Company page', landing: 'Campaign page' },
    states: {
      draft: 'Draft',
      scheduled: 'Scheduled',
      live: 'Live',
      expired: 'Ended',
      unpublished: 'Unpublished',
    },
    reviews: {
      not_required: 'No approval needed',
      pending: 'Awaiting expert approval',
      approved: 'Expert approved',
      rejected: 'Expert rejected',
    },
    title: 'Page title',
    newHeading: 'New heading',
    back: 'All pages',
    saved: 'Draft saved',
    publishedToast: 'Page published',
    unpublishedToast: 'Page unpublished',
    reviewedToast: 'Review decision saved',
    preview: 'Preview',
    save: 'Save draft',
    publish: 'Publish',
    liveVersion: 'Live version: {{version}}',
    unpublished: 'Unpublished changes',
    publishAtInfo: 'Starts: {{date}}',
    unpublishAtInfo: 'Ends: {{date}}',
    basics: 'Page details',
    slug: 'Short name',
    slugLead: 'Address: {{path}}',
    seoTitle: 'SEO title',
    seoDescription: 'SEO description',
    chars: '{{count}}/{{max}} characters',
    healthContent: 'Health content (needs expert approval)',
    sections: 'Sections',
    sectionsLead: 'Shown on the storefront top to bottom in this order. Hidden sections stay in the draft.',
    noSections: 'No sections yet. Pick a section type below and add it.',
    sectionType: 'Section type',
    sectionTypes: {
      hero: 'Hero',
      richText: 'Text',
      imageText: 'Image and text',
      productGrid: 'Product grid',
      categoryTiles: 'Category tiles',
      faq: 'FAQ',
      banners: 'Banners',
      postList: 'Blog posts',
    },
    addSection: 'Add section',
    hidden: 'Hidden',
    hide: 'Hide',
    moveUp: 'Move section {{n}} up',
    moveDown: 'Move section {{n}} down',
    sectionUnavailable: 'This section type is not supported yet.',
    heading: 'Heading',
    heroText: 'Short text',
    ctaLabel: 'Button text',
    ctaHref: 'Button address',
    body: 'Text',
    imagePosition: 'Image position',
    gridSource: 'Product source',
    gridSources: {
      newest: 'Newest products',
      category: 'Products in a category',
      products: 'Products I pick',
      bestsellers: 'Best sellers (last 30 days)',
      discounted: 'Products on sale',
      collection: 'Products in a collection',
      brand: 'Products of a brand',
    },
    gridCollection: 'Collection',
    gridBrand: 'Brand',
    chooseRef: 'Choose',
    refInactive: '{{name}} (not shown in the storefront)',
    gridLimit: 'Number of products',
    products: 'Add products',
    unknownProduct: 'Product not found (it may have been deleted)',
    tileCategories: 'Categories to show',
    question: 'Question {{n}}',
    answer: 'Answer {{n}}',
    addQuestion: 'Add question',
    removeQuestion: 'Remove this question',
    noImage: 'No image',
    uploadImage: 'Upload image',
    replaceImage: 'Replace image',
    imageAlt: 'Alt text',
    review: 'Expert review',
    reviewLead:
      'Pages with health content or health claims are published with Veterinary Expert approval. Changing the content voids the approval.',
    reviewNote: 'Reviewer note: {{note}}',
    reviewNoteLabel: 'Review note',
    reviewSaveFirst: 'Save the draft first; the decision applies to the saved content.',
    findings: 'Possible health claims: {{count}}',
    approve: 'Approve',
    reject: 'Reject',
    versions: 'Published versions',
    versionsLead: 'Every publish is kept as an immutable version.',
    noVersions: 'This page has not been published yet.',
    unpublish: 'Unpublish',
    unpublishConfirm: 'The page leaves the storefront immediately. Drafts and versions are kept. Continue?',
    deleteConfirm: 'This draft page will be permanently deleted. Continue?',
    publishTitle: 'Publish page',
    publishLead: 'The draft goes live as a new version. Without dates it is published now.',
    publishConfirm: 'Publish',
    publishAt: 'Start date',
    bannerPlacement: 'Banner area',
    bannersLead: 'This section shows the active banners added to the chosen area.',
    manageBanners: 'Manage banners',
    allPostCategories: 'All categories',
    postLimit: 'Number of posts',
    unpublishAt: 'End date',
  },
  banners: {
    create: 'New banner',
    createConfirm: 'Save as draft',
    save: 'Save',
    saved: 'Banner saved',
    activate: 'Activate',
    activated: 'Banner activated',
    deactivate: 'Stop',
    deactivated: 'Banner stopped',
    reordered: 'Order saved',
    back: 'All banners',
    unsaved: 'Unsaved changes',
    saveBeforeActivate: 'Save before activating.',
    activeLocked: 'This banner is active; changing it needs the publish content permission.',
    emptyPlacement: 'No banners in this area.',
    noText: 'No text',
    startsInfo: 'Starts: {{date}}',
    endsInfo: 'Ends: {{date}}',
    updated: 'Last changed {{date}}',
    moveUp: 'Move {{name}} up',
    moveDown: 'Move {{name}} down',
    placements: {
      home_hero: 'Home slider',
      home_secondary: 'Home secondary area',
      category_top: 'Category top',
      announcement: 'Announcement bar',
      popup: 'Popup',
    },
    placementLead: {
      home_hero: 'Rotates at the top of the home page (max 8). Visitors can pause it.',
      home_secondary: 'Tiles on the home page (max 6).',
      category_top: 'Above the product list of the chosen categories (first in order).',
      announcement: 'A single line at the very top of the site (first in order).',
      popup: 'Opens once when a page loads; never during checkout or cart (first in order).',
    },
    states: {
      draft: 'Draft',
      scheduled: 'Scheduled',
      live: 'Live',
      expired: 'Ended',
      inactive: 'Stopped',
    },
    audiences: { all: 'Everyone', retail: 'Non-dealers', dealer: 'Dealers only' },
    basics: 'Banner details',
    placement: 'Placement',
    name: 'Internal name',
    nameLead: 'Only shown in the panel.',
    title: 'Title',
    text: 'Text',
    announcementText: 'Announcement text',
    ctaLabel: 'Button text',
    href: 'Link address',
    images: 'Images',
    imagesLead: 'Text is never placed over the image; the image is used as an image only.',
    desktopImage: 'Desktop image',
    uploadDesktop: 'Upload desktop image',
    replaceDesktop: 'Replace desktop image',
    mobileImage: 'Mobile image',
    uploadMobile: 'Upload mobile image',
    replaceMobile: 'Replace mobile image',
    targeting: 'Audience and timing',
    targetingLead: 'Who sees it and when.',
    audience: 'Audience',
    startsAt: 'Start',
    endsAt: 'End',
    dismissDays: 'Days hidden after closing',
    categories: 'Categories',
    categoriesLead: 'If none is chosen, it appears on all category pages.',
    dangerZone: 'Delete',
    deleteConfirm: 'This banner will be permanently deleted. Continue?',
  },
  blog: {
    create: 'New post',
    posts: 'Posts',
    filter: 'Show',
    filters: { all: 'All posts', review: 'Awaiting expert approval', live: 'Live', draft: 'Drafts' },
    pendingCount: '{{count}} posts await expert approval',
    empty: 'No posts',
    emptyLead: 'Use "New post" to write your first post; it is not shown until published.',
    publishedInfo: 'Published {{date}}',
    states: { draft: 'Draft', scheduled: 'Scheduled', live: 'Live', unpublished: 'Unpublished' },
    title: 'Post title',
    back: 'All posts',
    feature: 'Feature',
    unfeature: 'Remove from featured',
    featuredBadge: 'Featured',
    featuredToast: 'The post is featured on the Articles page.',
    unfeaturedToast: 'The post is no longer featured.',
    readingTime: '{{n}} min read',
    article: 'Post',
    excerpt: 'Excerpt',
    category: 'Category',
    noCategory: 'No category',
    tags: 'Tags',
    tagsLead: 'Separate with commas.',
    authorName: 'Author name',
    authorTitle: 'Author title',
    authorTitlePlaceholder: 'Veterinarian',
    cover: 'Cover image',
    uploadCover: 'Upload cover image',
    replaceCover: 'Replace cover image',
    body: 'Post text',
    references: 'References',
    referencesLead: 'Scientific sources and links the post is based on.',
    referenceTitle: 'Reference {{n}}',
    referenceUrl: 'Link of reference {{n}}',
    referenceRemove: 'Remove reference {{n}}',
    referenceAdd: 'Add reference',
    related: 'Related products',
    relatedLead: 'Shown at the end of the post.',
    relatedSearch: 'Add product',
    seo: 'Search engines',
    noVersions: 'This post has not been published yet.',
    publishedToast: 'Post published',
    unpublishedToast: 'Post unpublished',
    unpublishConfirm: 'The post leaves the storefront immediately. Drafts and versions are kept. Continue?',
    deleteConfirm: 'This draft post will be permanently deleted. Continue?',
    publishTitle: 'Publish post',
    publishLead: 'The draft goes live as a new version. Without a date it is published now.',
    categories: 'Blog categories',
    categoriesLead: 'A category is listed on the storefront once it has a live post.',
    categoryName: 'Category name',
    categoryAdd: 'Add category',
    categoryEdit: 'Edit category',
    categorySlugLead: 'If changed, the old address redirects to the new one.',
    categoryDescription: 'Description',
    categorySaved: 'Category saved',
    categoryDelete: 'Delete category {{name}}',
    categoryDeleteConfirm: '"{{name}}" will be deleted; its posts become uncategorized. Continue?',
    postCount: '{{count}} posts',
  },
  contentPlan: {
    kind: 'Type',
    allKinds: 'All content',
    kinds: { post: 'Blog post', page: 'Page', banner: 'Banner' },
    monthNav: 'Month selection',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    thisMonth: 'This month',
    summary: '{{planned}} planned, {{done}} done',
    agenda: 'Content calendar for {{month}}',
    today: 'Today',
    planned: 'Planned',
    empty: 'No publishing events this month',
    emptyLead: 'Posts and pages published for a future date, and banners with start/end dates, appear here.',
    truncated: 'There are too many events this month; the first 1000 are shown.',
    events: {
      publish_planned: 'Goes live',
      publish_done: 'Went live',
      update: 'Updated (version {{version}})',
      start_planned: 'Starts showing',
      start_done: 'Started showing',
      end_planned: 'Goes offline',
      end_done: 'Went offline',
    },
    statesTitle: 'Status summary',
    postsTitle: 'Blog posts',
    pagesTitle: 'Pages',
    bannersTitle: 'Banners',
    pendingReview: 'Awaiting expert review',
    categoriesTitle: 'Live posts by category',
    categoriesLead: 'Counted by the category in the published version.',
    noCategories: 'No blog categories or live posts yet.',
    livePosts: 'Live posts',
    monthlyTitle: 'Posts that went live in the last 12 months',
    monthlyLead: 'By the date shown on the storefront (Turkey time); posts that are live now are counted.',
    month: 'Month',
    published: 'Posts',
    bar: 'Visual comparison',
    staleTitle: 'Posts not updated',
    staleLead:
      'Live posts whose last published version is older than {{days}} days. Review the information and publish again.',
    staleNone: 'No post has gone more than a year without an update.',
    staleMore: 'and {{count}} more',
    lastPublished: 'Last published: {{date}}',
    scTitle: 'Search Console: posts, last 28 days',
    scUnavailable: 'Search Console data cannot be shown for this language.',
    scOtherLocale:
      'Search Console clicks are shown only for posts in the storefront language (default language).',
    setupRequired: 'Setup required',
    scNotLinked:
      'No Search Console property is linked to this store. Link one on the Google connections page.',
    scNoData: 'No Search Console data yet; it appears here after the first sync.',
    scRange: 'Data range: {{from}} – {{to}}',
    scNoClicks: 'No search clicks or impressions on blog posts in this period.',
    scWithoutClicks: 'Live posts without clicks in this period: {{count}}',
    post: 'Post',
  },
  forms: {
    form: 'Form',
    kinds: { contact: 'Contact form', dealer_application: 'Dealer application (extra fields)' },
    settingsTitle: 'Publishing and notices',
    noticeMissing: 'Privacy notice (KVKK) not published',
    noticeMissingLead: 'Publish the privacy notice first to show the form on the storefront.',
    enabled: 'Show the form on the Contact page',
    notifyStaff: 'Email notice for new messages',
    newMessages: 'New messages: {{count}}',
    dealerLead:
      'Company name, tax details, phone, address, city/district, business type, note and document fields are fixed. Fields you add here appear at the end of the application form and are stored with the application.',
    fieldsTitle: 'Form fields',
    extraFieldsTitle: 'Extra fields',
    fieldsLead:
      'Fields appear on the storefront in this order. Changes go live immediately with "Save form".',
    noFields: 'No extra fields yet.',
    addField: 'Add field',
    save: 'Save form',
    saved: 'Form saved',
    untitled: 'Untitled field',
    fieldN: 'Field {{n}}: {{name}}',
    requiredBadge: 'Required',
    label: 'Label',
    type: 'Field type',
    help: 'Help text',
    options: 'Options (one per line)',
    required: 'Required field',
    moveUp: 'Move {{name}} up',
    moveDown: 'Move {{name}} down',
    remove: 'Remove {{name}}',
    types: {
      text: 'Short text',
      textarea: 'Long text',
      email: 'Email',
      tel: 'Phone',
      number: 'Number',
      select: 'Choice list',
      checkbox: 'Checkbox',
      date: 'Date',
    },
    presets: { name: 'Full name', email: 'Email', phone: 'Phone', message: 'Message' },
  },
  messages: {
    filter: 'Show',
    convert: 'Convert to request',
    filters: { new: 'New messages', handled: 'Handled', all: 'All messages' },
    newCount: 'New messages: {{count}}',
    listTitle: 'Messages',
    empty: 'No messages',
    emptyLead:
      'Messages sent from the storefront while the contact form is on appear here (Storefront → Forms).',
    statuses: { new: 'New', handled: 'Handled' },
    reply: 'Reply by email',
    markHandled: 'Mark as handled',
    markNew: 'Mark as new',
    deleteConfirm: 'Delete this message permanently? This cannot be undone.',
    deleted: 'Message deleted',
    pageOf: 'Page {{page}} of {{pages}}',
  },
  topbar: {
    store: 'Working store',
    jobsRunning: 'Jobs running: {{count}}',
    jobsDone: 'Jobs finished ({{count}})',
    jobsTitle: 'Background jobs',
    jobsLead: 'Running jobs and those finished in the last 10 minutes.',
    progress: '{{processed}} / {{total}}',
    statuses: { queued: 'Queued', running: 'Running', done: 'Finished', failed: 'Failed' },
    kinds: {
      import: 'Import',
      product_bulk: 'Bulk product action',
      seo_crawl: 'Site crawl',
      web_vitals: 'Page speed measurement',
    },
    imports: {
      products: 'Product import',
      shopify_products: 'Shopify product import',
      categories: 'Category import',
      dealers: 'Dealer list import',
      migration: 'Migration package',
    },
  },
  audience: {
    subscribersTitle: 'Newsletter subscribers',
    subscribersLead:
      'People who subscribed with the storefront newsletter form. A subscription starts with the confirmation link in the email (double opt-in); member consents are on the customer card.',
    status: 'Status',
    statuses: {
      subscribed: 'Subscribed',
      pending: 'Awaiting confirmation',
      unsubscribed: 'Unsubscribed',
      all: 'All',
    },
    sources: { storefront_form: 'Storefront form', admin_import: 'Import' },
    search: 'Search email',
    member: 'Member',
    colEmail: 'Email',
    colStatus: 'Status',
    colConsent: 'Consent date and text',
    noSubscribers: 'No subscribers with this status',
    noSubscribersLead:
      'The newsletter form appears in the storefront footer when email sending is set up and the privacy notice is published.',
    unsubscribe: 'End subscription',
    unsubscribeConfirm:
      'No more marketing email will be sent to this address (added to the suppression list) and a refusal is reported to İYS. Continue?',
    unsubscribedDone: 'Subscription ended.',
    deleteConfirm:
      'The subscriber record is deleted (privacy). The unsubscribe and İYS records are kept as proof. This cannot be undone. Continue?',
    deletedDone: 'Subscriber deleted.',
    suppressionsTitle: 'Suppression list',
    suppressionsLead:
      'No marketing message is sent to these addresses even with consent: unsubscribes, bounces, complaints and manual entries. Order and shipping notifications are not affected.',
    channel: 'Channel',
    channels: { email: 'Email', sms: 'SMS', whatsapp: 'WhatsApp' },
    channelFilter: 'Filter list by channel',
    allChannels: 'All channels',
    address: 'Address',
    note: 'Note (optional)',
    suppress: 'Suppress',
    suppressedDone: 'Address added to the suppression list.',
    colReason: 'Reason',
    colDate: 'Date',
    reasons: {
      unsubscribe: 'Unsubscribed',
      bounce: 'Bounced',
      complaint: 'Complaint',
      manual: 'Added manually',
      iys_ret: 'Refused in İYS',
    },
    noSuppressions: 'The suppression list is empty',
    noSuppressionsLead: 'People who use the unsubscribe link and addresses you suppress are listed here.',
    unsuppress: 'Remove',
    unsuppressConfirm:
      'The block is removed; consent does not come back, the person must give consent again. Continue?',
    unsuppressedDone: 'Block removed.',
    iysTitle: 'İYS records',
    iysLead:
      'Consents and refusals must be reported to the Turkish İleti Yönetim Sistemi within three business days; no marketing message is sent on consent that was not reported.',
    iysConnected: 'İYS connected',
    iysSetup: 'Setup required',
    iysSetupLink: 'Integrations → İYS',
    iysPending: 'Pending: {{count}}',
    iysOverdue: 'Overdue: {{count}}',
    iysFailed: 'Rejected: {{count}}',
    iysFilter: 'Show',
    iysFilters: {
      open: 'To report',
      sent: 'Sent to İYS',
      reported: 'Reported manually',
      failed: 'Rejected',
      all: 'All',
    },
    iysDownload: 'Download file (CSV)',
    iysMark: 'Mark selected as reported ({{count}})',
    iysMarked: 'Records marked as reported.',
    iysEmpty: 'Nothing to report',
    iysEmptyLead: 'New consents and refusals are listed here.',
    select: 'Select',
    selectRecord: 'Select record {{address}}',
    colIys: 'Consent',
    colDue: 'Report by',
    colState: 'Status',
    overdue: 'Overdue',
    recipientTypes: { BIREYSEL: 'Individual', TACIR: 'Merchant (dealer)' },
    iysTypes: { EPOSTA: 'Email', MESAJ: 'Message', ARAMA: 'Call' },
    iysStatuses: { ONAY: 'Consent', RET: 'Refusal' },
    eligibility: {
      invalid_address: 'Invalid address',
      suppressed: 'On the suppression list',
      no_consent: 'No marketing consent',
      iys_not_registered: 'Consent not yet registered in İYS',
      iys_refused: 'İYS has a refusal record',
    },
    iysStates: { pending: 'Pending', sent: 'Sent to İYS', reported: 'Reported manually', failed: 'Rejected' },
  },
  segments: {
    rfmTitle: 'RFM groups',
    rfmLead:
      'Customers are scored 1–5 on how recently they bought (R), how often (F) and their net spend (M), then grouped. Recalculated automatically every night.',
    computedAt: 'Last calculated: {{date}}',
    neverComputed: 'Not calculated yet. Use "Recalculate now"; it also runs every night.',
    recompute: 'Recalculate now',
    recomputed: 'RFM groups and segment counts updated.',
    thresholds:
      'R: bought within {{r5}} days 5, {{r4}} days 4, {{r3}} days 3, {{r2}} days 2, older 1. F: at least {{f5}} orders 5, {{f4}} → 4, {{f3}} → 3, {{f2}} → 2, one order 1. M: quintiles among customers (top 20% spenders → 5).',
    groupCount: '{{count}} customers',
    groupShare: '{{pct}}% of customers',
    groupSpent: 'Net spend {{amount}}',
    noOrdersCount: '{{count}} members',
    saveAsSegment: 'Save as segment',
    saveAsSegmentLabel: 'Save the {{group}} group as a segment',
    savedAsSegment: 'Segment created.',
    groups: {
      champions: 'Champions',
      loyal: 'Loyal customers',
      new: 'New customers',
      potential: 'Potential loyalists',
      need_attention: 'Need attention',
      cant_lose: "Can't lose them",
      at_risk: 'At risk',
      hibernating: 'Hibernating',
      lost: 'Lost',
      none: 'Members without orders',
    },
    groupHints: {
      champions: 'Bought within {{r4}} days, at least {{f4}} orders and in the top 40% by spend.',
      loyal: 'Bought within {{r3}} days with at least {{f3}} orders.',
      new: 'Placed their only order within {{r4}} days.',
      potential: 'Placed their second order within {{r4}} days.',
      need_attention: 'Last bought {{r4}}–{{r3}} days ago, at most two orders.',
      cant_lose: 'At least {{f4}} orders but no purchase for over {{r3}} days.',
      at_risk: '2–3 orders, no purchase for over {{r3}} days.',
      hibernating: 'Only order {{r3}}–{{r2}} days ago.',
      lost: 'Only order more than {{r2}} days ago.',
      none: 'Signed up but no valid order.',
    },
    listTitle: 'Segments',
    listLead:
      'Customer groups defined by rules, used as audiences in campaigns and automations. Members are recalculated from the rules each time.',
    add: 'New segment',
    emptyTitle: 'No segments yet',
    emptyLead: 'Save an RFM group above or create a segment with your own rules.',
    colName: 'Segment',
    colMembers: 'Customers',
    colCounted: 'Last counted',
    backToList: 'All segments',
    basics: 'Segment details',
    name: 'Name',
    description: 'Description',
    rulesTitle: 'Rules',
    rulesLead:
      'Customers matching the rules are in the segment. Order conditions are evaluated live, the RFM group from the last calculation; customers erased under KVKK are never included.',
    match: 'Match',
    matchAll: 'All conditions',
    matchAny: 'Any condition',
    conditions: 'Conditions',
    field: 'Field',
    op: 'Comparison',
    value: 'Value',
    choose: 'Choose',
    addCondition: 'Add condition',
    removeCondition: 'Remove condition',
    fields: {
      order_count: 'Number of orders',
      total_spent: 'Net spend',
      last_order_days: 'Days since last order',
      registered_days: 'Days since sign-up',
      species: 'Species of purchased product',
      tag: 'Tag',
      city: 'City',
      kind: 'Customer type',
      consent: 'Channel with marketing consent',
      consent_source: 'Where email consent was given',
      rfm: 'RFM group',
    },
    ops: { is: 'is', is_not: 'is not', gte: 'at least', lte: 'at most' },
    kinds: { dealer: 'Dealer (approved company member)', retail: 'Retail' },
    amountIn: 'Amount ({{currency}})',
    days: 'Days',
    preview: 'Preview',
    previewTitle: 'Matching customers: {{count}}',
    previewLead: 'Preview before saving; the first 10 customers are shown.',
    noMatches: 'No customers match the rules.',
    saved: 'Segment saved.',
    deleted: 'Segment deleted.',
    deleteConfirm: 'Delete the "{{name}}" segment? Customers are not affected.',
    membersTitle: 'Customers in this segment: {{count}}',
    membersEmpty: 'No customers in this segment right now.',
    colCustomer: 'Customer',
    colRfm: 'RFM group',
    colOrders: 'Orders',
    colSpent: 'Net spend',
    colLastOrder: 'Last order',
  },
  emailRouting: {
    title: 'Email sending',
    lead: 'Order, password and invitation emails (transactional) and newsletter/campaign emails (marketing) can use different providers. Only providers with a successful connection test are listed.',
    transactional: 'Transactional email',
    marketing: 'Marketing email',
    smtpDefault: 'SMTP (business or platform)',
    sameAsTransactional: 'Same as transactional',
    noProviders:
      'No email provider (Amazon SES, SendGrid, Postmark) is connected yet; email goes through SMTP.',
    save: 'Save sending choice',
    saved: 'Sending choice saved.',
    webhooksLead:
      'Enter these addresses in the provider dashboard for bounce, complaint and unsubscribe notifications; they update the suppression list. They contain a secret key; do not share them.',
    webhookFor: '{{provider}} notification URL',
    rotate: 'Regenerate URLs',
    rotateConfirm:
      'A new secret is generated and the old URLs stop working immediately. Update them in the provider dashboards. Continue?',
    rotated: 'Notification URLs regenerated.',
  },

  emailTemplates: {
    create: 'New template',
    lead: 'Templates for newsletter and campaign emails. Build content from blocks; colours and logo come from the store’s published theme, legal footer details from business settings. Sending happens from campaigns.',
    emptyTitle: 'No templates yet',
    emptyLead: 'Start with "New template": add and order heading, text, image, button and product blocks.',
    listLabel: 'Email templates',
    colName: 'Template',
    colReview: 'Expert review',
    colUpdated: 'Last change',
    noReview: 'Not needed',
    saved: 'Template saved.',
    deleted: 'Template deleted.',
    save: 'Save',
    createConfirm: 'Create template',
    back: 'All templates',
    unsaved: 'Unsaved changes',
    completeFirst: 'To save, fill in the name, subject and the blocks marked as incomplete.',
    editor: 'Template editor',
    basics: 'Template details',
    name: 'Template name',
    nameLead: 'Only shown in the panel (e.g. "October newsletter").',
    subject: 'Subject',
    preheader: 'Preheader',
    preheaderLead: 'Short text shown next to the subject in the inbox; not shown inside the email.',
    mergeTitle: 'Personalisation fields',
    mergeFields: {
      firstName: 'recipient’s first name',
      name: 'recipient’s full name',
      email: 'recipient’s email address',
      storeName: 'store name',
    },
    mergeFallback: 'For a fallback when there is no value, write it after a vertical bar:',
    blocks: 'Content blocks',
    blocksLead:
      'Blocks appear top to bottom in this order. Drag by the handle or use the arrow buttons to reorder. Legal details and the unsubscribe link are added to the bottom of every email.',
    noBlocks: 'No blocks yet. Add one below.',
    moved: 'Block moved to position {{position}}.',
    removed: 'Block {{n}} removed.',
    added: '{{type}} block added at position {{n}}.',
    dragHint: 'Drag to reorder',
    blockTitle: '{{n}}. {{type}}',
    blockTypes: {
      heading: 'Heading',
      text: 'Text',
      image: 'Image',
      button: 'Button',
      products: 'Product cards',
      divider: 'Divider',
      spacer: 'Spacer',
      cart: 'Cart',
      order: 'Order',
      quote: 'Quote',
    },
    missing: {
      text: 'Write the text',
      image: 'Upload an image',
      label: 'Enter the button text',
      link: 'Enter the link',
      products: 'Choose at least one product',
      collection: 'Choose a collection',
      category: 'Choose a category',
    },
    moveUp: 'Move block {{n}} up',
    moveDown: 'Move block {{n}} down',
    removeBlock: 'Remove block {{n}}',
    addBlock: 'Add block',
    blockLimit: 'A template can have at most {{max}} blocks.',
    dangerZone: 'Delete template',
    deleteConfirm: 'Template "{{name}}" will be deleted. Versions in other languages stay. Continue?',
    updated: 'Last change: {{date}}',
    align: 'Alignment',
    aligns: { left: 'Left', center: 'Centre' },
    headingText: 'Heading',
    level: 'Size',
    levels: { '1': 'Large heading', '2': 'Subheading' },
    text: 'Text',
    textLead: 'A blank line starts a new paragraph. Text between **two asterisks** is bold.',
    replaceImage: 'Replace image',
    uploadImage: 'Upload image',
    imageAlt: 'Image description',
    imageAltLead: 'Shown if the image does not load and read by screen readers. Required for linked images.',
    imageLink: 'Image link',
    width: 'Width',
    widths: { full: 'Full width', half: 'Half width (centred)' },
    buttonLabel: 'Button text',
    buttonLink: 'Button link',
    source: 'Product source',
    sources: {
      newest: 'Newest products',
      collection: 'Collection',
      category: 'Category',
      manual: 'Hand-picked products',
    },
    columns: 'Columns',
    columnCount: '{{count}} columns',
    limit: 'Number of products',
    collection: 'Collection',
    category: 'Category',
    choose: 'Choose',
    pickProducts: 'Products',
    showPrice: 'Show price',
    productsLead:
      'Only products published in this store, active and with approved content are shown; products with health claims awaiting approval are left out. The price is the lowest tax-inclusive variant price of the default market and is recalculated when sending.',
    spacerSize: 'Spacer height',
    sizes: { sm: 'Small', md: 'Medium', lg: 'Large' },
    cartLead:
      'In the abandoned cart automation, the customer’s cart items and total are listed here. In campaign emails a description is shown instead.',
    orderLead:
      'In post-purchase automations, the order items and total are listed here. In campaign emails a description is shown instead.',
    quoteLead:
      'In the dealer quote follow-up automation the quote items, total and validity date are listed here. In a campaign email an explanation appears instead.',
    dividerLead: 'A thin line between blocks.',
    preview: 'Preview',
    previewUpdating: 'Updating…',
    device: 'Screen',
    devices: { desktop: 'Desktop', phone: 'Phone' },
    format: 'Format',
    formats: { html: 'Email', text: 'Plain text' },
    previewFieldErrors: 'The preview could not be built; fix the marked fields.',
    previewWaiting: 'The preview appears here once you write a subject.',
    previewFrame: 'Email preview',
    findingsTitle:
      '{{count}} phrase(s) may be health claims. After saving, Veterinary Expert Reviewer approval is needed; without it the template cannot be used in campaigns.',
    emptyProducts:
      'A product block has nothing to show (block: {{blocks}}). The source has no published, approved products; the block is left out of the email.',
    test: 'Send test',
    testLead:
      'The saved version is sent with "[Test]" before the subject. It goes only to panel users of your business, never to customers.',
    testSend: 'Send',
    testQueued: 'Test email queued for sending ({{count}} recipient(s)).',
    testSaveFirst: 'There are unsaved changes. The test sends the saved version; save first.',
    testTo: 'Recipients',
    testToLead:
      'Email addresses of panel users, separated by commas, up to 5. Leave empty to send only to yourself.',
  },
  campaigns: {
    create: 'New campaign',
    lead: 'A campaign sends an email template to the chosen audience. Each recipient is checked again at send time: nobody on the suppression list, without consent, or whose consent is not reported to İYS gets it. Sending runs in the background with a per-minute limit.',
    emptyTitle: 'No campaigns yet',
    emptyLead: 'Prepare an email template first, then choose the audience with "New campaign".',
    listLabel: 'Email campaigns',
    colName: 'Campaign',
    colStatus: 'Status',
    colSent: 'Sent / recipients',
    colClicked: 'Clicked',
    colWhen: 'Date',
    statuses: {
      draft: 'Draft',
      scheduled: 'Scheduled',
      sending: 'Sending',
      testing: 'A/B test running',
      sent: 'Sent',
      paused: 'Paused',
      cancelled: 'Stopped',
    },
    saved: 'Campaign saved.',
    deleted: 'Campaign deleted.',
    cancelled: 'Sending stopped.',
    resumed: 'Sending resumed.',
    save: 'Save',
    createConfirm: 'Create draft',
    back: 'All campaigns',
    unsaved: 'Unsaved changes',
    editor: 'Campaign settings',
    content: 'Content',
    name: 'Campaign name',
    nameLead: 'Shown in the panel and reports; the campaign code added to links is made from it.',
    template: 'Email template',
    chooseTemplate: 'Choose a template',
    openTemplate: 'Open template',
    noTemplates: 'This store has no email templates yet.',
    subject: 'Subject',
    subjectLead:
      'If empty, the template subject is used: "{{subject}}". Recipients in other languages get that language’s template subject.',
    preheader: 'Preheader',
    preheaderLead: 'If empty, the template preheader is used.',
    audience: 'Audience',
    audienceLead:
      'Customers in the segments and, optionally, the store’s newsletter subscribers. Each address counts once.',
    segments: 'Segments',
    noSegments: 'No saved segments (Marketing → Segments).',
    segmentCount: '(last count {{count}} customers)',
    subscribers: 'Store newsletter subscribers',
    estimate: 'Count recipients',
    estimateResult: 'Can be sent to {{eligible}} people (of {{total}}).',
    estimateNote: 'Counts reflect the current state; every recipient is checked again when sending.',
    skipReasons: {
      suppressed: 'On the suppression list: {{count}}',
      no_consent: 'No marketing consent: {{count}}',
      iys_not_registered: 'Consent not reported to İYS: {{count}}',
      iys_refused: 'Refused in İYS: {{count}}',
      invalid_address: 'Invalid address: {{count}}',
      staging_allowlist: 'Not on the staging allowlist (not sent): {{count}}',
    },
    abTitle: 'A/B test (subject)',
    abLead:
      'Part of the recipients get two different subjects. After the waiting time, the subject with the higher click rate goes to the rest.',
    abEnable: 'Run an A/B test on the subject',
    subjectB: 'Subject B',
    abPercent: 'Test group',
    percentOption: '{{pct}}% of recipients',
    abWait: 'Wait before choosing the winner',
    hoursOption: '{{count}} hours',
    delivery: 'Sending speed',
    deliveryLead:
      'Set it by your provider’s limit and your domain’s reputation. Start slowly on a new domain.',
    rate: 'Emails per minute (max)',
    dangerZone: 'Delete campaign',
    deleteConfirm: 'Campaign "{{name}}" will be deleted. Continue?',
    updated: 'Last change: {{date}}',
    send: 'Send…',
    templateNotApproved: 'The template awaits expert approval; it cannot be sent until approved.',
    sendTitle: 'Send campaign',
    sendLead:
      'Emails go to real people and cannot be recalled. You can stop sending after it starts; sent emails stay sent.',
    scheduleConfirm: 'Schedule',
    sendConfirm: 'Send to {{count}} people',
    when: 'When',
    now: 'Now',
    later: 'At a later time',
    scheduledAt: 'Send time',
    scheduledToast: 'Campaign scheduled.',
    queuedToast: 'Sending is starting; follow the progress on this screen.',
    statusTitle: 'Sending status',
    statusLabel: 'Status',
    startedAt: 'Started',
    abDecideAt: 'Winner chosen at',
    winner: 'Winning subject',
    variantLabel: 'Subject {{v}}',
    finishedAt: 'Finished',
    progressLabel: 'Sending progress',
    progress: '{{done}} / {{total}} recipients processed: {{sent}} sent, {{skipped}} skipped.',
    abSkipped: 'No A/B test: there were not enough recipients (at least 100). Everyone got subject A.',
    pauseReasons: {
      email_not_configured:
        'Email sending is not set up (Setup required). Connect SMTP or a provider under Connections, then press "Resume".',
      provider_auth_failed:
        'The email provider rejected the key. Fix the connection and press "Resume"; unsent recipients are waiting.',
      template_review_required: 'The template awaits expert approval. Press "Resume" after approval.',
      campaign_template_invalid:
        'The template was not found (it may have been deleted). Stop this campaign and create a new one.',
    },
    resume: 'Resume',
    cancel: 'Stop sending',
    cancelConfirm:
      'Recipients not yet sent will not get the email; sent emails cannot be recalled. Continue?',
    reportTitle: 'Report',
    reportLead:
      'Opens are not measured (privacy and reliability). "Delivered" is filled only with SES, SendGrid or Postmark and their notification address.',
    purged: 'Recipient records were deleted after the retention period (180 days); totals are kept.',
    stats: {
      recipients: 'Recipients',
      sent: 'Sent',
      skipped: 'Skipped',
      delivered: 'Delivered',
      bounced: 'Bounced',
      clicked: 'Clicked',
      clicks: 'Clicks',
      unsubscribed: 'Unsubscribed',
      complained: 'Complaints',
      failed: 'Failed',
    },
    skippedTitle: 'Skipped',
    colVariant: 'Subject',
    winnerBadge: 'Winner',
    linksTitle: 'Link',
    ordersTitle: 'Orders from the campaign',
    noOrders: 'No orders from campaign links yet.',
    ordersLine: '{{orders}} orders, {{paid}} paid · revenue {{revenue}}',
    ordersNote:
      'An order counts when the visitor came through the email link as the last touch and allowed cookies (same rule as the Campaigns and sources report).',
  },
  automations: {
    lead: 'An automation emails a person automatically when something happens (sign-up, abandoned cart, delivered order…). Flows are off by default; only events after a flow is turned on enter it. Before every email, suppression, marketing consent, İYS, the frequency cap and quiet hours are checked.',
    listLabel: 'Marketing automations',
    colFlow: 'Flow',
    colStatus: 'Status',
    colEnrolled: 'Entered',
    colSent: 'Sent',
    on: 'On',
    off: 'Off',
    activeCount: '{{count}} in progress',
    last30Note: 'Counts cover the last 30 days.',
    kinds: {
      welcome: 'Welcome',
      cart_abandon: 'Abandoned cart',
      checkout_abandon: 'Unfinished payment',
      post_purchase: 'After purchase',
      repurchase: 'Repurchase reminder',
      winback: 'Win back',
      vip: 'VIP customers',
      birthday: 'Birthday',
      dealer_welcome: 'Dealer welcome',
      quote_followup: 'Dealer quote follow-up',
    },
    summaries: {
      welcome: 'First email to a new member or newsletter subscriber.',
      cart_abandon: 'Reminder for a member who left items in the cart, with an optional second email.',
      checkout_abandon: 'Reminder for an order whose payment was not completed.',
      post_purchase: 'Review invitation after delivery.',
      repurchase: 'Reminder some days after the last order.',
      winback: 'Win back customers who have not ordered for a long time.',
      vip: 'A yearly thank-you to the Champions group.',
      birthday: 'Greeting for customers who entered their birthday.',
      dealer_welcome: 'Welcome for users of an approved dealer company.',
      quote_followup: 'Reminder to the dealer about a sent quote that has not turned into an order.',
    },
    settingsTitle: 'Sending rules',
    settingsLead: 'Apply to all flows. Campaign emails count toward the frequency cap.',
    frequencyCap: 'Frequency cap',
    frequencyCapLead:
      'A person who received a campaign or another flow email within this time is skipped. The wait step sets the gap inside a flow.',
    capNone: 'No cap',
    capHours: 'At most one email per {{count}} hours',
    quietHours: 'Quiet hours',
    quietStart: 'Start',
    quietEnd: 'End',
    quietLead: 'No email between {{start}} and {{end}} (Türkiye time); such emails go at {{end}}.',
    quietOff: 'No quiet hours: emails may go at any time.',
    saveSettings: 'Save rules',
    settingsSaved: 'Sending rules saved.',
    unknownTitle: 'Flow not found',
    unknownLead: 'The address may be wrong. Choose a flow from the automations list.',
    back: 'All automations',
    unsaved: 'Unsaved changes',
    editor: 'Flow settings',
    save: 'Save',
    saveAndEnable: 'Save and turn on',
    enableConfirm:
      'Once on, emails go automatically to people who meet the conditions (and pass consent, suppression and İYS checks). Sent emails cannot be recalled. Turn it on?',
    saved: 'Flow saved.',
    enabledToast: 'Flow turned on; new events will enter it.',
    disabledToast: 'Flow turned off; people in progress were removed.',
    statusTitle: 'Status',
    enabledLabel: 'Flow on',
    enabledSince: 'Turned on: {{date}}. Events after this date enter the flow.',
    enableLead:
      'Choose a template for every email step to turn it on. Email sending must be set up; templates with health claims need expert approval.',
    disableWarning: 'Saving turns the flow off and removes people currently in it.',
    stepsChangedWarning: 'You changed the steps: saving removes people currently in the flow.',
    triggerTitle: 'Trigger',
    triggers: {
      welcome: 'When an account is created or a newsletter subscription is confirmed. Once per address.',
      cart_abandon: '{{hours}} hours after the last change to a member’s cart.',
      checkout_abandon: '{{hours}} hours after an order is created if its payment is still pending.',
      post_purchase: '{{days}} days after the order is delivered.',
      repurchase: '{{days}} days after the last order in this store (if no newer order).',
      winback: '{{days}} days after the last order in this store (if no newer order).',
      vip: 'When a customer is in the RFM Champions group; checked daily, at most once a year per customer.',
      birthday: 'On the birthday the customer entered (start of day; morning if quiet hours).',
      dealer_welcome: 'Right after a dealer company is approved.',
      quote_followup:
        '{{days}} days after a quote (its latest version) was sent to the dealer, if the quote is still open. Goes to the company owners and the user who requested the quote; starts again when a new version is sent.',
    },
    afterHours: 'How long after',
    hoursOption: '{{count}} hours',
    daysLabel: {
      post_purchase: 'Days after delivery',
      repurchase: 'Days after last order',
      winback: 'Days after last order',
      quote_followup: 'Days after the quote was sent',
    },
    storeScoped: 'This flow is triggered only by carts, orders and quotes of the chosen store.',
    stepsTitle: 'Steps',
    stepsLead:
      'Steps run in order. A wait delays the next step; if a condition fails the person leaves; an email step sends the template.',
    stepTitle: 'Step {{n}}: {{type}}',
    stepNumber: 'Step {{n}}',
    stepTypes: { wait: 'Wait', condition: 'Condition', email: 'Email' },
    waitHours: 'Hours to wait',
    condition: 'Continue if',
    conditionLead: 'If the condition is not met the person leaves the flow.',
    conditions: {
      cart_not_converted: 'Cart still has items and no order was placed',
      order_not_paid: 'Order payment is still pending',
      not_reviewed: 'Products of the order are not reviewed yet',
      no_order_since_enrollment: 'No order since entering the flow',
      quote_open: 'Quote still open (same version, not expired, not ordered)',
    },
    template: 'Email template',
    chooseTemplate: 'Choose a template',
    openTemplate: 'Open template',
    noTemplates: 'This store has no email templates yet.',
    templateHints: {
      welcome: 'Use {{firstName}} for the person’s name.',
      cart_abandon: 'Add a Cart block to show the items and current prices.',
      checkout_abandon: 'Add an Order block to show the pending order and its link.',
      post_purchase: 'Add an Order block to show the delivered order.',
      repurchase: 'Add an Order block to show the last order.',
      winback: 'Add an Order block to show the last order.',
      vip: 'Use {{firstName}} for the person’s name.',
      birthday: 'Use {{firstName}} for the person’s name.',
      dealer_welcome: 'Dealer prices show after sign-in; include a sign-in link.',
      quote_followup:
        'Add a "Quote" block to the template to show the quote items, total, validity date and a button to the quote.',
    },
    moveUp: 'Move step {{n}} up',
    moveDown: 'Move step {{n}} down',
    removeStep: 'Delete step {{n}}',
    moved: 'Step moved to position {{n}}.',
    added: 'Step {{n}} added.',
    removed: 'Step {{n}} deleted.',
    addStep: 'Add step',
    resetDefaults: 'Back to default steps',
    reportTitle: 'Report',
    reportLead:
      'Entries, exit reasons and sends. Records are deleted 180 days after the flow ends. Opens are not measured.',
    stats: {
      enrolled: 'Entered',
      active: 'In progress',
      completed: 'Completed',
      exited: 'Left',
      sent: 'Sent',
      skipped: 'Skipped',
      failed: 'Failed',
    },
    exitsTitle: 'Exit reasons',
    exitReasons: {
      cart_not_converted: 'Cart ordered or emptied: {{count}}',
      order_not_paid: 'Paid or cancelled: {{count}}',
      not_reviewed: 'Wrote a review: {{count}}',
      no_order_since_enrollment: 'Placed an order: {{count}}',
      superseded: 'Cart changed, new entry: {{count}}',
      expired: 'Email could not be sent within 72 hours: {{count}}',
      flow_changed: 'Flow steps changed: {{count}}',
      disabled: 'Flow turned off: {{count}}',
      quote_open: 'Quote ordered, rejected, cancelled, expired or a new version was sent: {{count}}',
    },
    skipsTitle: 'Emails not sent',
    skipReasons: {
      suppressed: 'Suppressed: {{count}}',
      no_consent: 'No marketing consent: {{count}}',
      iys_not_registered: 'Consent not reported to İYS: {{count}}',
      iys_refused: 'Refused in İYS: {{count}}',
      invalid_address: 'Invalid address: {{count}}',
      frequency_cap: 'Frequency cap: {{count}}',
      template_unavailable: 'Template unavailable: {{count}}',
      staging_allowlist: 'Not on the staging allowlist: {{count}}',
      rejected: 'Rejected by provider: {{count}}',
      error: 'Sending error: {{count}}',
    },
    skipOther: 'Other: {{count}}',
    byStepTitle: 'Sends per step',
    colStep: 'Step',
    ordersTitle: 'Orders from this flow',
    noOrders: 'No orders from this flow’s email links yet.',
    ordersNote:
      'Store links get a flow campaign code; an order counts if that link was the last touch (with cookie consent).',
    updated: 'Last change: {{date}}',
  },
  productAlerts: {
    lead: 'Shoppers can leave an email with "Notify me" on out-of-stock items and get one notice when stock returns. When a favorite product’s price drops enough, customers with marketing consent can get an email. Both are off by default.',
    settingsTitle: 'Settings',
    settingsLead:
      'Email sending must be set up. The storefront form is hidden unless the privacy notice is published.',
    stockToggle: '"Notify me" on the storefront',
    stockToggleLead:
      'Waiting people are notified in request order when stock returns (3× the stock, at least 5 per round, every 5 minutes). A one-time requested notice; no marketing consent needed.',
    priceDropToggle: 'Price drop notices for favorites',
    priceDropLead:
      'Checked daily at 10:05. Sent when the price is lower than the lowest price seen since favoriting by the chosen share. A marketing message: consent, suppression, İYS and the frequency cap apply.',
    store: 'Store',
    chooseStore: 'Choose a store',
    minPercent: 'Minimum drop',
    percentOption: '{{pct}}%',
    save: 'Save',
    saved: 'Settings saved.',
    enableConfirm:
      'Once on, emails go automatically to people who meet the conditions; sent emails cannot be recalled. Turn on?',
    requestsTitle: 'Notify me requests',
    requestsLead:
      'Waiting and notified requests per variant. Requests are valid for 6 months; closed records are deleted after 180 days.',
    emptyTitle: 'No requests yet',
    emptyLead: 'Emails left on out-of-stock items appear here while "Notify me" is on.',
    colProduct: 'Product',
    colWaiting: 'Waiting',
    colNotified: 'Notified',
    colStock: 'Stock',
    colOldest: 'Oldest request',
    colActions: 'Actions',
    inStock: 'In stock ({{count}})',
    outOfStock: 'Out of stock',
    view: 'Requests',
    viewFor: 'Requests for {{product}}',
    priceDropLast30: 'Price drop emails in the last 30 days: {{sent}} sent, {{skipped}} not sent.',
    statusFilter: 'Status',
    statuses: { waiting: 'Waiting', notified: 'Notified', cancelled: 'Closed' },
    noRequests: 'No requests with this status.',
    member: 'Member',
    requestedAt: 'Requested: {{date}}',
    notifiedAt: 'Notified: {{date}}',
    reasons: {
      panel: 'Cancelled in the panel',
      expired: 'Expired (6 months)',
      suppressed: 'Address suppressed',
      staging_allowlist: 'Not on the staging allowlist',
      rejected: 'Rejected by provider',
    },
    cancel: 'Cancel',
    cancelConfirm: 'The request closes and no notice is sent. Continue?',
    cancelled: 'Request cancelled.',
  },
  messaging: {
    create: 'New SMS/WhatsApp campaign',
    lead: 'Send an SMS or a Meta-approved WhatsApp template to customers in segments. Each recipient is re-checked for consent, suppression and İYS at send time; the frequency cap and quiet hours apply. Sending is real and paid: check the audience and the estimated cost first.',
    emptyTitle: 'No SMS/WhatsApp campaigns for this store',
    emptyLead: 'Prepare an SMS template first, then create a draft with "New SMS/WhatsApp campaign".',
    listLabel: 'SMS and WhatsApp campaigns',
    colName: 'Campaign',
    colChannel: 'Channel',
    colStatus: 'Status',
    colSent: 'Sent',
    colDelivered: 'Delivered',
    colWhen: 'Date',
    channels: { sms: 'SMS', whatsapp: 'WhatsApp' },
    statuses: {
      draft: 'Draft',
      scheduled: 'Scheduled',
      sending: 'Sending',
      sent: 'Sent',
      paused: 'Paused',
      cancelled: 'Stopped',
    },
    recipientStatuses: {
      pending: 'queued',
      sending: 'sending',
      sent: 'sent',
      delivered: 'delivered',
      failed: 'failed',
      skipped: 'skipped',
      cancelled: 'cancelled',
    },
    setupTitle: 'Setup status',
    setupLead:
      'Commercial SMS needs a connected SMS provider, a MERSİS number and an opt-out text; WhatsApp needs a WhatsApp Business connection. A channel with something missing shows "Setup required" and cannot send.',
    connectedVia: '{{provider}} connected',
    connected: 'Connected',
    webhookUrl: 'Meta webhook address:',
    smsSetupLink: 'Connect Netgsm, İleti Merkezi or Verimor in Integrations, then choose it below',
    whatsappSetupLink: 'Connect WhatsApp Business in Integrations',
    mersis: 'MERSİS number',
    missing: 'Missing',
    mersisLink: 'Enter it in business details',
    optOut: 'Opt-out text',
    settingsTitle: 'Settings',
    settingsLead:
      'SMS provider, commercial SMS opt-out text, estimated unit costs, frequency cap and staging test numbers. Quiet hours are shared with automations.',
    smsProvider: 'SMS provider',
    smsProviderLead: 'Only providers connected and tested in Integrations can be chosen.',
    noProvider: 'Not chosen',
    providerNotConnected: '{{provider}} (setup required)',
    optOutLead:
      'Added to the end of commercial SMS with the MERSİS number (max 80 characters). Avoiding Turkish characters keeps the SMS shorter.',
    smsUnitCost: 'Cost per SMS part (TRY)',
    whatsappUnitCost: 'Cost per WhatsApp message (TRY)',
    costInvalid: 'Amount could not be read; e.g. 0,25',
    frequencyCap: 'Frequency cap',
    frequencyCapLead: 'A phone number gets at most one SMS/WhatsApp campaign message within this time.',
    capNone: 'No cap',
    capHours: 'At most one message per {{count}} hours',
    stagingPhones: 'Staging test numbers',
    stagingPhonesLead:
      'On the staging server, only these numbers receive messages (one per line, max 10). Not used live.',
    saveSettings: 'Save settings',
    settingsSaved: 'Settings saved.',
    saved: 'Campaign saved.',
    deleted: 'Campaign deleted.',
    cancelled: 'Sending stopped.',
    resumed: 'Sending resumed.',
    save: 'Save',
    createConfirm: 'Create draft',
    back: 'SMS and WhatsApp campaigns',
    unsaved: 'Unsaved changes',
    channelSetup: '{{channel}}: setup required',
    editor: 'Campaign editor',
    content: 'Content',
    channel: 'Channel',
    name: 'Campaign name',
    nameLead: 'Only shown in the panel.',
    smsTemplate: 'SMS template',
    chooseTemplate: 'Choose a template',
    openTemplate: 'Open template',
    noTemplates: 'No SMS templates yet.',
    audience: 'Audience',
    audienceLead:
      'Customers in the chosen segments; a phone number gets one message. Individuals need consent and İYS approval; for traders (dealer company members) SMS only needs no İYS refusal. WhatsApp needs explicit consent from everyone.',
    estimate: 'Count recipients and cost',
    dangerZone: 'Delete',
    deleteConfirm: 'Delete the campaign "{{name}}"?',
    updated: 'Last change: {{date}}',
    whatsappNotConnected:
      'WhatsApp Business is not connected (setup required): the approved template list is unavailable. You can draft by typing the template name and language as in Meta; sending needs the connection.',
    whatsappTemplate: 'WhatsApp template',
    whatsappOption: '{{name}} ({{language}}) · {{status}}',
    waStatuses: {
      APPROVED: 'approved',
      PENDING: 'in Meta review',
      REJECTED: 'rejected',
      PAUSED: 'paused',
      DISABLED: 'disabled',
      OTHER: 'unavailable',
    },
    whatsappName: 'Template name',
    whatsappNameLead: 'Template name in Meta (e.g. campaign_announcement).',
    whatsappLanguage: 'Language code',
    whatsappParams: 'Template variables',
    noParams: 'This template has no variables.',
    paramLabel: 'Variable {{n}}',
    addParam: 'Add variable',
    paramsLead:
      'Replace {{1}}, {{2}}… in the template in order. For a personal value, write {{firstName}}, {{name}} or {{storeName}}.',
    estimateResult: '{{eligible}} of {{total}} people can be messaged.',
    skipReasons: {
      no_phone: 'No phone number: {{count}}',
      not_mobile: 'Not a Turkish mobile number: {{count}}',
      suppressed: 'On the suppression list: {{count}}',
      no_consent: 'No consent for this channel: {{count}}',
      iys_not_registered: 'Consent not reported to İYS: {{count}}',
      iys_refused: 'Refused in İYS: {{count}}',
      duplicate_phone: 'Same number on several customers (sent once): {{count}}',
      frequency_cap: 'Frequency cap (got another message recently): {{count}}',
      staging_allowlist: 'Not a staging test number (not sent): {{count}}',
      invalid_address: 'Invalid number: {{count}}',
    },
    partsPerMessage: '{{count}} SMS part(s) per person',
    costEstimate: 'Estimated cost: {{cost}}',
    costUnknown: 'Enter the unit cost in settings for a cost estimate.',
    estimateNote:
      'An estimate: consent and suppression are re-checked at send time; SMS length can vary with the name.',
    send: 'Send…',
    templateNotApproved: 'The template awaits expert approval; it cannot be sent before approval.',
    sendTitle: 'Send the {{channel}} campaign',
    sendLead:
      'Paid messages go to real people and cannot be undone. Check the recipient count and estimated cost; sending asks for two-step verification.',
    scheduleConfirm: 'Schedule',
    sendConfirm: 'Send to {{count}} people',
    sendSetupWarning: 'This channel is not set up (setup required); sending will be refused.',
    scheduledToast: 'Campaign scheduled.',
    queuedToast: 'Campaign queued for sending.',
    statusTitle: 'Sending status',
    statusLabel: 'Status',
    progressLabel: 'Sending progress',
    progress:
      '{{done}} / {{total}} processed: {{sent}} sent, {{delivered}} delivered, {{skipped}} skipped, {{failed}} failed.',
    pauseReasons: {
      sms_template_required: 'Paused: the SMS template was deleted. Stop the campaign and prepare a new one.',
      template_review_required:
        'Paused: the template changed and awaits expert approval. Resume after approval.',
      sms_footer_missing: 'Paused: the MERSİS number or opt-out text is missing. Complete it and resume.',
      sms_not_configured:
        'Paused: no SMS provider connected or chosen. Connect it in Integrations and resume.',
      whatsapp_not_configured:
        'Paused: no WhatsApp Business connection. Connect it in Integrations and resume.',
      provider_invalid_settings: 'Paused: provider settings are missing or wrong.',
      provider_auth_failed: 'Paused: the provider rejected the credentials. Renew them in Integrations.',
      provider_sender_invalid: 'Paused: the SMS header (sender name) is not approved at the provider.',
      provider_iys_not_configured: 'Paused: no İYS brand code set on the provider account.',
      provider_insufficient_balance: 'Paused: not enough balance on the provider account. Top up and resume.',
      provider_template_invalid:
        'Paused: the WhatsApp template is invalid in Meta or its parameters do not match.',
    },
    pauseReasonOther: 'Paused ({{code}}).',
    resume: 'Resume',
    cancelConfirm: 'Stop sending? Recipients not yet sent to get no message.',
    cancel: 'Stop',
    reportTitle: 'Report',
    reportLead:
      'SMS delivery is fetched from the provider every 10 minutes; WhatsApp delivery comes from Meta notifications.',
    purged: 'Recipient records were deleted after the retention period (180 days); totals are kept.',
    stats: {
      recipients: 'Recipients',
      sent: 'Sent',
      delivered: 'Delivered',
      failed: 'Failed',
      skipped: 'Skipped',
      parts: 'SMS parts',
      cost: 'Estimated cost',
    },
    skippedTitle: 'Skipped',
    errorsTitle: 'Failed',
    sendErrors: {
      whatsapp_opted_out: 'Person turned off WhatsApp marketing messages: {{count}}',
      interrupted: 'Sending interrupted (not resent): {{count}}',
      undelivered: 'Operator could not deliver: {{count}}',
      whatsapp_failed: 'WhatsApp could not deliver: {{count}}',
      error: 'Sending error: {{count}}',
    },
    providerError: 'Provider error code {{code}}: {{count}}',
    reportNote:
      'Cost is an estimate from the unit cost in settings; the exact amount is on the provider invoice.',
  },
  smsTemplates: {
    create: 'New SMS template',
    lead: 'SMS texts used in campaigns. The MERSİS number and opt-out text are added at send time, and length is counted with them. Text with health claims is not sent without Veterinary Expert Reviewer approval.',
    emptyTitle: 'No SMS templates yet',
    emptyLead: 'Start with a short, clear text; personal fields can be added.',
    listLabel: 'SMS templates',
    colName: 'Template',
    colReview: 'Expert approval',
    colUpdated: 'Last change',
    noReview: 'Not needed',
    saved: 'Template saved.',
    deleted: 'Template deleted.',
    save: 'Save',
    createConfirm: 'Create template',
    back: 'SMS templates',
    unsaved: 'Unsaved changes',
    editor: 'SMS template editor',
    name: 'Template name',
    nameLead: 'Only shown in the panel.',
    body: 'Text',
    bodyLead:
      'Max 900 characters. The MERSİS number and opt-out text are added automatically; do not type them here.',
    insertField: 'Insert field:',
    fields: { firstName: 'First name', name: 'Full name', storeName: 'Store name' },
    preview: 'Preview',
    previewEmpty: 'As you type, the text to be sent appears here.',
    encoding: 'Character set',
    encodings: {
      gsm7: 'Standard (no Turkish characters)',
      turkish: 'With Turkish characters',
      unicode: 'Unicode (emoji or special characters)',
    },
    length: 'Characters',
    parts: 'Parts',
    multiPart: 'The text takes {{count}} SMS parts; each part is billed.',
    unicodeWarning:
      'Emoji or special characters: one SMS part drops to 65 characters and cost rises. Remove them if possible.',
    tooLong: 'The text exceeds 7 SMS parts; providers cannot send it. Shorten it.',
    footerMissing: 'The commercial SMS footer is incomplete; campaigns cannot be sent:',
    footerParts: {
      mersis: 'MERSİS number (business details)',
      optOut: 'Opt-out text (SMS and WhatsApp settings)',
    },
    findingsNote:
      'The text has {{count}} possible health claim(s): expert approval is needed after saving. Disease prevention or treatment claims are not used.',
    previewNote:
      'Sample person: Ayşe Yılmaz. Length is an estimate; the operator code is added by the provider.',
    dangerZone: 'Delete',
    deleteConfirm: 'Delete the template "{{name}}"?',
    updated: 'Last change: {{date}}',
  },
  push: {
    create: 'New notification campaign',
    lead: 'Send a short notification to the browsers of visitors who allowed notifications on the storefront. Visitors subscribe only by pressing the button and granting browser permission, and can turn it off any time. Sending reaches real people; check the audience first.',
    emptyTitle: 'No notification campaigns for this store',
    emptyLead: 'Complete the setup, then create a draft with "New notification campaign".',
    listLabel: 'Notification campaigns',
    colName: 'Campaign',
    colStatus: 'Status',
    colSent: 'Sent',
    colWhen: 'Date',
    subscriberCount: '{{count}} browsers have notifications on for this store.',
    statuses: {
      draft: 'Draft',
      scheduled: 'Scheduled',
      sending: 'Sending',
      sent: 'Sent',
      paused: 'Paused',
      cancelled: 'Stopped',
    },
    setupTitle: 'Setup',
    setupLead:
      'The storefront button needs a key, a contact address and a published KVKK notice. Android admin app notifications need a Firebase connection.',
    vapidKey: 'Notification key (VAPID)',
    keyReady: 'Ready ({{date}})',
    createKey: 'Create key',
    replaceKey: 'Replace key',
    replaceConfirm:
      'Replacing the key invalidates all browser subscriptions; visitors must turn notifications on again. Continue?',
    keyCreated: 'Key created.',
    privacyNotice: 'KVKK privacy notice',
    published: 'Published',
    missing: 'Missing',
    privacyLink: 'Publish it in legal texts',
    android: 'Android app (Firebase)',
    connected: 'Connected',
    firebaseLink: 'Connect Firebase in Integrations',
    settingsTitle: 'Storefront settings',
    contact: 'Contact address',
    contactLead:
      'Push services (Google, Mozilla, Apple) use this if there is a problem. Write mailto: with an email or https: with a site address.',
    enabled: 'Show the "Turn on notifications" button on the storefront',
    saveSettings: 'Save',
    settingsSaved: 'Settings saved.',
    saved: 'Campaign saved.',
    deleted: 'Campaign deleted.',
    cancelled: 'Sending stopped.',
    resumed: 'Sending resumed.',
    save: 'Save',
    createConfirm: 'Create draft',
    back: 'Push notifications',
    unsaved: 'Unsaved changes',
    notReady: 'Setup required: storefront notifications are off or there is no key',
    editor: 'Notification editor',
    name: 'Campaign name',
    nameLead: 'Only shown in the panel.',
    title: 'Title',
    body: 'Text',
    counter: '{{n}} / {{max}} characters',
    url: 'Page to open',
    urlLead:
      'A store path (e.g. /kategori/kedi). Opens when the notification is clicked; UTM is added for the source report.',
    audience: 'Audience',
    audienceLead:
      'Without segments it goes to all subscribers of the store. With segments it only goes to browsers of members in those segments (signed in when subscribing).',
    estimate: 'Count browsers',
    estimateResult: '{{eligible}} of {{total}} subscriptions will receive it.',
    anonymousExcluded: '{{count}} browsers subscribed without signing in are not in a segment audience.',
    estimateNote: 'An estimate: expired subscriptions drop out when sending.',
    preview: 'Preview',
    previewTitle: 'Title',
    previewBody: 'Notification text',
    previewNote: 'The look depends on the browser and operating system; long text may be shortened.',
    findingsNote:
      'The text has {{count}} possible health claim(s): expert approval is needed after saving. Disease prevention or treatment claims are not used.',
    send: 'Send…',
    reviewRequired: 'The text awaits expert approval; it cannot be sent before approval.',
    sendTitle: 'Send the notification campaign',
    sendLead:
      'The notification goes to real people’s browsers and cannot be undone. Sending asks for two-step verification.',
    sendConfirm: 'Send to {{count}} browsers',
    scheduleConfirm: 'Schedule',
    sendSetupWarning: 'Storefront notifications are not set up (setup required); sending will be refused.',
    scheduledToast: 'Campaign scheduled.',
    queuedToast: 'Campaign queued for sending.',
    statusTitle: 'Sending status',
    statusLabel: 'Status',
    progressLabel: 'Sending progress',
    progress:
      '{{done}} / {{total}} processed: {{sent}} sent, {{expired}} subscriptions expired, {{failed}} failed.',
    pauseReasons: {
      template_review_required: 'Paused: the text awaits expert approval.',
      web_push_not_configured: 'Paused: storefront notifications were turned off or the key was removed.',
      push_auth_failed:
        'Paused: the push service rejected the key. Check the contact address; replacing the key may be needed.',
    },
    pauseReasonOther: 'Paused ({{code}}).',
    resume: 'Resume',
    cancelConfirm: 'Stop sending? Browsers not yet sent to get no notification.',
    cancel: 'Stop',
    reportTitle: 'Report',
    reportLead:
      'Whether the notification was shown is not measured; only sends accepted by the service are counted.',
    purged: 'Recipient records were deleted after the retention period (180 days); totals are kept.',
    stats: {
      recipients: 'Recipients',
      sent: 'Sent',
      expired: 'Expired subscriptions',
      failed: 'Failed',
      skipped: 'Skipped',
    },
    errorsTitle: 'Reasons',
    sendErrors: {
      push_404: 'Subscription not found (removed): {{count}}',
      push_410: 'Subscription expired (removed): {{count}}',
      push_403: 'Subscription made with another key (removed): {{count}}',
      push_too_large: 'Notification too large: {{count}}',
      push_unavailable: 'Push service unreachable after several tries: {{count}}',
      interrupted: 'Sending interrupted (not resent): {{count}}',
    },
    serviceError: 'Push service response {{code}}: {{count}}',
    ordersNote:
      'Orders from visitors who came through the notification link and gave cookie consent (last touch).',
    dangerZone: 'Delete',
    deleteConfirm: 'Delete the campaign "{{name}}"?',
    updated: 'Last change: {{date}}',
  },
  notifications: {
    title: 'Mobile notifications (Android)',
    lead: 'Notifications in the Android admin app for events such as new orders and return requests. Only events you have permission for; no personal data in notifications.',
    firebaseMissing:
      'Firebase is not connected for the business; no notifications are sent until it is (Integrations → Firebase).',
    devices: 'My devices',
    noDevices:
      'No devices for this account. The device appears here after turning on notifications in the Android admin app.',
    unnamed: 'Unnamed device',
    deviceLine: 'App version {{version}} · last seen {{seen}}',
    remove: 'Remove',
    removeConfirm: 'Remove this device? It can register again when the app is opened.',
    removed: 'Device removed.',
    events: 'Events that notify me',
    eventNames: {
      order_created: 'New order',
      payment_review_required: 'Payment needs review',
      return_requested: 'New return request',
      dealer_applied: 'New dealer application',
      form_submitted: 'New contact message',
      dealer_balance_paid: 'Dealer payment received',
    },
    noPermission: '(no permission)',
    quietHours: 'Quiet hours (no notifications in this range)',
    save: 'Save preferences',
    saved: 'Notification preferences saved.',
    test: 'Send a test notification',
    testSent: 'Test notification sent to {{count}} devices.',
  },
  promotions: {
    create: 'New promotion',
    lead: 'Discounts without a coupon: product/category/brand discount, cart amount or quantity tiers, buy X pay Y, free shipping. The discount is applied in the cart; no struck-through price is shown on products. A product whose price was raised in the 10 days before the promotion gets no discount.',
    emptyTitle: 'No automatic promotions yet',
    emptyLead: 'Create a draft with New promotion; customers see nothing until you make it live.',
    listLabel: 'Automatic promotions',
    colName: 'Promotion',
    colKind: 'Type',
    colStatus: 'Status',
    colUsage: 'Usage',
    colDates: 'Dates',
    kinds: {
      item_discount: 'Product discount (percent)',
      cart_tiers: 'Cart tiers',
      buy_x_pay_y: 'Buy X pay Y',
      free_shipping: 'Free shipping',
    },
    kindLeads: {
      item_discount:
        'A percentage off selected (or all) products in the cart. At most one product discount applies to a product.',
      cart_tiers:
        'A discount once the cart amount or item count passes a threshold; the highest eligible tier applies. Uses the amount left after product discounts.',
      buy_x_pay_y: 'For every X items, the lowest-priced (X − Y) are free. Selected products can be mixed.',
      free_shipping:
        'No shipping fee above the threshold (the cash-on-delivery fee still applies). Uses the discounted amount.',
    },
    phases: {
      draft: 'Draft',
      scheduled: 'Waiting to start',
      running: 'Live',
      paused: 'Paused',
      ended: 'Ended',
    },
    usageShort: '{{orders}} orders · {{discount}}',
    noDates: 'No end',
    saved: 'Promotion saved.',
    activated: 'Promotion is live.',
    paused: 'Promotion paused.',
    deleted: 'Draft deleted.',
    save: 'Save',
    createConfirm: 'Create draft',
    activate: 'Make live',
    pause: 'Pause',
    back: 'Back to automatic promotions',
    unsaved: 'Unsaved changes',
    liveLocked: 'A live promotion cannot be changed; pause it first.',
    reviewRequired:
      'The promotion name may contain a health claim: it cannot go live without Veterinary Expert Reviewer approval.',
    editor: 'Promotion settings',
    name: 'Promotion name',
    nameLead: 'Shown in the panel only.',
    label: 'Name shown to customers',
    labelLead: 'Shown in the cart, at checkout and on product pages ({{n}}/{{max}}).',
    kind: 'Promotion type',
    percent: 'Discount percent',
    buy: 'Buy (items)',
    pay: 'Pay (items)',
    minSubtotal: 'Minimum cart amount',
    minSubtotalLead: 'Leave empty for free shipping on every order.',
    basis: 'Threshold type',
    bases: { subtotal: 'Cart amount', quantity: 'Item count' },
    tierType: 'Discount type',
    tiers: 'Tiers',
    tierMinAmount: 'Minimum amount',
    tierMinQty: 'Minimum items',
    removeTier: 'Remove tier {{n}}',
    addTier: 'Add tier',
    currency: 'Currency',
    targets: 'Target products',
    targetsLead:
      'If none are selected, all products. A product matching any selection is included; subcategories are included.',
    categories: 'Categories',
    brands: 'Brands',
    collections: 'Collections',
    noCollections: 'No collections.',
    products: 'Products',
    audienceTitle: 'Audience',
    audience: 'Who gets it',
    audiences: { all: 'Everyone', retail: 'Retail customers only', dealers: 'Dealers only' },
    groups: 'Customer groups (optional)',
    segments: 'Segments (optional; signed-in members only)',
    noSegments: 'No segments.',
    rulesTitle: 'Priority, combining and dates',
    priority: 'Priority',
    stacking: 'Combining',
    stackings: {
      combinable: 'Combines with other promotions',
      exclusive: 'Exclusive (no other promotion applies)',
    },
    allowCoupon: 'Can be used with a coupon',
    startsAt: 'Start',
    endsAt: 'End',
    preview: 'What customers see',
    previewLabel: 'Name shown to customers',
    previewNote: 'Product pages show the name, condition and end date; no struck-through price is shown.',
    excludedTitle: 'Products without discount (price increase)',
    excludedLead:
      'Products whose price was raised within {{days}} days before the promotion started, or during it, get no discount from this promotion and do not show it on their page (discount sale rule). For a draft this is calculated as if it went live now.',
    excludedNone: 'No price increases; all target products are included.',
    excludedCount: '{{count}} product options are left out of the promotion.',
    colProduct: 'Product',
    colPriceList: 'Price list',
    colCurrent: 'Current price',
    colLowest: 'Lowest price in the period',
    usageTitle: 'Usage',
    usageNone: 'No orders with this promotion yet.',
    usageLine: '{{orders}} orders · total discount {{discount}} · order total {{revenue}}',
    dangerZone: 'Delete draft',
    deleteConfirm: 'Delete the "{{name}}" draft?',
    updated: 'Last changed: {{date}}',
  },
  giftCards: {
    lead: 'A gift card is a prepayment spent by entering its code at checkout. The code is shown only once when created; only its last four characters are stored. A partly used card keeps its remaining balance for later.',
    create: 'Create gift card',
    search: 'Last four characters',
    searchPlaceholder: 'e.g. 7KQ2',
    searchInvalid: 'Enter up to four letters or digits.',
    stateFilter: 'Status',
    states: { active: 'Usable', disabled: 'Disabled', expired: 'Expired', empty: 'No balance' },
    emptyTitle: 'No gift cards yet',
    emptyLead:
      'Use "Create gift card" to choose an amount and an optional expiry date; you pass the code to the customer.',
    noMatch: 'No cards match these filters',
    listLabel: 'Gift cards',
    colCard: 'Card',
    colState: 'Status',
    colBalance: 'Balance',
    colExpires: 'Expires',
    colCreated: 'Created',
    cardTitle: 'Card ···· {{last4}}',
    ofInitial: 'Initial {{amount}}',
    noExpiry: 'No expiry',
    createTitle: 'Create gift card',
    createLead: 'The code is shown only once. You pass it to the customer; no email is sent.',
    createForCustomer: 'The card is recorded for {{name}}. The code is shown only once; you pass it on.',
    createButton: 'Create',
    amount: 'Amount',
    amountInvalid: 'Enter the amount like 250 or 250.50.',
    currency: 'Currency',
    expiresAt: 'Expiry date',
    expiresHint: 'Valid until the end of the chosen day. Leave empty for no expiry.',
    note: 'Internal note',
    noteHint: 'Visible in the panel only (e.g. "Birthday gift").',
    createdTitle: 'Gift card created',
    createdLead: 'The code of the {{amount}} card is below.',
    code: 'Code',
    copy: 'Copy code',
    copied: 'Code copied',
    copyFailed: 'Could not copy; select the code and copy it by hand.',
    codeOnce:
      'This code will not be shown again. Copy it before closing and pass it to the customer securely. If it is lost, disable the card and create a new one.',
    openCard: 'Open card',
    savedCode: 'I saved the code',
    backToList: 'Gift cards',
    summary: 'Card',
    balance: 'Balance',
    initial: 'Initial amount',
    customer: 'Customer',
    created: 'Created',
    adjust: 'Adjust balance',
    disable: 'Disable card',
    enable: 'Re-enable card',
    disableConfirm:
      'The card is disabled and its balance cannot be spent. Amounts used in earlier orders are not affected. Continue?',
    enableConfirm: 'The card becomes usable again. Continue?',
    settings: 'Expiry and note',
    history: 'Transactions',
    noHistory: 'No transactions.',
    colDate: 'Date',
    colKind: 'Type',
    colAmount: 'Amount',
    colAfter: 'Balance after',
    kinds: {
      issue: 'Created',
      redeem: 'Used in order',
      release: 'Order cancelled, restored',
      refund: 'Refund, restored',
      adjust: 'Manual adjustment',
    },
    adjustTitle: 'Adjust balance of card ···· {{last4}}',
    adjustLead: 'Current balance {{balance}}. The adjustment and its reason go to the history and audit log.',
    direction: 'Action',
    directionAdd: 'Add balance',
    directionSubtract: 'Deduct balance',
    adjustAmount: 'Amount ({{currency}})',
    adjustNote: 'Reason',
    adjustNoteHint: 'At least 3 characters, e.g. "Correcting a wrong top-up".',
    adjustAdd: 'Add',
    adjustSubtract: 'Deduct',
    adjusted: 'Balance updated',
  },
  storeCredit: {
    title: 'Store credit',
    lead: 'Credit in the customer account is spent at checkout with "Use my store credit". It comes from refunds (with the customer\'s consent) or is added by hand.',
    adjust: 'Add / deduct credit',
    issueGiftCard: 'Issue gift card',
    none: 'No credit.',
    history: 'Credit transactions',
    giftCards: 'Gift cards issued to this customer',
    kinds: {
      grant: 'Added',
      refund: 'Refund',
      redeem: 'Used in order',
      release: 'Order cancelled, restored',
      adjust: 'Deducted',
    },
    adjustTitle: 'Add / deduct store credit',
    adjustLead:
      'The reason goes to the history and audit log; the customer only sees the amount and type in their account.',
  },
  loyalty: {
    lead: 'Members earn points on delivered orders and pay with points at checkout; they get a VIP tier based on their spending in the last 12 months (tier discount and free shipping). While off, nothing applies to customers; points are kept.',
    summary: 'Program summary',
    on: 'On',
    off: 'Off',
    members: 'Members with points',
    outstanding: 'Unused points (value)',
    earned30: 'Earned, last 30 days',
    redeemed30: 'Redeemed, last 30 days',
    expired30: 'Expired, last 30 days',
    tierCounts: 'Members by tier: {{list}}',
    settings: 'Program settings',
    settingsLead:
      'Changes apply to carts and checkout as soon as they are saved. Existing orders do not change.',
    enabled: 'Loyalty program on',
    currency: 'Currency',
    earn: 'Points earned per 1 unit',
    value: 'Points needed for 1 unit off',
    preview:
      'Customers earn {{earn}} points for every {{one}}; {{value}} points = {{one}}. Return rate: {{percent}}.',
    previewNoEarn: 'Earning is off: only tiers apply.',
    minRedeem: 'Minimum points to use',
    holdDays: 'Wait after delivery (days)',
    expiryMonths: 'Point validity (months)',
    expiryHint: '0 = points never expire.',
    tiers: 'VIP tiers',
    tiersLead:
      "The tier is recalculated on each order from the customer's net spending in the last 12 months (refunds deducted). Up to 5 tiers.",
    tierName: 'Tier name',
    tierSpend: 'Last 12 months at least ({{currency}})',
    tierDiscount: 'Discount (%)',
    tierShipping: 'Free shipping',
    tierAdd: 'Add tier',
    tierRemove: 'Remove tier {{name}}',
    fixErrors: 'Not saved: fix the marked fields.',
    save: 'Save',
    saved: 'Loyalty program saved',
    enableConfirm:
      "When the program is on, tier discounts apply to members' carts immediately and delivered orders start earning points. No messages are sent to customers. Continue?",
    customerTitle: 'Loyalty',
    adjust: 'Add / deduct points',
    points: '{{points}} points',
    expiringSoon: '{{points}} points expire within 30 days.',
    customerTier: 'Tier: {{tier}}',
    customerNoTier: 'No tier',
    spend12: 'last 12 months {{amount}}',
    nextTier: '{{amount}} to {{tier}}',
    history: 'Points history',
    colDate: 'Date',
    colKind: 'Type',
    colPoints: 'Points',
    colExpires: 'Expires',
    kinds: {
      earn: 'Earned',
      redeem: 'Used in order',
      release: 'Restored',
      reverse: 'Taken back (refund)',
      expire: 'Expired',
      adjust: 'Manual adjustment',
    },
    adjustTitle: 'Add / deduct points',
    adjustLead:
      'Current balance {{points}} points. The reason goes to the history and audit log; the customer does not see it.',
    direction: 'Action',
    directionAdd: 'Add points',
    directionSubtract: 'Deduct points',
    pointsField: 'Points',
    pointsInvalid: 'Enter a positive whole number.',
    adjustAdd: 'Add',
    adjustSubtract: 'Deduct',
    adjusted: 'Points updated',
  },
  referrals: {
    lead: 'Members get their invite code on My account and share it with friends. A friend gets a discount on their first order; once the order is delivered and the waiting period has passed, the referrer receives a single-use reward coupon. The shop never messages anyone. While the program is off, invite codes do not work.',
    summary: 'Program summary',
    on: 'On',
    off: 'Off',
    codes: 'Members with an invite code',
    pending: 'Pending invites',
    rewarded: 'Rewarded invites',
    cancelled: 'Closed without reward',
    rewardCoupons: 'Reward coupons (issued / used)',
    rewardCouponsValue: '{{issued}} / {{used}}',
    settings: 'Program settings',
    settingsLead:
      'Saving updates all invite codes with the new discount. Reward coupons already issued do not change.',
    enabled: 'Referral program on',
    currency: 'Currency',
    friend: 'Friend discount (first order)',
    referrer: 'Referrer reward (coupon)',
    rewardType: 'Discount type',
    typePercent: 'Percentage',
    typeFixed: 'Fixed amount ({{currency}})',
    valuePercent: 'Discount (%)',
    valueFixed: 'Discount amount ({{currency}})',
    minSubtotal: 'Minimum cart total ({{currency}})',
    minSubtotalHint: 'Leave empty for no minimum.',
    holdDays: 'Wait after delivery (days)',
    rewardValidDays: 'Reward coupon validity (days)',
    maxRewards: 'Maximum rewards per member',
    fixErrors: 'Not saved: fix the marked fields.',
    save: 'Save',
    saved: 'Referral program saved',
    enableConfirm:
      'Once on, members can get an invite code on My account and invite codes work as discounts in the cart. No notifications are sent to customers. Continue?',
    recent: 'Recent invites',
    recentLead:
      'Orders placed with an invite code. Rewards are issued by the hourly job after the waiting period.',
    emptyTitle: 'No orders from invites yet',
    emptyLead: 'When a friend places a first order with an invite code, it appears here.',
    colDate: 'Date',
    colReferrer: 'Referrer',
    colOrder: 'Order',
    colStatus: 'Status',
    colReward: 'Reward coupon',
    statuses: {
      pending: 'Awaiting delivery',
      rewarded: 'Rewarded',
      cancelled: 'Cancelled / returned',
      limit: 'Reward limit reached',
    },
  },
  affiliates: {
    lead: 'Affiliate and influencer orders are matched by coupon code or by the utm_source value in the link. Link matching works only if the visitor allowed measurement cookies. Commission is calculated on the product amount excluding VAT and shipping and is approved 14 days after delivery. You make the payment: download the CSV, pay, then mark as paid.',
    create: 'Add affiliate',
    emptyTitle: 'No affiliates yet',
    emptyLead: 'Add an affiliate to give them their own coupon or link source.',
    listLabel: 'Affiliates',
    colName: 'Affiliate',
    colMatch: 'Matching',
    colRate: 'Rate',
    colPending: 'Pending',
    colApproved: 'Approved',
    colPaid: 'Paid',
    colActions: 'Actions',
    kinds: { affiliate: 'Affiliate', influencer: 'Influencer' },
    paused: 'Paused',
    coupon: 'Coupon: {{code}}',
    edit: 'Edit',
    editNamed: 'Edit {{name}}',
    createTitle: 'Add affiliate',
    editTitle: 'Edit affiliate',
    dialogLead: 'Rate and status changes apply only to future orders; recorded commissions do not change.',
    name: 'Name',
    kind: 'Type',
    email: 'Email',
    emailMasked: 'Email hidden. Type a new one to change it.',
    source: 'Link source (utm_source)',
    sourceHint: 'Add to the end of the link: ?utm_source={{source}}',
    rate: 'Commission rate (%)',
    discount: 'Coupon',
    noDiscount: 'No coupon (link only)',
    status: 'Status',
    statuses: { active: 'Active', paused: 'Paused' },
    note: 'Internal note',
    save: 'Save',
    created: 'Affiliate added',
    updated: 'Affiliate updated',
    commissions: 'Commissions',
    commissionsLead:
      'Pending commission is approved 14 days after delivery; it is cancelled on cancellation or full refund, and the base is reduced on partial refunds.',
    filterAffiliate: 'Affiliate',
    filterStatus: 'Status',
    export: 'Download CSV',
    markPaid: 'Mark as paid ({{count}})',
    selectAll: 'Select all approved commissions',
    selectOne: 'Select commission for {{order}}',
    noCommissions: 'No commissions',
    noCommissionsLead: 'Matched orders appear here.',
    colOrder: 'Order',
    colAffiliate: 'Affiliate',
    colBase: 'Base',
    colCommission: 'Commission',
    colStatus: 'Status',
    sources: { coupon: 'By coupon', link: 'By link' },
    commissionStatuses: { pending: 'Pending', approved: 'Approved', paid: 'Paid', cancelled: 'Cancelled' },
    markPaidTitle: 'Mark commissions as paid',
    markPaidLead:
      '{{count}} commissions, total {{total}}. Mark them only if you have paid outside the system; this cannot be undone and is recorded in the audit log.',
    paidNote: 'Payment note',
    paidNoteHint: 'e.g. receipt number and payment date.',
    markPaidConfirm: 'Mark as paid',
    markedPaid: '{{count}} commissions marked as paid',
  },
  support: {
    lead: 'Customers open requests from My account; contact form messages can also be converted to requests. Your reply to the customer is also sent by email; internal notes are visible to the team only. Customers can rate resolved requests from 1 to 5.',
    countsLabel: 'Request counts',
    countOpen: 'Awaiting reply: {{count}}',
    countWaiting: 'Awaiting customer: {{count}}',
    countUnassigned: 'Unassigned: {{count}}',
    listTitle: 'Requests',
    filterStatus: 'Status',
    filterActive: 'Open and waiting',
    filterAssigned: 'Assignee',
    assignedMe: 'Assigned to me',
    unassigned: 'Unassigned',
    filterPriority: 'Priority',
    search: 'Search',
    searchPlaceholder: 'Request no, email or subject',
    emptyTitle: 'No requests',
    emptyLead: 'Requests opened by customers under My account → Support requests appear here.',
    colTicket: 'Request',
    colCustomer: 'Customer',
    colStatus: 'Status',
    colAssignee: 'Assignee',
    colLast: 'Last activity',
    pageOf: 'Page {{page}} of {{pages}}',
    statuses: {
      open: 'Awaiting reply',
      waiting: 'Awaiting customer',
      resolved: 'Resolved',
      closed: 'Closed',
    },
    priorities: { low: 'Low', normal: 'Normal', high: 'High', urgent: 'Urgent' },
    categories: {
      order: 'Order',
      shipping: 'Shipping and delivery',
      return: 'Returns and exchanges',
      payment: 'Payment and invoice',
      product: 'Product information',
      account: 'Account',
      other: 'Other',
    },
    channels: { account: 'My account', contact_form: 'Contact form', panel: 'Panel', chat: 'Live chat' },
    kinds: { customer: 'Customer', staff: 'Reply', note: 'Internal note' },
    durationDays: '{{d}} d {{h}} h',
    durationHours: '{{h}} h {{m}} min',
    durationMinutes: '{{m}} min',
    report: 'Support and satisfaction report',
    reportLead:
      'Requests opened and resolved in the period, first response time (median), satisfaction scores and topics. Return reasons appear if you can view orders.',
    period: 'Period',
    lastDays: 'Last {{days}} days',
    statCreated: 'Opened',
    statResolved: 'Resolved',
    statOpen: 'Open now',
    statFirstResponse: 'First response (median)',
    statSatisfaction: 'Satisfaction',
    satisfactionValue: '{{avg}} / 5 ({{count}} ratings)',
    distribution: 'Score distribution',
    score: '{{score}} points',
    byCategory: 'Requests by topic',
    noData: 'No records in this period.',
    returnReasons: 'Return reasons',
    returnTotal: '{{count}} return requests',
    colReason: 'Reason',
    colRequests: 'Requests',
    colApproved: 'Approved',
    topReturned: 'Most returned products',
    units: '{{count}} units',
    macros: 'Saved replies',
    macrosLead:
      'Save frequent replies; pick and edit them while replying. {{name}} is replaced with the customer name.',
    macrosEmpty: 'No saved replies',
    macrosEmptyLead: 'For example, add a reply for shipping delays or the return process.',
    macroAdd: 'Add saved reply',
    macroEdit: 'Edit saved reply',
    macroEditNamed: 'Edit saved reply {{name}}',
    macroDeleteNamed: 'Delete saved reply {{name}}',
    macroDeleteConfirm: 'Delete saved reply "{{name}}"?',
    macroDeleted: 'Saved reply deleted',
    macroSaved: 'Saved reply saved',
    macroDialogLead: '{{name}} in the text is replaced with the customer name when inserted.',
    macroTitle: 'Name',
    macroBody: 'Reply text',
    macroBodyHint: 'Do not write personal data (order, address); add them to each reply.',
    ticketTitle: 'Request #{{number}}: {{subject}}',
    backToList: 'Back to requests',
    details: 'Request details',
    customer: 'Customer',
    guest: 'guest',
    order: 'Order',
    channel: 'Source',
    opened: 'Opened',
    firstResponse: 'First response time',
    noResponseYet: 'No reply yet',
    satisfaction: 'Satisfaction',
    ratingValue: '{{rating}} / 5',
    status: 'Status',
    priority: 'Priority',
    category: 'Topic',
    assignee: 'Assignee',
    notifyResolved: 'Email the customer that the request is resolved (with rating link)',
    saveDetails: 'Save changes',
    savedEmailed: 'Saved; the customer was emailed',
    savedNotEmailed: 'Saved; no email was sent because email is not set up (Setup required)',
    conversation: 'Conversation',
    emailed: 'Sent by email',
    notEmailed: 'Not emailed',
    closedHint:
      'The request is closed: you cannot reply to the customer, only add internal notes. Change the status to reply again.',
    insertMacro: 'Insert saved reply',
    chooseMacro: 'Choose…',
    replyLabel: 'Reply or internal note',
    noteLabel: 'Internal note',
    replyHint:
      'The reply is shown on the customer request page and also sent by email. Internal notes stay within the team.',
    sendReply: 'Send reply',
    sendAndResolve: 'Send and resolve',
    addNote: 'Add internal note',
    noteSaved: 'Internal note added',
    replySent: 'Reply sent; the customer was emailed',
    replySavedNotEmailed:
      'Reply saved; the customer sees it on the request page. No email was sent because email is not set up (Setup required).',
    convertTitle: 'Convert to support request',
    convertLead:
      'The message becomes the first customer message of the request and is marked as handled. The request link is emailed to the customer with your first reply.',
    subject: 'Request subject',
    convert: 'Convert to request',
    converted: 'Request #{{number}} created',
  },
  chat: {
    lead: 'Chats from the "Live support" window on the storefront. Visitors can start a chat only while at least one staff member is "Available for chat"; otherwise the window falls back to a message form (support request). The screen refreshes every 5 seconds.',
    disabledNotice:
      'Live chat is off: the window is not shown on the storefront. Turn it on in the settings below.',
    workspace: 'Chats',
    available: 'Available for chat',
    onlineAgents: 'Staff available now: {{count}}',
    waiting: 'Waiting',
    active: 'Ongoing',
    closedRecent: 'Closed in the last 24 hours',
    noWaiting: 'No waiting chats.',
    noActive: 'No ongoing chats.',
    noClosed: 'No closed chats.',
    anonymous: 'Anonymous visitor',
    visitor: 'Visitor',
    with: 'with {{name}}',
    pickTitle: 'Select a chat',
    pickLead: 'Select a chat from the list; you can take a waiting chat and reply.',
    statuses: { waiting: 'Waiting', active: 'Ongoing', closed: 'Closed' },
    noEmail: 'No email given',
    customerCard: 'Customer card',
    messages: 'Chat messages',
    events: {
      joined: 'Staff joined the chat',
      closed_visitor: 'Visitor ended the chat',
      closed_staff: 'Staff closed the chat',
      closed_idle: 'Closed due to inactivity',
      ticket: 'Converted to a support request',
    },
    openTicket: 'Open the support request',
    claim: 'Take chat',
    reply: 'Your reply',
    replyHint: 'Enter sends, Shift+Enter adds a line. The visitor sees "Support team", not your name.',
    send: 'Send',
    close: 'Close chat',
    closeConfirm: 'Close the chat? The visitor can start a new chat.',
    closedToast: 'Chat closed',
    convert: 'Convert to request',
    convertNeedsEmail: 'Cannot convert: the visitor gave no email.',
    convertTitle: 'Convert chat to support request',
    convertLead:
      'Visitor messages become customer messages and team messages become replies; the chat closes. Replies you write on the request are emailed to the customer.',
    settings: 'Chat settings',
    settingsLead: 'Chat is off by default. The privacy notice must be published to turn it on.',
    enabled: 'Live support window on the storefront',
    needsNotice: 'Chat cannot be turned on before the privacy notice is published (Legal texts).',
    retentionDays: 'Retention of closed chats (days)',
    idleMinutes: 'Close inactive chat after (minutes)',
    saveSettings: 'Save settings',
    settingsSaved: 'Chat settings saved',
  },
  ads: {
    sourcesTitle: 'Ad accounts and data',
    sourcesLead:
      'Spend data is read every morning from the Meta and TikTok connections, or you upload the report (CSV/XLSX) downloaded from the platform. Revenue is always calculated from the store’s real orders.',
    connections: 'Ad connections',
    connected: 'Connected',
    connectionError: 'Connection error',
    setupRequired: 'Setup required',
    manageConnections: 'Manage connections',
    googleNote:
      'To get Google Ads spend through the API every morning, connect the Google account with the "Google Ads" permission on the Google connections page and choose the customer account for the store (no developer token needed). Until then you can upload the Google Ads report as a file.',
    googleNoteLink: 'Google connections',
    syncNow: 'Sync now',
    synced: 'Synced: {{rows}} rows read.',
    syncFailed: 'Sync could not complete: {{error}}',
    addAccount: 'Add account',
    addAccountLead:
      'An ad account whose data you upload as a file. Meta and TikTok accounts are added automatically once connected.',
    editAccount: 'Edit account',
    editAccountFor: 'Edit account {{name}}',
    accountSaved: 'Account saved.',
    noAccounts: 'No ad accounts yet',
    noAccountsLead:
      'Connect Meta or TikTok, or add an account to upload Google Ads and other platform reports.',
    accountsTable: 'Ad accounts',
    account: 'Account',
    accountName: 'Account name',
    platform: 'Platform',
    externalId: 'Account ID on the platform',
    currency: 'Currency',
    utmSources: 'Matching sources (utm_source)',
    utmDefault: 'If left empty, the platform’s usual values are used (e.g. facebook, instagram for Meta).',
    noUtm: 'No sources defined',
    accountStatus: 'Status',
    active: 'Active',
    archived: 'Archived',
    source: 'Data source',
    sources: { api: 'API sync', file: 'File' },
    lastData: 'Last sync',
    automatic: 'Automatic',
    platforms: { google_ads: 'Google Ads', meta: 'Meta', tiktok: 'TikTok', other: 'Other' },
    uploadReport: 'Upload report',
    uploadTitle: '{{name}} — upload report',
    uploadLead:
      'Upload the platform’s daily breakdown report (date, campaign, spend; optionally ad group, ad, impressions, clicks). Amounts must be in {{currency}}.',
    chooseFile: 'Choose file',
    applyImport: 'Save data',
    imported: 'Saved: {{inserted}} new, {{updated}} updated rows.',
    previewFile: 'File',
    previewRows: 'Rows',
    previewRowsValue: '{{valid}} of {{rows}} rows valid, {{skipped}} skipped',
    previewPeriod: 'Period',
    previewSpend: 'Total spend',
    previewCampaigns: 'Campaigns',
    previewErrors: 'Skipped rows (first 20)',
    rowError: 'Row {{row}}: {{error}}',
    rowErrors: {
      ads_import_date: 'date unreadable or in the future',
      ads_import_campaign: 'no campaign name or a totals row',
      ads_import_currency: 'currency differs from the account',
      ads_import_amount: 'amount or number unreadable',
    },
    reportTitle: 'Campaign performance',
    reportLead:
      'Platform data together with store orders. Revenue comes from paid orders whose last visit source is one of the account’s sources and whose campaign (utm_campaign) matches.',
    period: 'Period',
    lastDays: 'Last {{n}} days',
    allPlatforms: 'All platforms',
    noData: 'No ad data in this period',
    noDataLead: 'Wait for connections to sync or upload a report for an account.',
    totalsLabel: 'Totals ({{currency}})',
    campaignsTable: 'Campaigns',
    campaign: 'Campaign',
    unmatchedCampaign: 'Orders with no matching campaign',
    spend: 'Spend',
    impressions: 'Impressions',
    clicks: 'Clicks',
    ctr: 'CTR',
    cpc: 'CPC',
    cpm: 'CPM',
    platformConversions: 'Platform conversions',
    orders: 'Orders',
    revenue: 'Revenue',
    cpa: 'Cost per order',
    newCustomers: 'New customers',
    cac: 'Cost per new customer (CAC)',
    roas: 'ROAS',
    profit: 'Profit after ads',
    revenueNote:
      'Revenue is the product amount excluding VAT and shipping, less refunds and cancellations. Platform conversions are for comparison only.',
    profitNote:
      'Profit = revenue − product cost − ad spend. If any product in an order has no cost, profit is not shown (—).',
    profitHidden: 'Viewing profit after ads requires the cost viewing permission.',
    currencyMismatch: '{{n}} orders were left out because their currency differs from the ad account.',
    compare: 'Compare',
    compareThis: 'Add campaign {{name}} to comparison',
    compareHint: 'Select up to {{n}} campaigns to compare.',
    compareTitle: 'Campaign comparison',
    metric: 'Metric',
    anomaliesTitle: 'Alerts',
    noAnomalies: 'Nothing unusual in the latest data.',
    anomalyKinds: {
      spend_spike: 'Spend spike',
      ctr_drop: 'CTR dropped',
      no_clicks: 'Spend without clicks',
      sync_failed: 'Sync error',
      sync_stale: 'Stale data',
    },
    anomalyText: {
      spend_spike:
        '{{account}} · {{campaign}}: spend on {{date}} was {{value}}, previous 7-day average {{baseline}}.',
      ctr_drop: '{{account}} · {{campaign}}: CTR on {{date}} is below half of the previous 7 days.',
      no_clicks: '{{account}} · {{campaign}}: {{value}} spent on {{date}} with no clicks.',
      sync_failed: '{{account}}: the last sync failed. Check the connection token.',
      sync_stale: '{{account}}: no new data for more than 2 days.',
    },
    productsTitle: 'Product performance (orders from ads)',
    product: 'Product',
    quantity: 'Quantity',
    productRevenue: 'Net sales',
    productAdsTitle: 'Shopping ad products (Google Ads)',
    productAdsNote:
      'Spend and clicks from Google’s product report; net sales are this product in paid orders from the same account (matched by SKU).',
    requestChange: 'Request change',
    changeTitle: 'Request a budget or delivery change',
    changeLead: '{{account}} · {{campaign}}. Once approved, you apply the change on the ad platform.',
    changeKind: 'Change',
    kinds: { budget: 'Change daily budget', status: 'Change delivery status' },
    dailyBudget: 'New daily budget ({{currency}})',
    budgetInvalid: 'Enter a valid amount (e.g. 750 or 750.50).',
    targetStatus: 'New status',
    targets: { paused: 'Pause delivery', active: 'Resume delivery' },
    changeNote: 'Reason',
    changeManualNote:
      'The system never changes anything on the ad platform by itself; after approval, apply it on the platform and mark it "Applied".',
    sendRequest: 'Send for approval',
    changeRequested: 'Request sent for approval.',
    changeUpdated: 'Request updated.',
    historyTitle: 'Change history',
    historyLead: 'Budget and delivery requests, approvals and data uploads.',
    changesTable: 'Change requests',
    noChanges: 'No change requests yet.',
    when: 'Date',
    request: 'Request',
    status: 'Status',
    budgetTo: 'Daily budget: {{amount}}',
    requestedBy: 'Requested by: {{name}}',
    decidedBy: '{{name}}, {{at}}',
    appliedAt: 'Applied: {{at}}',
    changeStatuses: {
      pending: 'Awaiting approval',
      approved: 'Approved — to apply',
      rejected: 'Rejected',
      applied: 'Applied',
      cancelled: 'Cancelled',
    },
    decide: 'Decide',
    decideTitle: 'Change request',
    decideLead: '{{campaign}}: {{change}}',
    decisionNote: 'Decision note',
    approve: 'Approve',
    reject: 'Reject',
    markApplied: 'Applied',
    markAppliedConfirm: 'Have you applied the change on the ad platform? It will be marked as applied.',
    cancelRequest: 'Cancel',
    cancelConfirm: 'Cancel the pending request?',
    runsTitle: 'Data uploads and syncs',
    noRuns: 'No data uploaded yet.',
    runRows: 'Rows',
    runRowsValue: '{{inserted}} new · {{updated}} updated · {{skipped}} skipped',
    gcTitle: 'Google Ads conversion upload',
    gcLead:
      'Reports paid orders from ads to Google Ads as conversions so bidding learns from real sales. Off by default.',
    gcPrivacy:
      'When on, for orders from visitors who consented to marketing cookies the Google click ID (gclid), order number, value and time are sent to Google (abroad). Confirm with your lawyer that your privacy notice covers this before turning it on. No name, email or phone is sent.',
    gcEnabled: 'Upload paid orders to Google Ads as conversions',
    gcEnabledHint: 'Every morning after the sync; last 60 days, once per order.',
    gcAction: 'Conversion action',
    gcActionHint:
      'A "click import" conversion action in Google Ads → Goals → Conversions; resource name customers/…/conversionActions/….',
    gcSaved: 'Conversion upload setting saved.',
    gcNoUploads: 'No conversions uploaded yet.',
    gcUploaded: '{{count}} orders uploaded ({{value}})',
    gcFailed: '{{count}} orders rejected by Google',
    runStatuses: { ok: 'OK', partial: 'Partial', failed: 'Failed' },
  },
  googleReports: {
    ga4Title: 'Analytics (GA4) report',
    ga4Lead:
      'Linked property: {{property}}. Up to yesterday; Google Analytics data comes from visitors who consented to measurement.',
    ga4LeadEmpty: 'Channel and daily report of the GA4 property linked to the store.',
    period: 'Period',
    lastDays: 'Last {{n}} days',
    totals: 'Period totals',
    sessions: 'Sessions',
    users: 'Users',
    keyEvents: 'Key events',
    revenue: 'Purchase revenue',
    byChannel: 'By channel',
    byDay: 'By day',
    channel: 'Channel',
    day: 'Day',
    noData: 'No GA4 data in this period.',
    ga4Note:
      'GA4 revenue covers only visitors who consented to measurement and excludes refunds/cancellations; for exact sales see the Sales and Campaigns and sources reports. Users are not summed across rows (one person may arrive via several channels).',
    gbpTitle: 'Google Business Profile',
    gbpLead: 'Location details and the latest 50 Google reviews (read only). Reviews are answered on Google.',
    location: 'Location',
    address: 'Address',
    phone: 'Phone',
    website: 'Website',
    rating: 'Average rating',
    ratingValue: '{{avg}} / 5 ({{count}} reviews)',
    replyOnGoogle: 'Open in Google Maps and reply to reviews',
    reviews: 'Google reviews',
    noReviews: 'No reviews yet.',
    anonymous: 'Google user',
    stars: '{{n}} stars',
    replied: 'Your reply: {{reply}}',
    noReply: 'Not answered yet.',
    problem_google_not_linked: 'No Google resource is linked to this store',
    problem_google_scope_missing: 'The Google account did not grant permission for this service',
    problem_google_not_connected: 'No Google account is connected',
    problemLead:
      'On the Google connections page connect the account with the needed permission and choose a property or location for the store.',
    openConnections: 'Go to Google connections',
  },
  trackingEvents: {
    title: 'Event manager',
    lead: 'Which storefront e-commerce events go to which measurement service, and custom events you define.',
    standardTitle: 'Standard events',
    event: 'Event',
    sendTo: '{{event}}: send to {{provider}}',
    notApplicable: 'No equivalent in this service',
    events: {
      view_item_list: 'Product list view',
      select_item: 'Select product from list',
      view_item: 'Product view',
      add_to_cart: 'Add to cart',
      remove_from_cart: 'Remove from cart',
      view_cart: 'View cart',
      begin_checkout: 'Begin checkout',
      add_shipping_info: 'Shipping info',
      add_payment_info: 'Payment info',
      purchase: 'Purchase',
      search: 'Search',
      sign_up: 'Sign up',
      login: 'Log in',
      generate_lead: 'Form submission (dealer, contact)',
      quiz_start: 'Needs finder started',
      quiz_step: 'Needs finder step',
      quiz_complete: 'Needs finder result',
    },
    customTitle: 'Custom events',
    customLead:
      'Measure views of a specific page or clicks on phone, email, WhatsApp and outbound links. No personal data is sent; for outbound links only the domain.',
    noCustom: 'No custom events.',
    name: 'Event name',
    nameHint: 'Lowercase letters, digits and underscore; e.g. campaign_viewed',
    trigger: 'When',
    triggers: {
      page_view: 'When the page is viewed',
      click_phone: 'When a phone link is clicked',
      click_email: 'When an email link is clicked',
      click_whatsapp: 'When a WhatsApp link is clicked',
      click_outbound: 'When a link to another site is clicked',
    },
    path: 'Page path',
    pathHint: 'Exact path (/campaign/october) or add * to match the beginning (/campaign/*)',
    destinations: 'Send to',
    addTitle: 'Add custom event',
    add: 'Add to list',
    remove: 'Remove {{name}}',
    consentNote:
      'Events are only sent while the cookie policy is published and the visitor consented to the cookie type (GA4: analytics; Meta and TikTok: marketing). The Google Ads purchase conversion is managed in the tag settings.',
    save: 'Save event settings',
    saved: 'Event settings saved. They apply on the storefront within a few minutes.',
  },
  credit: {
    available: 'Remaining credit: {{amount}}',
    overdue: 'Overdue debt: {{amount}}',
    overrideLead:
      'You can manage dealer accounts: enter a reason and save again to place the order over the limit (two-step verification; audit logged).',
    overrideReason: 'Override reason',
    summary: 'Credit limit {{limit}} · remaining {{available}}',
    blocked: {
      overdue: 'Open account is blocked because of overdue debt.',
      currency: 'The limit is in another currency: open account is closed in this currency.',
    },
    limit: 'Credit limit',
    limitHint: 'Leave empty for no limit.',
    currency: 'Limit currency',
    blockWhenOverdue: 'Block open account when overdue',
    limitColumn: 'Limit / remaining',
  },
  compliance: {
    title: 'Country eligibility',
    lead: 'Whether the product may be sold in each country, its registration/permit number and verification status. Countries without a record allow sales.',
    add: 'Add country',
    editTitle: 'Edit country record',
    dialogLead:
      'A blocked product is not listed in that country’s market, does not appear in search or the feed and cannot be added to the cart. The reason and note are not shown to visitors.',
    empty: 'No country records',
    emptyLead:
      'The product may be sold in every country. Add a country if it cannot be sold there or to enter a registration number.',
    country: 'Country',
    saleStatus: 'Sales status',
    status: { allowed: 'For sale', blocked: 'Not for sale' },
    allowedLead: 'For sale',
    reason: 'Reason',
    reasons: {
      registration_missing: 'Registration/permit missing or pending',
      legal_restriction: 'Legal restriction',
      shipping_restriction: 'Shipping/customs restriction',
      business_decision: 'Business decision',
      other: 'Other',
    },
    registrationNo: 'Registration / permit number',
    registrationHint:
      'E.g. the ministry registration number or an EU feed additive approval. Only verified numbers are shown in the store.',
    registrationShort: 'Reg. no {{no}}',
    verificationLabel: 'Verification',
    verification: { unverified: 'Not verified', verified: 'Verified', not_required: 'Not required' },
    verifiedAt: 'Verified: {{date}}',
    note: 'Internal note',
    confirmDelete: 'Delete the {{country}} record? The product becomes available for sale there again.',
  },
  fx: {
    statusTitle: 'Rate source',
    sourceLead:
      'The Central Bank of Türkiye (CBRT) publishes its rate bulletin around 15:30 on business days; rates are fetched automatically after 15:40. Rates are never made up: if fetching fails, the last valid rate and its date are used.',
    source: 'Source',
    sourceName: 'CBRT indicative exchange rates',
    bulletinLabel: 'Latest bulletin',
    bulletin: 'Bulletin of {{date}}',
    bulletinNo: 'no. {{no}}',
    noBulletin: 'No rates fetched yet',
    lastSuccess: 'Last successful fetch',
    nextAttempt: 'Next attempt',
    nextAttemptNone: 'Not scheduled (starts once a foreign currency is used)',
    lastError: 'Last error',
    refresh: 'Update rates now',
    refreshResult: {
      updated: 'New bulletin fetched ({{date}}); {{count}} lists recalculated.',
      unchanged: 'Rates are up to date (bulletin of {{date}}).',
      throttled: 'Just tried; try again in a minute.',
      not_needed: 'No market or price list uses a currency other than TRY; no rates fetched.',
      not_due: 'Not due yet.',
      failed: 'Could not reach the CBRT: {{error}}',
    },
    stale: {
      no_data: 'No rates yet; rate-derived lists cannot be calculated.',
      old_bulletin: 'Rates are old: the latest bulletin is from {{date}}. Prices and orders keep using it.',
      fetch_failing:
        'Rates cannot be fetched ({{count}} attempts failed). The last valid rate ({{date}}) is used.',
    },
    ratesTitle: 'Rates',
    ratesLead: 'Value in TRY; when the unit is not 1 (e.g. JPY 100) it is the value of that many units.',
    currency: 'Currency',
    unit: 'Unit',
    rateTypes: {
      forex_buying: 'Forex buying',
      forex_selling: 'Forex selling',
      banknote_buying: 'Banknote buying',
      banknote_selling: 'Banknote selling',
    },
    notPublished: 'not published',
    inUse: 'In use',
    noRates: 'No rates yet',
    noRatesLead:
      'Rates are fetched once a market or price list uses a currency other than TRY; use "Update rates now" to fetch immediately.',
    derivedTitle: 'Rate-derived price lists',
    derivedLead:
      'Prices are calculated from the base list with the selected rate; they cannot be entered manually.',
    toPricing: 'Go to price lists',
    noDerived: 'No rate-derived lists',
    noDerivedLead: 'Use "Derive from rate" on a list on the Pricing page.',
    derivedFrom: 'from {{base}} ({{currency}})',
    rule: '{{rateType}} · markup {{markup}} · price ending {{ending}}',
    auto: 'Updates automatically',
    manualOnly: 'Recalculated manually',
    applied: 'Bulletin of {{date}}: {{pair}} · {{count}} prices',
    notApplied: 'Not calculated yet (no rate)',
    behind: 'Not calculated with the latest bulletin',
    recompute: 'Recalculate now',
    recomputed: 'List recalculated with the latest rate; {{count}} prices changed.',
    pair: '{{unit}} {{currency}} = {{rate}} TRY',
    deriveButton: 'Derive from rate',
    deriveTitle: '{{name}} — derive from rate',
    deriveLead:
      'Prices of this list ({{currency}}) are calculated from the base list with the CBRT rate. Calculated prices replace the current ones (recorded in price history); manual prices cannot be entered.',
    lastApplied: 'Last calculation: bulletin of {{date}}, {{pair}} ({{rateType}}).',
    baseList: 'Base list',
    baseListHint: 'A manually priced list in another currency. Tiered prices are converted too.',
    rateType: 'Rate type',
    markup: 'Markup (%)',
    markupHint: 'Applied after conversion; use a minus sign to lower (e.g. -5).',
    markupInvalid: 'Enter the rate like 5 or -2.5.',
    autoLabel: 'Update automatically on a new bulletin and when base prices change',
    saved: 'Rate settings saved; {{count}} prices updated.',
    savedNoRate: 'Rate settings saved but the list could not be calculated: {{reason}}',
    clear: 'Switch to manual prices',
    confirmClear:
      'The list becomes manually priced; current prices stay and are no longer updated by rate. Continue?',
    cleared: 'The list is now manually priced.',
    badge: 'Rate · {{base}}',
    noBaseOptions:
      'No manually priced list in another currency. Create the base list (e.g. TRY retail) first.',
    orderRate: 'Exchange rate',
    orderRateLine: '{{pair}} · CBRT forex buying · bulletin of {{date}} ({{no}})',
    orderRateNone: 'No rate was available when the order was placed (none was made up).',
    orderTryEquivalent: 'TRY equivalent (at the order-time rate, for information): {{amount}}',
    orderRateStale: 'The rate was old when the order was placed.',
    orderListRate: '{{name}} prices: {{pair}} ({{rateType}}, bulletin of {{date}})',
  },
  internationalReport: {
    csv: 'Download CSV',
    from: 'From',
    to: 'To',
    store: 'Store',
    allStores: 'All stores',
    note: 'Country is the shipping address country. Amounts are in the order currency; different currencies are not added together. Gross includes VAT, less cancelled items; net = gross − refunds. Export: VAT-exempt (export) orders. The TRY equivalent uses the CBRT rate recorded on the order.',
    empty: 'No orders in this period',
    emptyLead: 'Draft and cancelled orders are not counted. Change the period or the store.',
    totalOrders: 'Orders',
    tryNet: 'Net (TRY equivalent)',
    exportOrders: 'Export orders',
    exportTryNet: 'Export net (TRY equivalent)',
    withoutRate:
      '{{count}} foreign-currency orders have no recorded rate and are left out of the TRY equivalent.',
    caption: 'Sales by country and currency',
    country: 'Country',
    currency: 'Currency',
    orders: 'Orders',
    gross: 'Gross',
    tax: 'VAT',
    shipping: 'Shipping',
    refunded: 'Refunds',
    net: 'Net',
    unknown: 'No address',
    rowWithoutRate: '{{count}} without rate',
    currencyTotal: 'Total',
  },
  dealerReports: {
    csv: 'Download CSV',
    report: 'Report',
    reports: {
      sales: 'Sales',
      products: 'Products',
      categories: 'Categories',
      aging: 'Aging',
      collections: 'Collections',
    },
    from: 'From',
    to: 'To',
    groupBy: 'Group by',
    groups: { company: 'Dealer', rep: 'Sales rep', region: 'Region' },
    none: { company: 'No company', rep: 'No sales rep', region: 'No region' },
    rep: 'Sales rep',
    region: 'Region',
    all: 'All',
    noRep: 'No sales rep',
    noRegion: 'No region',
    notes: {
      sales:
        'Dealer orders placed in the period (drafts and cancellations excluded). Gross: order total − cancelled items (incl. VAT). Net: gross − refunds. Product sales exclude VAT and shipping. Sales rep is the rep on the order; region is the dealer’s current region.',
      products:
        'Quantity and sales excluding VAT per product in dealer orders of the period (cancelled quantities excluded).',
      categories:
        'Every category of a product is counted: a product in several categories appears in each; the bottom row is the product sales total.',
      aging:
        'Open items as of today by days past due (this system’s dealer ledger; payments apply to the oldest due debt). BizimHesap balance is for reference. Sales rep and region are the dealer’s current assignment.',
      collections:
        'Payments recorded on dealer accounts in the period (reversed ones excluded); "Order payment" is recorded with "Payment received" on the order.',
    },
    orders: 'Orders',
    dealers: 'Dealers',
    gross: 'Gross (incl. VAT)',
    refunded: 'Refunds',
    net: 'Net (incl. VAT)',
    netExTax: 'Product sales (excl. VAT)',
    average: 'Average order',
    lastOrder: 'Last order',
    total: 'Total',
    product: 'Product',
    quantity: 'Quantity',
    category: 'Category',
    noCategory: 'No category',
    productTotal: 'Product sales total',
    balance: 'Balance',
    buckets: {
      notDue: 'Not due',
      d1_30: '1–30 days',
      d31_60: '31–60 days',
      d61_90: '61–90 days',
      d90plus: '90+ days',
    },
    bizimhesap: 'BizimHesap balance',
    oldest: 'Oldest overdue',
    days: '{{days}} days',
    count: 'Payments',
    collected: 'Total collected',
    methods: {
      bank_transfer: 'Bank transfer',
      cash: 'Cash',
      card: 'Card',
      cheque: 'Cheque',
      note: 'Promissory note',
      other: 'Other',
      order: 'Order payment',
    },
    emptySales: 'No dealer orders in this period.',
    emptyAging: 'No dealer has an open balance.',
    emptyCollections: 'No payments in this period.',
    emptyLead: 'Change the dates or filters.',
  },
  dealerCampaigns: {
    companies: 'Dealer companies',
    search: 'Search by name, dealer code or tax number',
    companiesNote:
      'Companies selected: the campaign applies only to users of these dealers (audience: dealers). Group and segment selections also apply.',
    forCompanies: 'For {{count}} dealers',
    couponFor: 'Only: {{names}}',
  },
  balancePayments: {
    recent: {
      title: 'Recent dealer payments',
      lead: 'Payments dealers made by card from My account → My dealer account (last 30 days). Each payment is posted to the dealer account automatically; the money goes to your payment provider account.',
      all: 'Dealer accounts',
      empty: 'No dealer card payments in the last {{days}} days.',
      email: 'Email on dealer payment',
      emailOn: 'Alert recipients get an email when a dealer pays.',
      emailOff: 'Email on dealer payment is off.',
    },
    title: 'Card balance payments',
    lead: 'Payments the dealer made by card from My account → My dealer account. Received payments are posted to the ledger as card collections automatically.',
    reference: 'Payment key',
    status: 'Status',
    card: 'Card',
    sandbox: 'Test',
    installments: '{{count}} instalments',
    modes: { balance: 'Full balance', items: 'Selected items', custom: 'Amount' },
    providers: { iyzico: 'iyzico', paytr: 'PayTR' },
    statuses: {
      pending: 'Pending',
      captured: 'Received',
      failed: 'Failed',
      expired: 'Expired',
      requires_action: 'Under review',
    },
    reviewHint:
      "{{reason}} Not posted: check the payment provider's panel; if the money was received, enter a card collection with Record payment.",
    reasons: {
      amount_mismatch: 'The provider reported a different amount.',
      amount_unverified: 'The amount could not be verified.',
      currency_mismatch: 'Different currency.',
      provider_review: 'The provider is reviewing the payment.',
      provider_review_stale: 'The provider review took too long.',
      provider_unreachable: 'The provider could not be reached.',
      test_mode_payment: 'Test transaction in the live environment.',
      other: 'The result is not final.',
    },
  },
  bankImport: {
    open: 'Upload bank transactions',
    back: 'Back to dealer accounts',
    columns:
      'Upload your bank account transactions as CSV or Excel (XLSX). Required columns: Date and Amount (or separate Credit/Debit). Description, Sender and Reference are used for matching when present. Only incoming transactions are taken.',
    file: 'Bank statement',
    summary:
      '{{incoming}} incoming transactions: {{matched}} matched a dealer, {{ambiguous}} with several candidates, {{unmatched}} unmatched, {{blocked}} cannot be posted. {{outgoing}} outgoing transactions skipped.',
    validUntil: 'The preview is valid until {{time}}.',
    tableCaption: 'Bank transactions and suggested dealers',
    pick: 'Select',
    pickRow: 'Post line {{line}}',
    date: 'Date',
    description: 'Description',
    amount: 'Amount',
    dealer: 'Dealer',
    dealerFor: 'Dealer for line {{line}}',
    matchColumn: 'Match',
    reference: 'Reference {{ref}}',
    line: 'File line {{line}}',
    chooseDealer: 'Choose a dealer',
    candidates: 'Candidates',
    allDealers: 'All dealers',
    match: {
      order: 'Order {{number}}',
      code: 'Dealer code',
      bizimhesap: 'BizimHesap code',
      tax: 'Tax number',
      name: 'Similar name — check',
      ambiguous: 'Several candidates',
      none: 'No match',
    },
    issues: {
      amount_invalid: 'Unreadable amount',
      date_invalid: 'Unreadable date',
      date_in_future: 'Future date',
      duplicate: 'Already posted',
    },
    apply: 'Post selected ({{count}} transactions · {{total}})',
    missingDealer: 'Choose a dealer for every selected line.',
    applied: '{{count}} payments posted to the ledger.',
    appliedWithBh: '{{count}} payments posted; {{queued}} entered the BizimHesap collection queue.',
    alreadyApplied: 'This statement was posted. Upload the statement again for new transactions.',
  },
  ledger: {
    import: 'Import opening balances',
    importLead: 'Import dealer balances from your previous accounting. A preview is shown first.',
    importColumns:
      'Columns: dealer code or tax number, amount (debit positive, credit negative), optional currency (TRY if empty), date, due date and description. CSV (semicolon) or Excel.',
    importFile: 'File',
    importSummary:
      '{{valid}} rows will be imported, {{invalid}} rows have errors (skipped). Total: {{totals}}',
    importAlready:
      '{{count}} dealers in this file already have an opening balance. Make sure you do not import twice.',
    importApply: 'Post {{count}} rows',
    importApplied: '{{count}} opening balance entries posted.',
    importPreview: 'Opening balance preview',
    importLine: 'Row',
    importStatus: 'Status',
    importOk: 'Will be imported',
    importErrors: {
      dealer_key_required: 'No dealer code or tax number.',
      dealer_not_found: 'Dealer not found.',
      currency_invalid: 'Invalid currency (e.g. TRY, EUR).',
      amount_invalid: 'Amount could not be read.',
      amount_zero: 'Amount is zero.',
      date_invalid: 'Date could not be read.',
      date_in_future: 'Date is in the future.',
      due_date_invalid: 'Due date could not be read.',
    },
    totals: 'Totals',
    totalBalance: 'Total balance ({{currency}})',
    totalOverdue: 'Overdue: {{amount}}',
    search: 'Search dealers',
    onlyOverdue: 'Overdue only',
    empty: 'No dealer account activity',
    emptyLead:
      'Open-account orders are posted automatically. Use "Import opening balances" for previous balances.',
    listCaption: 'Dealer accounts',
    dealer: 'Dealer',
    balance: 'Balance',
    overdue: 'Overdue',
    notDue: 'Not yet due',
    oldestOverdue: 'Oldest due date',
    daysOverdue: '{{date}} ({{days}} days overdue)',
    lastEntry: 'Last entry',
    companyTitle: '{{name}} — account',
    toDealer: 'Dealer card',
    term: 'Payment term: {{days}} days after the order. A positive balance means the dealer owes you.',
    noEntries: 'No account activity yet',
    noEntriesLead: 'Open-account orders, payments and opening balances appear here.',
    statement: 'Statement',
    csv: 'Download statement (CSV)',
    print: 'Print',
    currency: 'Currency',
    from: 'From',
    to: 'To',
    date: 'Date',
    kind: 'Type',
    description: 'Description',
    dueDate: 'Due date',
    debit: 'Debit',
    credit: 'Credit',
    actions: 'Actions',
    broughtForward: 'Brought forward',
    periodTotal: 'Period total / closing balance',
    reversedBadge: 'Reversed',
    kinds: {
      order: 'Order',
      order_change: 'Order change',
      order_payment: 'Order payment',
      payment: 'Payment',
      opening: 'Opening balance',
      adjustment: 'Adjustment',
      reversal: 'Reversal',
    },
    reasons: {
      placed: 'Order placed',
      cancelled: 'Cancelled',
      partial_cancel: 'Partial cancellation',
      edited: 'Order edited',
      refunded: 'Refund',
      paid: 'Payment received',
      refund_paid: 'Refund paid out',
      card_balance: 'Card payment from My account',
      changed: 'Amount changed',
    },
    methods: {
      bank_transfer: 'Bank transfer',
      cash: 'Cash',
      cheque: 'Cheque',
      note: 'Promissory note',
      card: 'Card',
      other: 'Other',
    },
    payment: 'Record payment',
    paymentLead:
      'Money received from the dealer is recorded as a credit and applied to the oldest due debt. If the dealer is linked to BizimHesap, bank transfer, cash and card collections also enter the BizimHesap collection queue (sent at once when writing to BizimHesap is on).',
    paymentSaved: 'Payment recorded.',
    adjustment: 'Record adjustment',
    adjustmentLead: 'A manual entry that increases or decreases the dealer debt. A description is required.',
    adjustmentSaved: 'Adjustment recorded.',
    direction: 'Direction',
    directions: { debit: 'Debit (dealer owes more)', credit: 'Credit (dealer owes less)' },
    amount: 'Amount',
    amountIn: 'Amount ({{currency}})',
    amountInvalid: 'Amount could not be read (e.g. 1,250.50).',
    entryDate: 'Entry date',
    method: 'Payment method',
    reference: 'Document no',
    reverse: 'Reverse',
    reverseTitle: 'Reverse entry',
    reverseLead: 'The {{kind}} entry ({{amount}}) is cancelled by an opposite entry. Nothing is deleted.',
    reverseReason: 'Reason',
    reversed: 'Entry reversed.',
    openItems: 'Open items',
    openItemsLead: 'Unpaid amounts, oldest due date first. Payments are applied to the oldest due debt.',
    openItem: 'Order / entry',
    original: 'Amount',
    open: 'Remaining',
    reminders: {
      title: 'Payment reminders',
      lead: 'A morning email to dealers for amounts due soon or overdue. Off by default.',
      noMail:
        'Email delivery is not set up (Setup required): no emails are sent even when reminders are on. Connect an email provider (SMTP, Amazon SES, SendGrid or Postmark) on the Integrations page.',
      enabled: 'Send payment reminders to dealers',
      daysBefore: 'Days before the due date',
      daysInvalid: 'Enter a number of days between 0 and 30.',
      confirm:
        'I confirm that dealers with open items (company email and company owners) will receive real emails every morning.',
      saved: 'Payment reminder setting saved.',
    },
  },
  sales: {
    sectionTitle: 'Sales rep and region',
    sectionLead:
      'With "assigned dealers only" scope, the rep and the region manager see this dealer, its users, orders and quotes.',
    rep: 'Sales rep',
    region: 'Sales region',
    noRep: 'No rep',
    noRegion: 'No region',
    saveAssignment: 'Save assignment',
    repLabel: 'Rep: {{name}}',
    regionLabel: 'Region: {{name}}',
    newRegion: 'Add region',
    editRegion: 'Edit region {{name}}',
    saveRegion: 'Save region',
    regionSaved: 'Region saved.',
    regionDeleted: 'Region deleted.',
    emptyRegions: 'No sales regions yet',
    emptyRegionsLead:
      'Create regions from provinces/districts, assign a manager and group dealers by location.',
    regionsTable: 'Sales regions',
    regionName: 'Region name',
    places: 'Provinces and districts',
    manager: 'Region manager',
    noManager: 'No manager',
    dealerCount: 'Dealers',
    morePlaces: 'and {{count}} more',
    confirmDelete:
      'Delete region {{name}}? {{count}} dealers lose their region; dealers and orders are not affected.',
    city: 'Province',
    district: 'District',
    wholeCity: 'Whole province',
    addPlace: 'Add',
    chosenPlaces: 'Provinces and districts in the region',
    removePlace: 'Remove {{place}} from the region',
    noPlaces: 'No provinces or districts yet.',
    autoAssign: 'Assign by province/district',
    autoAssignLead:
      'Dealers’ province/district is matched to regions: district first, otherwise the whole province. A preview comes first; nothing is written.',
    reassignAll: 'Also re-match dealers that already have a region',
    previewAssign: 'Preview',
    previewSummary: '{{assigned}} dealers will be assigned; {{unmatched}} dealers match no region.',
    applyAssign: 'Assign {{count}} dealers',
    autoAssigned: '{{count}} dealers assigned to regions.',
  },
  bizimhesap: {
    reversedFixAtBh: 'Reversed in the ledger; correct the collection in BizimHesap by hand.',
    ledgerEntry: 'BizimHesap collection {{number}}: {{status}}',
    statement: {
      title: 'BizimHesap statement',
      lead: 'BizimHesap is the master record: the balance is the last running balance of the statement. The credit limit is checked against this balance plus open-account orders not yet in BizimHesap. The statement is fetched every 30 minutes (every 6 hours for idle dealers).',
      notLinked: 'The dealer is not linked to a BizimHesap account. To link:',
      balance: 'BizimHesap balance',
      pending: 'Orders not yet transferred',
      effective: 'Used for the credit limit',
      fetchedAt: 'Last updated {{date}}',
      neverFetched: 'Not fetched yet',
      lastError: 'Last attempt failed: {{error}}',
      refreshOne: 'Update this dealer',
      refreshed: 'Statement updated from BizimHesap.',
      pendingOrders: 'Open-account orders not yet in BizimHesap: {{orders}}',
      rows: 'BizimHesap statement lines',
      date: 'Date',
      type: 'Type',
      note: 'Description',
      debit: 'Debit',
      credit: 'Credit',
      running: 'Balance',
      sources: {
        field: 'Balance read from the statement header (no running balance on lines)',
        sums: 'Balance computed from debit − credit totals',
        rows: 'Balance computed from the lines',
      },
      creditSource:
        'The credit limit is checked against the BizimHesap balance plus orders not yet transferred.',
    },
    diff: {
      title: 'BizimHesap balances and difference report',
      lead: 'For each dealer linked to BizimHesap: the BizimHesap balance, open-account orders not yet transferred and this system’s ledger balance. Difference = BizimHesap + not transferred − ledger (largest first).',
      refreshAll: 'Update now',
      queued: 'Statements of {{count}} dealers queued; they update within a few minutes.',
      bizimhesap: 'BizimHesap',
      pending: 'Not transferred',
      ledger: 'Ledger',
      diff: 'Difference',
      updated: 'Last updated',
    },
    dealerTitle: 'BizimHesap account',
    dealerLead:
      'This dealer’s invoices and collections are written to this BizimHesap account code; BizimHesap is the master record. The code is checked against the BizimHesap account list.',
    notLinked: 'Not linked — invoices are not sent',
    linkedAt: 'Linked at',
    link: 'Link',
    unlink: 'Unlink',
    notConnected:
      'BizimHesap is not connected or not tested (Setup required). Enter the firm ID and run "Test connection":',
    cashTitle: 'Cash accounts',
    cashLead:
      'A paid order’s invoice is sent with the cash account of its payment method; BizimHesap records the collection there. Open-account (credit) orders send no cash account and stay as receivables.',
    cashiersRefreshed: 'Cash account list updated.',
    cashiersAt: '{{count}} cash accounts from BizimHesap · {{date}}',
    cashiersNever: 'The cash account list has not been fetched yet.',
    refreshCashiers: 'Fetch cash accounts',
    cashKeys: {
      card: 'Card payment',
      bank_transfer: 'Bank transfer',
      cash_on_delivery: 'Cash on delivery',
      manual: 'Manual payment (panel)',
      cash: 'Cash collection (account)',
    },
    noCash: 'No cash account',
    cashRule:
      'Invoices of orders paid with a method that has no cash account are not sent (without one BizimHesap shows no collection).',
    saveCash: 'Save cash accounts',
    linksTitle: 'Dealer ↔ BizimHesap account',
    linksLead:
      'Dealer invoices and collections are written to the dealer’s BizimHesap account code. Matching uses the account list: dealer code = account code first, then tax number. Invoices of unlinked dealers are not sent.',
    dealers: 'Dealers',
    linked: 'Linked to BizimHesap',
    customersCheck: 'Nightly account list check',
    customersCheckResult: 'Dealers whose linked code is missing from the list: {{missing}}',
    importCustomers: 'Import accounts',
    linkedDone: '{{count}} dealers linked to BizimHesap accounts.',
    previewSummary:
      'Matched {{matched}} · ambiguous {{ambiguous}} · not in BizimHesap {{unmatched}} · already linked {{linked}}. {{other}} BizimHesap accounts matching no dealer (may be retail) stay unchanged.',
    applyLinks: 'Save {{count}} matches',
    groupMatched: 'Matched (ticked to save)',
    byCode: 'dealer code',
    byTax: 'tax no',
    groupAmbiguous: 'Ambiguous: several candidates',
    leaveUnlinked: 'Do not link',
    groupUnmatched: 'Not found in BizimHesap',
    unmatchedLead:
      'These dealers need an account in BizimHesap. Adding accounts (AddCustomer) writes to BizimHesap and is off by default; until then open the account in BizimHesap and import again.',
    linkMissing: 'linked code ({{code}}) not in the list',
    alreadyLinked: '{{count}} dealers already linked.',
    writesTitle: 'Writing to BizimHesap',
    writesLead:
      'These steps write records to your real BizimHesap account and are off by default. While off, records wait here; once on they are sent manually.',
    writeKeys: {
      collections: 'Send collections (AddCollection)',
      customers: 'Add accounts (AddCustomer)',
      cancel: 'Cancel invoices (CancelInvoice)',
    },
    writesConfirm: 'I confirm that the steps I turn on will write records to my real BizimHesap account.',
    saveWrites: 'Save write settings',
    writesOwnerOnly: 'The owner or an admin changes this setting.',
    correctionsTitle: 'Paid orders sent without a cash account',
    correctionsLead:
      'Paid orders invoiced earlier without a cash account: BizimHesap shows no collection for them. Tick them to open collection records; sending depends on the write setting turned on with the owner’s approval.',
    queued: '{{count}} collection records opened.',
    noCorrections: 'No invoices to correct.',
    method: 'Payment method',
    customerCode: 'Account code',
    sentAt: 'Invoice sent',
    amount: 'Amount',
    collection: 'Collection',
    pickCorrection: 'Select order {{number}}',
    cashMissing: 'No cash account',
    statuses: {
      pending: 'Pending',
      sending: 'Sending',
      sent: 'Sent',
      failed: 'Failed',
      uncertain: 'Uncertain',
      cancelled: 'Cancelled',
    },
    queueCorrections: 'Open collection records for selected ({{count}})',
    writesOffNote: 'Writing collections to BizimHesap is off: records wait unsent.',
    collectionsTitle: 'Collection queue',
    collectionsLead:
      'Collections to be sent to and sent to BizimHesap. The collection number (ZT-TAH-…) goes into the BizimHesap note; without a response the status becomes "uncertain" and is checked by searching the statement for that number — no blind retries.',
    sent: 'Collection sent to BizimHesap.',
    sendResult: {
      uncertain: 'BizimHesap did not respond: the collection may exist. Check the statement.',
      failed: 'BizimHesap rejected the collection; the error is on the row.',
    },
    checkFound: 'Collection number found in the statement: marked as sent.',
    checkNotFound: 'Not found in the statement: you can send it again.',
    noCollections: 'No collection records.',
    collectionNumber: 'Collection no',
    account: 'Account',
    paymentType: 'Type',
    status: 'Status',
    sources: {
      order_correction: 'Invoice correction',
      ledger_payment: 'Panel collection',
      balance_payment: 'Card balance payment',
    },
    paymentTypes: { 1: 'Cash', 2: 'Credit card', 3: 'Bank transfer' },
    send: 'Send',
    cancelCollection: 'Cancel record',
    checkStatement: 'Check statement',
    collectionActionsNote: 'Send, Check statement and Cancel record are written to the audit log.',
    cancelled: 'Collection record cancelled.',
    cancelTitle: 'Cancel record {{number}}',
    cancelLead:
      'The record is not sent to BizimHesap. Note it if you entered the collection in BizimHesap by hand.',
    cancelNote: 'Reason',
    sampleReset: 'Sample deleted; the next real response will be stored again.',
    samplesTitle: 'BizimHesap response samples',
    samplesLead:
      'The BizimHesap documentation does not describe the fields of the account list, statement and cash account responses. The first real response is stored here with personal data masked; the field mapping is checked against it.',
    endpoints: {
      customers: 'Account list (customers)',
      abstract: 'Statement (abstract)',
      cashiers: 'Cash accounts (cashiers)',
    },
    sampleAt: 'captured {{date}}',
    sampleNone: 'none yet',
    copySample: 'Copy',
    copied: 'Copied.',
    resetSample: 'Delete sample',
  },
  commissions: {
    rules: 'Commission rules',
    rulesLead:
      'The rate applies to the order’s net amount excluding VAT and shipping. Each line uses the most specific rule: rep-specific before general, product before category, category before all products.',
    newRule: 'Add rule',
    editRule: 'Edit rule {{name}}',
    saveRule: 'Save rule',
    ruleSaved: 'Commission rule saved.',
    ruleDeleted: 'Commission rule deleted.',
    confirmDeleteRule:
      'Delete rule {{name}}? Rates already calculated for orders do not change; new orders will not use it.',
    noRules: 'No commission rules yet',
    noRulesLead: 'Start with a general rate for all reps; add rep- or product-specific rules if needed.',
    ruleName: 'Rule name',
    rep: 'Rep',
    allReps: 'All reps',
    scope: 'Scope',
    allProducts: 'All products',
    categoryCount: '{{count}} categories',
    productCount: '{{count}} products',
    rate: 'Rate',
    rateHint: 'As a percentage, e.g. 5 or 2.5. At most 50%.',
    rateInvalid: 'Enter a percentage between 0 and 50 (e.g. 2.5).',
    validity: 'Validity',
    always: 'No end',
    validFrom: 'First day',
    validTo: 'Last day',
    categories: 'Categories',
    products: 'Products',
    activeLabel: 'Rule is active',
    inactive: 'Off',
    statements: 'Monthly statements',
    statementsLead:
      'Calculating a period creates a draft statement for each rep. Commission follows the amount collected; refunds, cancellations and late payments show up as adjustments in later months.',
    period: 'Period (month)',
    calculate: 'Calculate period',
    calculated: 'Statements prepared for {{count}} reps; {{locked}} approved statements kept.',
    downloadCsv: 'Download CSV',
    noStatements: 'No statements for this period. Calculate the period.',
    orders: 'Orders',
    base: 'Base (excl. VAT)',
    commission: 'Commission',
    status: 'Status',
    statuses: { draft: 'Draft', approved: 'Approved', paid: 'Paid' },
    details: 'Details',
    approve: 'Approve',
    approved: 'Statement approved.',
    markPaid: 'Mark as paid',
    markPaidTitle: '{{name}} — mark as paid',
    markPaidLead:
      'Payment happens outside the system (transfer, payroll); only the record is kept here. A paid statement cannot change.',
    paidNote: 'Payment note',
    paidDone: 'Statement marked as paid.',
    detailTitle: '{{name}} — {{period}}',
    calculatedAt: 'Calculated: {{date}}',
    entries: 'Statement lines',
    kind: 'Type',
    kinds: { accrual: 'Accrual', adjustment: 'Adjustment' },
    collected: 'Collected',
    ownOnly: 'You only see your own statements.',
  },
  quotes: {
    new: 'New quote',
    newLead: 'Choose the dealer. The quote opens in the working store; prices follow the dealer group.',
    create: 'Create quote',
    changeDealer: 'Change dealer',
    status: 'Status',
    search: 'Quote no or dealer',
    empty: 'No quotes',
    emptyLead: 'Dealers can request a quote from the cart; you can also prepare one with "New quote".',
    listCaption: 'Quotes',
    number: 'Quote no',
    dealer: 'Dealer',
    total: 'Total',
    validUntil: 'Valid until',
    validUntilShort: 'until {{date}}',
    createdAt: 'Created',
    expired: 'Expired',
    statuses: {
      requested: 'Requested',
      draft: 'Draft',
      sent: 'Sent',
      ordered: 'Ordered',
      rejected: 'Declined',
      cancelled: 'Cancelled',
    },
    title: 'Quote {{number}}',
    backToList: 'Quote list',
    print: 'Print',
    send: 'Send',
    resend: 'Send new version',
    cancel: 'Cancel quote',
    saved: 'Quote saved.',
    sentEmailed: 'Quote sent; the dealer was emailed.',
    sentNoEmail:
      'Quote sent; the dealer sees it under My account. No email was sent because email delivery is not set up (Setup required).',
    summary: 'Summary',
    requester: 'Requested by',
    requestNote: 'Dealer note',
    version: 'Sent version',
    versionValue: 'Version {{version}}',
    rejectReason: 'Decline reason',
    cancelReason: 'Cancel reason',
    order: 'Order',
    openOrder: 'Open order',
    editResetsLead:
      'Saving changes to a sent quote turns it back into a draft; the dealer cannot accept until you send the new version.',
    lines: 'Products',
    linesLead:
      'Enter unit prices as in the dealer price list (VAT included/excluded); empty uses the dealer list price.',
    product: 'Product',
    qty: 'Qty',
    listPrice: 'List price',
    unitPrice: 'Quote price',
    lineTotal: 'Amount (VAT incl.)',
    taxIncluded: 'VAT: {{tax}}',
    saving: 'Discount vs list price: {{amount}}',
    saveToRecalc: 'Amounts for changed lines are recalculated when you save.',
    terms: 'Terms',
    note: 'Note to dealer',
    noteHint: 'Shown on the quote',
    internalNote: 'Internal note',
    internalNoteHint: 'Panel only',
    versions: 'Sent versions',
    cancelTitle: 'Cancel quote',
    cancelLead: 'A cancelled quote cannot be accepted. The reason stays in the panel.',
    cancelled: 'Quote cancelled.',
  },
  locations: {
    title: 'Locations',
    lead: 'Branch, delivery and billing addresses of the dealer. Dealer users pick one at checkout; the company owner can also add them on the storefront.',
    add: 'Add location',
    edit: 'Edit location',
    empty: 'No locations',
    emptyLead: 'Add locations for dealers with branches or separate delivery/billing addresses.',
    label: 'Location name',
    contact: 'Recipient',
    postalCode: 'Postal code',
    defaultShipping: 'Default delivery',
    defaultBilling: 'Default billing',
    makeDefaultShipping: 'Make default delivery address',
    makeDefaultBilling: 'Make default billing address',
    saved: 'Location saved.',
    deleted: 'Location deleted.',
    confirmDelete: 'Delete the "{{name}}" location? Addresses on past orders do not change.',
    fill: 'Fill from company location',
    choose: 'Choose a location',
  },
  retention: {
    rulesTitle: 'Automatic destruction rules',
    rulesLead:
      'Rules that are on run every night at 03:40 and permanently delete records whose retention period has ended. All are off by default. Periods are suggestions; confirm them with your lawyer.',
    colData: 'Data',
    colDays: 'Retention period (days)',
    colDue: 'Due today',
    colEnabled: 'Automatic destruction',
    daysLabel: '{{name}}: retention period (days)',
    daysRange: '{{min}}–{{max}} days; suggested {{def}}',
    dueValue: '{{n}} records',
    enabledLabel: '{{name}}: automatic destruction',
    on: 'On',
    off: 'Off',
    saved: 'Retention rules saved.',
    lastRun: 'Last destruction: {{day}}',
    noRunYet: 'No destruction yet.',
    confirmTitle: 'Turn on automatic destruction',
    confirmLead:
      'Rules you turn on run every night. Records whose retention period has ended are permanently deleted and written to the destruction log.',
    confirmRow: '{{days}} days: {{n}} records will be deleted on the first run',
    confirmRowUnknown: '{{days}} days: could not count records to be deleted',
    confirmAck: 'I understand that expired records will be permanently deleted every night.',
    confirmButton: 'Turn on and save',
    fixedTitle: 'Fixed retention periods',
    fixedLead:
      'These records are deleted when the feature’s own period ends and are written to the destruction log. The live chat period is changed in the live chat settings.',
    colRetention: 'Retention period',
    days: '{{n}} days',
    logTitle: 'Destruction log',
    logLead:
      'Personal data deleted or anonymised: day, data type, method and number of records. The log contains no personal data and is never deleted.',
    period: 'Period',
    lastDays: 'Last {{n}} days',
    colDay: 'Day',
    colRule: 'Data type',
    colMethod: 'Method',
    colCount: 'Records',
    methods: { delete: 'Deletion', anonymize: 'Anonymisation' },
    byRequest: 'On request',
    logEmpty: 'No destruction in this period',
    logEmptyLead: 'Appears here when expired records are deleted or data is anonymised following a request.',
    rules: {
      carts: 'Carts',
      pending_subscribers: 'Unconfirmed newsletter sign-ups',
      unsubscribed_subscribers: 'Ended newsletter subscriptions',
      integration_logs: 'Integration logs',
      support_tickets: 'Resolved support requests',
      form_submissions: 'Contact form messages',
      chat_conversations: 'Closed live chats',
      email_campaign_recipients: 'Email campaign recipient records',
      automation_runs: 'Finished automation records',
      stock_alerts: 'Closed back-in-stock requests',
      price_drop_notices: 'Price drop notices',
      message_recipients: 'SMS/WhatsApp campaign recipient records',
      push_deliveries: 'Browser notification delivery records',
      push_subscriptions: 'Expired browser notification subscriptions',
      staff_notifications: 'Staff notifications',
      staff_devices: 'Unused staff devices',
      server_events: 'Server-side measurement events',
      privacy_request: 'Data subject request (the person’s data)',
    },
    ruleLeads: {
      carts: 'Carts that became orders or were left; counted from the last change.',
      pending_subscribers:
        'Sign-ups whose confirmation link was never opened (no consent); counted from sign-up.',
      unsubscribed_subscribers:
        'Records of people who left the newsletter; counted from leaving. Consent records are kept 3 years after consent ends; the address stays on the suppression list.',
      integration_logs: 'Logs of external service connections (masked summary).',
    },
  },
  questions: {
    filter: 'Status',
    statuses: { pending: 'Awaiting answer', published: 'Live', rejected: 'Rejected' },
    empty: {
      pending: 'No questions awaiting an answer',
      published: 'No live questions',
      rejected: 'No rejected questions',
    },
    answered: 'Answer written',
    unanswered: 'No answer',
    detailTitle: 'Product question',
    back: 'All questions',
    question: 'Question',
    meta: '{{author}} · {{date}}',
    answer: 'Answer',
    answerLead: 'The answer is shown on the product page under the store name.',
    answerLabel: 'Your answer',
    answeredBy: 'Last answered by {{name}}, {{date}}',
    save: 'Save answer',
    saved: 'Answer saved',
    saveFirst: 'Save the answer before publishing.',
    publish: 'Publish',
    publishedToast: 'Question published',
    notified: 'Answer email sent to the customer: {{date}}',
    rejectTitle: 'Reject',
    rejectLead: 'The question is not shown on the storefront; the customer is not notified.',
    rejectNote: 'Reason (panel only)',
    reject: 'Reject',
    unpublish: 'Unpublish',
    rejectConfirm: 'The question will not be shown on the storefront. Continue?',
    rejectedToast: 'Question rejected',
    rejectedNote: 'Rejection reason: {{note}}',
  },
  productTools: {
    copy: 'Copy',
    copyConfirm:
      'A draft copy is created: content, variants (new SKU, no barcode), categories, attributes, images and prices. Store listing and stock are not copied. Continue?',
    copied: 'Draft copy created. New SKU: {{skus}}',
    saveTemplate: 'Save as template',
    saveTemplateLead:
      'Brand, categories, species, options, attributes, tags and description texts are saved. Name, SKU, price and images are not.',
    templateName: 'Template name',
    templateSaved: 'Template saved',
    startFrom: 'Start from a template',
    startFromLead: 'Apply a saved template to fill the form, then edit.',
    template: 'Template',
    chooseTemplate: 'Choose a template',
    applyTemplate: 'Apply template',
    templateApplied: 'Template "{{name}}" applied',
    noTemplates: 'No saved templates. Use "Save as template" on a product to create one.',
    deleteTemplate: 'Delete template',
    deleteTemplateConfirm: 'Delete template "{{name}}"? Products created from it are not affected.',
    templateDeleted: 'Template deleted',
    suggestSkus: 'Suggest SKUs',
    skusSuggested: 'Empty SKU fields filled (pattern: {{pattern}}). Remember to save.',
    skuPattern: 'SKU pattern',
    skuPatternLead: 'SKU suggestions follow this pattern and are always unique in the business.',
    skuPatternLabel: 'Pattern',
    skuPatternHint:
      'Tokens: {marka} (brand), {kategori} (category), {urun} (first three words of the name), {secenek} (option values), {sira} (sequence). Separators: - _ . /',
    skuPatternSaved: 'SKU pattern saved',
    schedule: 'Schedule publishing',
    scheduleLead:
      'The product is published in this store at the chosen time. Publishing rules are checked again then; if not met, it is not published and the reason is shown here.',
    publishAt: 'Publish at',
    publishAtHint: 'In your browser time; at least 1 minute ahead, within 1 year.',
    scheduleSave: 'Schedule',
    scheduled: 'Publishing scheduled',
    scheduledFor: 'Scheduled: {{date}}',
    unschedule: 'Cancel schedule',
    unscheduled: 'Schedule cancelled',
    scheduleFailed: 'Scheduled publishing failed:',
  },
  productBulk: {
    selectAllPage: 'Select all products on this page',
    selectRow: 'Select {{title}}',
    selected: '{{count}} products selected',
    allMatching: 'All products matching the filter are selected',
    selectAllMatching: 'Select all products matching the filter',
    clear: 'Clear selection',
    open: 'Bulk action',
    history: 'Bulk action history',
    lead: 'Choose an action and preview it. Nothing changes in the preview; "Apply" makes the change, which can be reverted from the bulk action history.',
    kind: 'Action',
    kinds: {
      status: 'Change status',
      categories_add: 'Add to category',
      categories_remove: 'Remove from category',
      tags_add: 'Add tags',
      tags_remove: 'Remove tags',
      collection_add: 'Add to collection',
      collection_remove: 'Remove from collection',
      stock_set: 'Set stock to a count',
      stock_adjust: 'Add or remove stock',
      seo: 'SEO title and description',
      merchant: 'Google Shopping',
      cells: 'Table edit',
      store_publish: 'Publish in store',
      store_unpublish: 'Unpublish from store',
    },
    newStatus: 'New status',
    categories: 'Categories',
    tags: 'Tags',
    tagsHint: 'Comma-separated (e.g. kitten, grain-free).',
    collection: 'Collection',
    chooseCollection: 'Choose a collection',
    noManualCollections: 'No hand-picked collections. Products join rule-based collections automatically.',
    warehouse: 'Warehouse',
    chooseWarehouse: 'Choose a warehouse',
    quantitySet: 'New stock (units)',
    quantityAdjust: 'Units to add or remove',
    stockHint:
      'Changes the stock of every active variant in this warehouse. Use a minus sign to remove (e.g. -5). Variants that would drop below reserved units are skipped; lot/expiry tracked variants are entered on the stock screen.',
    seoTitle: 'SEO title pattern',
    seoDescription: 'SEO description pattern',
    seoHint:
      'Tokens: {urun}, {marka}, {kategori} (e.g. {urun} | {marka}). Empty fields are left unchanged. Titles are cut at 70 and descriptions at 170 characters.',
    onlyEmpty: 'Only fill empty fields',
    merchantChoice: 'In the Google Shopping product feed',
    store: 'Store',
    storeHint:
      'Products that are not active, await vet approval or have no price in this store are not published; the preview skips them with the reason.',
    merchantOptions: { include: 'Include', exclude: 'Exclude' },
    preview: 'Preview',
    back: 'Back',
    apply: 'Apply',
    summary: '{{products}} products checked: {{total}} changes, {{skipped}} skipped.',
    nothing: 'Nothing would change. See the reasons for skipped rows.',
    expires: 'The preview is valid until {{time}}.',
    item: 'Product',
    before: 'Now',
    after: 'After',
    sampleNote: 'Showing the first 200 changes.',
    skippedTitle: 'Skipped ({{count}})',
    queued: 'Applying in the background: {{processed}} / {{total}}',
    queuedLead: 'You can close this window; progress is shown in the bulk action history.',
    done: 'Bulk action applied: {{applied}} changes, {{skipped}} rows skipped.',
    notes: {
      unchanged: 'Already this value',
      product_requires_active_variant: 'No active variant',
      too_many_categories: 'Category limit (20) exceeded',
      too_many_tags: 'Tag limit (30) exceeded',
      lot_tracked: 'Lot/expiry tracked; use the stock screen',
      insufficient_stock: 'Stock would drop below zero or reserved units',
      changed_since_preview: 'Changed after the preview; left untouched',
      error: 'Could not be changed ({{code}})',
    },
    values: {
      inCollection: 'In collection',
      notInCollection: 'Not in collection',
      included: 'Included',
      excluded: 'Excluded',
      published: 'Published',
      notPublished: 'Not published',
    },
    date: 'Date',
    status: 'Status',
    rows: 'Rows',
    statuses: {
      preview: 'Not applied',
      queued: 'Queued',
      running: 'Applying',
      applied: 'Applied',
      failed: 'Failed',
      reverted: 'Reverted',
      expired: 'Expired',
    },
    states: {
      pending: 'Pending',
      applied: 'Applied',
      skipped: 'Skipped',
      reverted: 'Reverted',
      revert_skipped: 'Not reverted (changed later)',
    },
    progress: '{{processed}} / {{total}}',
    skippedCount: '{{count}} skipped',
    empty: 'No bulk actions yet',
    emptyLead: 'Select products on the Products screen and choose "Bulk action".',
    details: 'Details',
    revert: 'Revert',
    revertConfirm:
      'Values changed by this action go back to what they were. Rows changed by hand since then are left alone; stock is corrected with a reverse movement. Continue?',
    reverted: 'Reverted {{reverted}} rows. Skipped because they changed later: {{skipped}}.',
    itemsNote: 'Showing the first 200 rows.',
    note: 'Note',
  },
  productGrid: {
    open: 'Edit in table',
    tableLabel: 'Product table',
    priceList: 'Price list',
    noPriceList: 'Hide prices',
    warehouse: 'Warehouse',
    noWarehouse: 'Hide stock',
    lockedWhileDirty: 'Save or discard your changes before switching the price list or warehouse.',
    keyboard:
      'Use the arrow keys to move between cells. Press Enter, double-click or start typing to edit; Enter saves and moves down, Tab moves right, Esc cancels.',
    changesRegion: 'Unsaved changes',
    cols: {
      product: 'Product',
      sku: 'SKU',
      barcode: 'Barcode',
      status: 'Status',
      price: 'Price',
      priceIn: 'Price ({{currency}})',
      onHand: 'Stock',
    },
    statuses: { active: 'Active', archived: 'Archived' },
    changes: '{{count}} unsaved changes',
    noChanges: 'No unsaved changes',
    discard: 'Discard',
    discardConfirm: 'Discard {{count}} unsaved changes?',
    review: 'Save changes',
    previously: 'Previously: {{value}}',
    edited: 'changed, not saved',
    invalidPrice: 'Enter the amount like 129.90.',
    invalidStock: 'Enter zero or a positive whole number.',
    lotTracked: 'Lot/expiry tracked; use the stock screen',
    prevPage: 'Previous page',
    nextPage: 'Next page',
    empty: 'No products match this search',
    previewTitle: 'Save changes',
    previewLead: 'Check before saving. Cells changed by someone else while you were editing are not saved.',
    summary: 'Changes will be saved on {{total}} rows.',
    nothing: 'There are no valid changes to save.',
    field: 'Field',
    conflictsTitle: 'Changed while you were editing ({{count}})',
    conflictsLead:
      'These cells are not saved and are removed from the table. Edit them again on top of the current value after the table reloads.',
    conflict: 'you saw {{yours}}, now {{current}}',
    problemsTitle: 'Cells that cannot be saved ({{count}})',
    save: 'Save',
    saved: '{{count}} rows saved.',
    queued: 'Changes are being saved in the background; progress is shown in the bulk action history.',
  },
  priceTiers: {
    title: 'Quantity prices',
    lead: 'A price that applies from a quantity (e.g. 6 or more). The highest matching tier applies in the cart.',
    row: '{{list}} · {{sku}} · {{qty}} or more: {{price}}',
    empty: 'No quantity prices.',
    list: 'List',
    variant: 'Variant',
    minQuantity: 'Minimum quantity',
    price: 'Unit price ({{currency}})',
    add: 'Add',
    remove: 'Remove',
    removeConfirm: 'Remove the price for {{qty}} or more?',
  },
  reviews: {
    enabled: 'Reviews shown in the storefront',
    filter: 'Status',
    statuses: { pending: 'Pending approval', published: 'Live', rejected: 'Rejected' },
    empty: {
      pending: 'No reviews awaiting approval',
      published: 'No live reviews',
      rejected: 'No rejected reviews',
    },
    ratingFilter: 'Rating',
    allRatings: 'All ratings',
    ratingN: '{{n}} stars',
    listLabel: 'Reviews',
    itemLabel: '{{rating}}/5 — {{title}}',
    verified: 'Verified purchase',
    replied: 'Replied',
    detailTitle: 'Product review',
    back: 'All reviews',
    verifiedOrder: 'Verified purchase: order {{number}}',
    review: 'Review',
    ratingOutOf: '{{n}} out of 5',
    meta: '{{author}} · {{date}}',
    reply: 'Store reply',
    replyLead: 'The reply appears under the review on the product page with the store name.',
    replyLabel: 'Your reply',
    repliedBy: 'Last replied by {{name}}, {{date}}',
    saveReply: 'Save reply',
    replySaved: 'Reply saved',
    saveFirst: 'Save the reply before publishing.',
    publish: 'Approve and publish',
    publishedToast: 'Review published',
    rejectTitle: 'Reject',
    rejectLead: 'The review is hidden and excluded from the average; the customer is not notified.',
    rejectNote: 'Reason (panel only)',
    reject: 'Reject',
    unpublish: 'Unpublish',
    rejectConfirm: 'The review will be hidden from the storefront. Continue?',
    rejectedToast: 'Review rejected',
    rejectedNote: 'Rejection reason: {{note}}',
  },
  translations: {
    locale: 'Content language',
    current: 'Language: {{lang}}',
    others: 'Other languages:',
    add: 'Add translation',
    lead: 'The content is copied as a draft in the selected language. Translate the text and save; it is not shown on the storefront until published. Health content needs expert approval again in the translation.',
    target: 'Target language',
    create: 'Create translation',
    created: 'Translation draft created',
    categoryName: 'Category name ({{lang}})',
  },
  // F7-19: düzenli sipariş (abonelik)
  subscriptions: {
    lead: 'Customers start a repeat delivery ("every N weeks") from the product page. Each period an order is opened at the current price with the subscription discount, stock is reserved and a card payment link is sent. No card is stored and nothing is charged automatically; an order not paid in time is cancelled and its stock released.',
    store: 'Store',
    settingsTitle: 'Settings',
    settingsLead: 'Repeat delivery is switched on per store; it is off by default.',
    readiness: 'Readiness',
    ok: 'Ready',
    missing: 'Missing',
    readyCard: 'Card payment provider connected (for payment links)',
    readyLegal: 'Pre-information form and distance sales contract published',
    readyEmail: 'Email delivery on (if off, customers see the payment link only in My account)',
    readyProducts: 'Products available for repeat delivery: {{count}}',
    enabled: 'Turn on repeat delivery',
    enabledLead:
      'When on, eligible product pages show a "Deliver regularly" box. When off, no new period orders are opened; subscriptions wait.',
    intervals: 'Intervals customers can choose',
    everyWeek: 'Every week',
    everyWeeks: 'Every {{n}} weeks',
    discount: 'Subscription discount (%)',
    discountHint: '0 to 30. The rate at the start of a subscription stays fixed for it.',
    discountShort: '{{pct}}% off',
    linkHours: 'Payment link validity',
    hoursOption: '{{n}} hours',
    save: 'Save settings',
    saved: 'Repeat order settings saved.',
    enableConfirm:
      'Turn on repeat delivery? Eligible product pages show a "Deliver regularly" box and customers can start subscriptions.',
    listTitle: 'Subscriptions',
    listLead: 'Customer, product, interval, next order day and the order awaiting payment.',
    statusFilter: 'Status',
    all: 'All',
    statuses: {
      active: 'Active',
      paused: 'Paused',
      cancelled: 'Cancelled',
    },
    reasons: {
      customer: 'At the customer’s request',
      unpaid: 'Two orders in a row were not paid',
      unavailable: 'Product or customer no longer eligible',
      panel: 'Cancelled in the panel',
      payment_unavailable: 'Payment link could not be created (is card payment connected?)',
    },
    emptyTitle: 'No repeat orders yet',
    emptyLead:
      'Turn on the settings and mark products as available for repeat delivery; customers can then start from the product page.',
    colCustomer: 'Customer',
    colProduct: 'Product',
    colQuantity: 'Qty',
    colInterval: 'Interval',
    colNext: 'Next order',
    colStatus: 'Status',
    colPending: 'Awaiting payment',
    colActions: 'Actions',
    runs: 'Periods',
    runsFor: 'Period records for {{product}}',
    runsTitle: 'Period records',
    noRuns: 'No period records yet.',
    runStatuses: {
      order_created: 'Order opened (awaiting payment)',
      paid: 'Paid',
      skipped: 'Skipped',
      out_of_stock: 'Out of stock',
      unpaid: 'Not paid (order cancelled)',
      failed: 'Order could not be opened',
    },
    cancel: 'Cancel',
    cancelFor: 'Cancel subscription for {{product}}',
    cancelTitle: 'Cancel subscription',
    cancelLead:
      'No new period orders are opened. An order awaiting payment is cancelled automatically when its link expires. The customer gets no email; My account shows "Cancelled".',
    cancelReason: 'Reason (written to the audit log)',
    cancelSubmit: 'Cancel subscription',
    cancelled: 'Subscription cancelled.',
  },
  gads: {
    textReviewStatus: {
      not_required: 'No expert review needed',
      pending:
        'The text has {{count}} health-claim findings: waiting for the Veterinary Expert Reviewer; this request cannot be approved before that.',
      approved: 'The text was approved by the expert ({{count}} findings reviewed).',
      rejected: 'The expert rejected the text; edit it and request again.',
    },
    keywordChanges: {
      added: 'To add ({{count}})',
      removed: 'To remove ({{count}})',
    },
    accessLevel: 'Google Ads API access level',
    accessLevelHint:
      'The level Google granted your Cloud project. Keyword ideas are disabled on Explorer; change it once Basic is approved.',
    accessLevels: {
      explorer: 'Explorer (default)',
      basic: 'Basic',
      standard: 'Standard',
    },
    searchOnlyReady: 'Only a Search campaign can be set up: Performance Max and Shopping are missing',
    search: {
      source: 'Build the draft from data',
      sourceKinds: {
        product: 'Product',
        category: 'Category',
      },
      sourceCategory: 'Category',
      sourceSearch: 'Search products',
      sourceProduct: 'Product',
      suggest: 'Create draft',
      preview: 'Ad preview',
      previewCaption: 'Sample view: Google picks the order and combination of headlines and descriptions.',
      sponsored: 'Sponsored',
      previewEmpty: 'Enter headlines',
      findings: '{{count}} health-claim findings',
      findingsLead:
        'This text cannot go to Google without the Veterinary Expert Reviewer’s approval. Do not claim to prevent or treat disease.',
      shortOf:
        'Not enough text in the data: write {{headlines}} more headlines and {{descriptions}} more descriptions.',
      finalUrl: 'Final URL',
      finalUrlHint:
        'A page in your store (https://…). Filled with the product or category page when you create a draft.',
      path1: 'Display path 1',
      path2: 'Display path 2',
      headlines: 'Headlines (3–15, up to 30 characters)',
      headlinesHint: 'Write headlines with different meanings; pin only when needed.',
      headlineN: 'Headline {{n}}',
      pinN: 'Pin for headline {{n}}',
      pinNone: 'Not pinned',
      pins: {
        h1: 'Headline position 1',
        h2: 'Headline position 2',
        h3: 'Headline position 3',
        d1: 'Description position 1',
        d2: 'Description position 2',
      },
      removeHeadline: 'Remove headline {{n}}',
      addHeadline: 'Add headline',
      descriptions: 'Descriptions (2–4, up to 90 characters)',
      descriptionN: 'Description {{n}}',
      pinDescN: 'Pin for description {{n}}',
      removeDescription: 'Remove description {{n}}',
      addDescription: 'Add description',
      keywordN: '{{label}} {{n}}',
      matchTypeN: '{{label}} {{n}} match type',
      matchTypes: {
        broad: 'Broad match',
        phrase: 'Phrase match',
        exact: 'Exact match',
      },
      removeKeyword: 'Remove “{{text}}”',
      addKeywords: 'Add {{label}}',
      addKeywordsHint: 'One per line (or separate with ;). Added as phrase match.',
      add: 'Add',
      keywordCount: '{{count}} / {{max}}',
      ideas: 'Suggest keywords',
      basicRequired: 'Basic access required',
      basicRequiredLead:
        'Google disables planning services (keyword ideas) on Explorer access. Once Basic is approved, change the access level in Budget cap and settings.',
      noIdeas: 'Google returned no ideas for these seeds.',
      monthlySearches: '≈ {{n}} searches/month',
      competition: {
        LOW: 'low competition',
        MEDIUM: 'medium competition',
        HIGH: 'high competition',
        UNSPECIFIED: 'competition unknown',
        UNKNOWN: 'competition unknown',
      },
      addIdea: 'Add “{{text}}”',
      approvalStatuses: {
        APPROVED: 'Approved',
        APPROVED_LIMITED: 'Approved (limited)',
        AREA_OF_INTEREST_ONLY: 'Area of interest only',
        DISAPPROVED: 'Disapproved',
        UNKNOWN: 'Unknown',
      },
      googleReviewStatuses: {
        REVIEW_IN_PROGRESS: 'Under review',
        REVIEWED: 'Reviewed',
        UNDER_APPEAL: 'Under appeal',
        ELIGIBLE_MAY_SERVE: 'Eligible, may serve',
      },
      adStrengths: {
        EXCELLENT: 'Excellent',
        GOOD: 'Good',
        AVERAGE: 'Average',
        POOR: 'Poor',
        PENDING: 'Pending',
        NO_ADS: 'No ads',
      },
      notSent: 'Not sent to Google',
      reviewSaved: 'Review decision saved.',
      reviewTitle: 'Expert review',
      reviewStatuses: {
        not_required: 'Not required',
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
      },
      reviewedBy: 'Decision: {{name}}',
      reviewNote: 'Review note',
      reviewNoteHint: 'A reason is required to reject.',
      reviewApprove: 'Approve text',
      reviewReject: 'Reject text',
      reviewWaiting: 'Waiting for the Veterinary Expert Reviewer’s decision.',
      adTitle: 'Ad text',
      adLead: 'Responsive search ad: Google combines headlines and descriptions.',
      requestedDiffers: 'The requested new text is not in Google yet (waiting for approval or apply).',
      googleState: 'Status in Google',
      approvalStatus: 'Policy approval',
      googleReview: 'Google review',
      adStrength: 'Ad strength',
      keywords: 'Keywords',
      keywordsLead: 'Searches the ad can show for. Adding needs approval; removing only does not.',
      negatives: 'Negative keywords',
      negativesLead: 'Searches the ad will not show for. Adding needs no approval; removing does.',
      noKeywords: 'No keywords.',
      noNegatives: 'No negative keywords.',
      edit: {
        ad: 'Edit ad text',
        keywords: 'Edit keywords',
        negatives: 'Edit negatives',
      },
      draftSaved: 'Draft saved.',
      draftEditLead: 'The campaign is a draft: changes are saved without going to Google.',
      adChangeLead:
        'The new text goes for approval; once approved the ad in Google is updated. Health-claim findings need expert approval first.',
      changeSummary: '{{added}} to add, {{removed}} to remove.',
      summaryAd: 'Ad',
      summaryAdValue:
        '{{headlines}} headlines, {{descriptions}} descriptions, {{keywords}} keywords, {{negatives}} negatives',
      summaryReviewNote:
        'If the text has health-claim findings, the campaign cannot be created without the Veterinary Expert Reviewer’s approval.',
    },
    backToAds: 'Ad center',
    backToList: 'Campaigns',
    settings: 'Budget cap and settings',
    newCampaign: 'New campaign',
    stopAll: 'Stop all Google campaigns',
    stopConfirm:
      'All live Google Ads campaigns will be paused and pending spend requests will be cancelled. Continue?',
    stopDone: 'Pausing {{pausing}} campaigns; {{cancelled}} requests cancelled.',
    monthTitle: 'This month',
    monthSpent: 'Spent this month',
    monthlyCap: 'Monthly ad budget cap',
    capMissing: 'Not set',
    capExceeded: 'Exceeds the cap ({{cap}})',
    projected: 'Estimated monthly maximum',
    projectedAll: 'Monthly maximum with all live campaigns',
    projectedNote:
      'The estimated monthly maximum is the sum of the live campaigns’ daily budgets × 30.4. Google may spend up to 2× the daily budget on a single day; the month total does not exceed daily × 30.4.',
    apiUsage: 'Google Ads API operations today',
    apiUsageValue: '{{used}} / {{limit}}',
    campaignsTitle: 'Campaigns',
    empty: 'No Google Ads campaigns yet',
    emptyLead:
      'Use New campaign to prepare a Performance Max or Shopping campaign from your products. The campaign is created paused in Google; going live needs a separate approval.',
    campaign: 'Campaign',
    status: 'Status',
    dailyBudget: 'Daily budget',
    dailyMax: 'Maximum in one day',
    monthlyMax: 'Monthly maximum',
    productsCount: 'Products',
    notes: 'Notes',
    driftBadge: 'Changed in Google Ads',
    pendingBadge: '{{count}} awaiting approval',
    kinds: {
      search: 'Search',
      pmax: 'Performance Max',
      shopping: 'Shopping',
    },
    kindHints: {
      search:
        'Text ads in Google search results (responsive search ad) with headlines, descriptions and keywords. No Merchant Center needed. Bidding: conversion value, conversions or clicks.',
      pmax: 'Automatic ads from the product feed across all Google channels (Search, Shopping, YouTube, Display, Gmail). Bidding: conversion value or conversions.',
      shopping: 'Product ads in Google Shopping results only. Bidding: conversion value or clicks.',
    },
    statuses: {
      draft: 'Draft',
      paused: 'Paused',
      enabled: 'Live',
      removed: 'Removed',
    },
    biddings: {
      max_conv_value: 'Maximise conversion value',
      max_conversions: 'Maximise conversions',
      max_clicks: 'Maximise clicks',
    },
    alerts: {
      month_80: '{{spent}} spent this month: 80% of the monthly cap ({{cap}}) reached.',
      month_cap_reached: '{{spent}} spent this month: the monthly cap ({{cap}}) has been reached.',
      daily_overspend: 'Spend on the last day ({{spent}}) exceeded 1.5× the daily budget ({{budget}}).',
      no_conversions_2d: '{{spent}} spent over the last two days, but Google reported no conversions.',
    },
    approvalsTitle: 'Awaiting approval',
    approvalsLead:
      'Changes that can spend money are not sent to Google until approved. Approval requires two-step verification; only the business owner can approve their own request.',
    noApprovals: 'Nothing is awaiting approval.',
    requestedBy: 'Requested by: {{name}}',
    system: 'System',
    approve: 'Approve',
    reject: 'Reject',
    approveTitle: 'Approve change',
    rejectTitle: 'Reject change',
    approveSubmit: 'Approve and send to Google',
    rejectSubmit: 'Reject',
    approved: 'Approved; the change has been queued.',
    rejected: 'Rejected.',
    approveStepUp: 'Approval requires two-step verification; you may be asked for a code.',
    decisionNote: 'Note',
    moneyLine: 'Daily budget: {{daily}}.',
    moneyRule:
      'Google may spend up to 2× in a single day ({{dailyMax}}); monthly maximum ≈ daily × 30.4 ({{monthlyMax}}).',
    moneyProjected: 'With this approval, the estimated monthly maximum of all live campaigns: {{value}}.',
    loosensWarning: 'This change loosens the bid target or changes the strategy: spend may increase.',
    removeWarning: 'Removing cannot be undone: the campaign is removed in Google Ads and cannot be reopened.',
    settingsTitle: 'Budget cap and settings',
    settingsLead:
      'The monthly cap is checked when changes that spend money are approved. Changing it requires approval permission and two-step verification.',
    monthlyCapLabel: 'Monthly ad budget cap ({{currency}})',
    monthlyCapHint: 'If empty, going live and budget increases cannot be approved.',
    autoStop: 'Stop automatically when the cap is reached',
    autoStopHint:
      'Off by default. When on, live campaigns are paused without approval once this month’s Google Ads spend reaches the cap.',
    dailyLimitHint:
      'Daily Google Ads API operation limit: {{limit}}. When it is reached, changes are applied the next morning.',
    settingsReadOnly: 'Only users with approval permission can change these settings.',
    settingsSaved: 'Settings saved.',
    wizardTitle: 'New Google Ads campaign',
    wizardStep: 'Step {{n}} of {{total}}: {{name}}',
    stepsLabel: 'Wizard steps',
    steps: {
      ad: 'Ad and keywords',
      store: 'Store',
      campaign: 'Type and name',
      products: 'Products',
      budget: 'Budget and bidding',
      targeting: 'Locations, languages, dates',
      summary: 'Summary',
    },
    back: 'Back',
    next: 'Next',
    store: 'Store',
    checking: 'Checking Google connections…',
    ready: 'Ready',
    readyLead:
      'Google Ads account {{customer}}, Merchant Center {{merchant}}; purchase conversion: {{conversion}}.',
    locked: 'Before preparing a campaign, complete the following:',
    kind: 'Campaign type',
    name: 'Campaign name',
    productSearch: 'Search products',
    productsHint:
      'The selected products go into the campaign’s product filter. Products that cannot enter the Google feed (e.g. no vet approval, health claim) are not added; the reasons are shown.',
    selectedCount: '{{count}} products selected',
    dailyBudgetLabel: 'Daily budget ({{currency}})',
    budgetInvalid: 'Enter a valid amount.',
    bidding: 'Bid strategy',
    targetRoas: 'Target ROAS (%)',
    targetRoasHint: 'Optional. Example: 400 = aim for 4 units of conversion value per 1 unit spent.',
    targetCpa: 'Target cost per conversion ({{currency}})',
    targetCpaHint: 'Optional. If empty, Google seeks the most conversions within the budget.',
    roasValue: '{{value}}% ROAS',
    noTarget: 'no target',
    countries: 'Countries',
    languagesLabel: 'Languages',
    languages: {
      tr: 'Turkish',
      en: 'English',
      de: 'German',
      ar: 'Arabic',
    },
    countryNames: {
      TR: 'Türkiye',
      DE: 'Germany',
      GB: 'United Kingdom',
      AE: 'UAE',
      US: 'USA',
      NL: 'Netherlands',
      FR: 'France',
      AT: 'Austria',
      BE: 'Belgium',
      CH: 'Switzerland',
      AZ: 'Azerbaijan',
      SA: 'Saudi Arabia',
      QA: 'Qatar',
      KW: 'Kuwait',
      BG: 'Bulgaria',
      GR: 'Greece',
      IT: 'Italy',
      ES: 'Spain',
      SE: 'Sweden',
      DK: 'Denmark',
    },
    startDate: 'Start date',
    endDate: 'End date',
    startHint: 'If empty, it starts once approved and set live.',
    endHint: 'If empty, it runs indefinitely.',
    dates: 'Dates',
    startNow: 'When set live',
    noEnd: 'no end date',
    assetsNote:
      'Assets: Google generates ad text and images from the product feed and your site (this version adds no headlines or images; Google notes that reach may be limited).',
    pausedNote:
      'The campaign is created PAUSED in Google Ads and bids only on the “Purchase” conversion. Going live needs a separate approval.',
    requestNote: 'Note (for the approver)',
    saveDraft: 'Save draft',
    submitForApproval: 'Send for approval',
    wizardSaved: 'Draft saved',
    wizardSavedLead:
      'The draft was not sent to Google. You can edit it on the campaign page and send it for approval.',
    wizardSubmitted: 'Sent for approval',
    wizardSubmittedLead: 'Once approved, the campaign is created paused in Google Ads.',
    openCampaign: 'Open campaign',
    rejectedTitle: 'Products that could not be added',
    reasons: {
      product_not_active: 'The product is not published.',
      product_not_found: 'Product not found.',
      in_other_campaign: 'The product is in another campaign (a product can be in one campaign only).',
      feed_not_listed:
        'The product is not in this store’s Google feed (is it published in the store and open to retail?).',
      feed_excluded_by_user: 'The product is excluded from the Google feed.',
      feed_health_not_approved: 'Health content is awaiting vet approval.',
      feed_health_claim:
        'The text contains a disease/treatment claim (Google health policy and regulations).',
      feed_image_missing: 'No image.',
      feed_image_too_small: 'The image is below Google’s minimum size.',
      feed_image_too_large: 'The image is too large.',
      feed_price_missing: 'No price.',
      feed_price_not_tax_inclusive: 'The price does not include VAT.',
      feed_no_variants: 'No active variants.',
      feed_country_blocked: 'The product cannot be sold in this country.',
      feed_translation_missing: 'No translation in the market’s language.',
      feed_tax_rate_missing: 'No VAT rate is set.',
      out_of_stock: 'Out of stock: Google does not show out-of-stock products.',
    },
    productStates: {
      queued: 'Queued',
      sent: 'Sent to Google — processing',
      eligible: 'Eligible',
      limited: 'Limited',
      not_eligible: 'Not eligible',
    },
    googleId: 'Google ID {{id}}',
    labelValue: 'Product label {{label}}',
    primaryStatus: 'Status in Google: {{status}}',
    primaryStatuses: {
      ELIGIBLE: 'Eligible',
      PAUSED: 'Paused',
      REMOVED: 'Removed',
      ENDED: 'Ended',
      PENDING: 'Pending start',
      MISCONFIGURED: 'Misconfigured',
      LIMITED: 'Limited',
      LEARNING: 'Learning',
      NOT_ELIGIBLE: 'Not eligible',
    },
    readAt: 'read {{at}}',
    driftTitle: 'Changed in Google Ads',
    driftLead:
      'The values in Google Ads differ from the system. The system does not overwrite Google’s values on its own: accept Google’s values or open a new request.',
    driftFields: {
      ad_text: 'Ad text (first headline)',
      keywords: 'Number of keywords',
      negatives: 'Number of negative keywords',
      status: 'Status',
      name: 'Name',
      budget: 'Daily budget (micros)',
      bidding: 'Bid strategy',
      target_roas: 'Target ROAS (%)',
      target_cpa: 'Target CPA (micros)',
      end_date: 'End date',
    },
    driftValues: '{{expected}} in the system, {{google}} in Google',
    acceptGoogle: 'Accept Google’s values',
    driftAccepted: 'The system record now matches Google Ads.',
    goal: 'Conversion goal',
    goalApplied: 'Purchases only',
    goalPending: 'Being applied',
    accounts: 'Google Ads / Merchant',
    actions: 'Campaign actions',
    ops: {
      adTextText: 'First headline: {{headline}}',
      keywordsText: '{{add}} to add, {{remove}} to remove',
      actions: {
        ad_text: 'Ad text',
        keywords: 'Keywords',
        negatives: 'Negative keywords',
        create: 'Send for approval (create)',
        enable: 'Set live',
        pause: 'Pause',
        budget: 'Change budget',
        bidding: 'Bid strategy',
        targeting: 'Locations, languages and dates',
        rename: 'Rename',
        remove: 'Remove',
        apply_recommendation: 'Google recommendation',
        conversion_goal: 'Conversion goal',
      },
      kinds: {
        ad_text: 'Ad text',
        keywords: 'Keywords',
        negatives: 'Negative keywords',
        create: 'Creation',
        enable: 'Going live',
        pause: 'Pause',
        budget: 'Budget',
        bidding: 'Bidding',
        targeting: 'Targeting',
        rename: 'Name',
        remove: 'Removal',
        apply_recommendation: 'Google recommendation',
        conversion_goal: 'Purchase goal',
      },
      budgetText: 'Daily budget {{from}} → {{to}}',
      biddingText: '{{bidding}} ({{target}})',
      targetingText: '{{countries}} · {{languages}} · {{start}} — {{end}}',
      renameText: 'New name: {{name}}',
      recommendationText: 'Recommendation: {{type}}',
    },
    opStatuses: {
      pending_approval: 'Awaiting approval',
      queued: 'Queued',
      applying: 'Applying',
      applied: 'Applied',
      failed: 'Failed',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
    },
    origins: {
      user: 'User',
      system: 'System',
      emergency: 'Emergency stop',
      auto_stop: 'Automatic stop (cap)',
    },
    deleteDraft: 'Delete draft',
    deleteDraftConfirm: 'The draft will be deleted. Nothing changes in Google Ads because it was never sent.',
    draftDeleted: 'Draft deleted.',
    openNote: 'A change is pending; no new change can be requested except pausing.',
    productsTitle: 'Products',
    productsLead:
      'Products go to Merchant Center with the campaign label (custom_label_0) and margin band (custom_label_1); once Google processes them, each product’s status in the campaign is shown.',
    addProducts: 'Add products',
    addProductsLead: 'Only products that enter the Google feed and are not in another campaign are added.',
    addSelected: 'Add {{count}} products',
    noProducts: 'The campaign has no products.',
    removeProduct: 'Remove',
    productRemoved: 'Product removed from the campaign.',
    productsAdded: '{{count}} products added.',
    productsRemoved: '{{count}} products removed.',
    operationsTitle: 'Changes',
    noOperations: 'No changes yet.',
    operation: 'Change',
    who: 'Requested by → decided by',
    when: 'Time',
    cancel: 'Cancel',
    cancelled: 'Change cancelled.',
    nextAttempt: 'Next attempt: {{at}}',
    recommendationsTitle: 'Google recommendations',
    recommendationsLead: 'Read from Google on request. Applying a recommendation always needs approval.',
    loadRecommendations: 'Load recommendations',
    noRecommendations: 'Google has no recommendations for this campaign.',
    recommendationTypes: {
      CAMPAIGN_BUDGET: 'Budget recommendation',
      TARGET_ROAS_OPT_IN: 'Target ROAS recommendation',
      MAXIMIZE_CONVERSION_VALUE_OPT_IN: 'Conversion value bidding recommendation',
    },
    recommendedBudget: 'Recommended daily budget {{daily}} (monthly maximum {{monthly}})',
    requestRecommendation: 'Request to apply',
    recommendationRequested: 'Recommendation sent for approval.',
    historyTitle: 'Google Ads change history',
    historyLead: 'Last 14 days; read from Google on request and not stored.',
    loadHistory: 'Load history',
    noHistory: 'No changes in this period.',
    historyBy: 'Source: {{client}} · {{user}}',
    historyNote: 'Read at: {{at}}',
    noApprovalLead:
      'This change needs no approval; once you tick the checkbox it is queued and applied to Google.',
    approvalLead: 'This change can increase spend: it is not sent to Google until approved.',
    applyNow: 'Apply to Google Ads',
    sendForApproval: 'Send for approval',
    queued: 'Change queued.',
    sentForApproval: 'Sent for approval.',
    enableLead:
      'Spending starts when the campaign goes live: {{daily}} per day, at most {{monthly}} per month.',
    confirmApply: 'I confirm applying this change to Google Ads.',
    productBox: 'Google ads',
    productBoxTitle: 'Google ads',
    inCampaign: 'Campaign:',
    notInCampaign: 'This product is not in any Google Ads campaign.',
    checkedAt: 'Read from Google: {{at}}',
    labelsNote:
      'For this product, custom_label_0 = {{label}} and custom_label_1 = margin band are sent to Merchant (replacing the product’s own 1st and 2nd labels).',
    removeFromCampaign: 'Remove from campaign',
    notEligible: 'This product cannot be added to a campaign right now:',
    chooseCampaign: 'Campaign',
    chooseCampaignPlaceholder: 'Choose a campaign',
    addToCampaign: 'Add to campaign',
    productAdded: 'Product added to the campaign.',
    productNotAdded: 'The product could not be added; see the reasons below.',
    noCampaignsYet: 'No campaigns yet. Create one under Marketing → Google Ads campaigns.',
    bulkCampaign: 'Google Ads campaign',
    bulkAdd: 'Add {{count}} selected products',
    bulkRemove: 'Remove selected from campaign',
    filterLabel: 'Google ads',
    filterAny: 'In a campaign',
    filterNone: 'Not in a campaign',
    filterNotEligible: 'Not eligible according to Google',
  },
};
